/*! Common */
if("undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.bind=function(a,b){return function(){return a.apply(b,arguments)}},Shopify.setSelectorByValue=function(a,b){for(var c=0,d=a.options.length;d>c;c++){var e=a.options[c];if(b==e.value||b==e.innerHTML)return a.selectedIndex=c,c}},Shopify.addListener=function(a,b,c){a.addEventListener?a.addEventListener(b,c,!1):a.attachEvent("on"+b,c)},Shopify.postLink=function(a,b){b=b||{};var c=b.method||"post",d=b.parameters||{},e=document.createElement("form");e.setAttribute("method",c),e.setAttribute("action",a);for(var f in d){var g=document.createElement("input");g.setAttribute("type","hidden"),g.setAttribute("name",f),g.setAttribute("value",d[f]),e.appendChild(g)}document.body.appendChild(e),e.submit(),document.body.removeChild(e)},Shopify.CountryProvinceSelector=function(a,b,c){this.countryEl=document.getElementById(a),this.provinceEl=document.getElementById(b),this.provinceContainer=document.getElementById(c.hideElement||b),Shopify.addListener(this.countryEl,"change",Shopify.bind(this.countryHandler,this)),this.initCountry(),this.initProvince()},Shopify.CountryProvinceSelector.prototype={initCountry:function(){var a=this.countryEl.getAttribute("data-default");Shopify.setSelectorByValue(this.countryEl,a),this.countryHandler()},initProvince:function(){var a=this.provinceEl.getAttribute("data-default");a&&this.provinceEl.options.length>0&&Shopify.setSelectorByValue(this.provinceEl,a)},countryHandler:function(a){var b=this.countryEl.options[this.countryEl.selectedIndex],c=b.getAttribute("data-provinces"),d=JSON.parse(c);if(this.clearOptions(this.provinceEl),d&&0==d.length)this.provinceContainer.style.display="none";else{for(var e=0;e<d.length;e++){var b=document.createElement("option");b.value=d[e][0],b.innerHTML=d[e][1],this.provinceEl.appendChild(b)}this.provinceContainer.style.display=""}},clearOptions:function(a){for(;a.firstChild;)a.removeChild(a.firstChild)},setOptions:function(a,b){var c=0;for(b.length;c<b.length;c++){var d=document.createElement("option");d.value=b[c],d.innerHTML=b[c],a.appendChild(d)}}},Shopify.CustomerAddress={toggleForm:function(a){var b=document.getElementById("view_addresses"),c=document.getElementById("edit_address_"+a);return b.style.display="none"==b.style.display?"":"none",c.style.display="none"==c.style.display?"":"none",!1},toggleNewForm:function(){var a=document.getElementById("add_address"),b=document.getElementById("address_tables");return a.style.display="none"==a.style.display?"":"none",b.style.display="none"==a.style.display?"":"none",!1},destroy:function(a,b){confirm(b||"Are you sure you wish to delete this address?")&&Shopify.postLink("/account/addresses/"+a,{parameters:{_method:"delete"}})}},Shopify.queryParams={},location.search.length)for(var aKeyValue,i=0,aCouples=location.search.substr(1).split("&");i<aCouples.length;i++)aKeyValue=aCouples[i].split("="),aKeyValue.length>1&&(Shopify.queryParams[decodeURIComponent(aKeyValue[0])]=decodeURIComponent(aKeyValue[1]));
/*! Bootstrap  */
!function(r){"use strict";r.fn.emulateTransitionEnd=function(n){var t=!1,i=this;r(this).one("bsTransitionEnd",function(){t=!0});return setTimeout(function(){t||r(i).trigger(r.support.transition.end)},n),this},r(function(){r.support.transition=function(){var n=document.createElement("bootstrap"),t={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var i in t)if(void 0!==n.style[i])return{end:t[i]};return!1}(),r.support.transition&&(r.event.special.bsTransitionEnd={bindType:r.support.transition.end,delegateType:r.support.transition.end,handle:function(n){if(r(n.target).is(this))return n.handleObj.handler.apply(this,arguments)}})})}(jQuery);
/*! Others */
(function(){function e(){}function t(e,t){for(var n=e.length;n--;)if(e[n].listener===t)return n;return-1}function n(e){return function(){return this[e].apply(this,arguments)}}var i=e.prototype,r=this,o=r.EventEmitter;i.getListeners=function(e){var t,n,i=this._getEvents();if("object"==typeof e){t={};for(n in i)i.hasOwnProperty(n)&&e.test(n)&&(t[n]=i[n])}else t=i[e]||(i[e]=[]);return t},i.flattenListeners=function(e){var t,n=[];for(t=0;e.length>t;t+=1)n.push(e[t].listener);return n},i.getListenersAsObject=function(e){var t,n=this.getListeners(e);return n instanceof Array&&(t={},t[e]=n),t||n},i.addListener=function(e,n){var i,r=this.getListenersAsObject(e),o="object"==typeof n;for(i in r)r.hasOwnProperty(i)&&-1===t(r[i],n)&&r[i].push(o?n:{listener:n,once:!1});return this},i.on=n("addListener"),i.addOnceListener=function(e,t){return this.addListener(e,{listener:t,once:!0})},i.once=n("addOnceListener"),i.defineEvent=function(e){return this.getListeners(e),this},i.defineEvents=function(e){for(var t=0;e.length>t;t+=1)this.defineEvent(e[t]);return this},i.removeListener=function(e,n){var i,r,o=this.getListenersAsObject(e);for(r in o)o.hasOwnProperty(r)&&(i=t(o[r],n),-1!==i&&o[r].splice(i,1));return this},i.off=n("removeListener"),i.addListeners=function(e,t){return this.manipulateListeners(!1,e,t)},i.removeListeners=function(e,t){return this.manipulateListeners(!0,e,t)},i.manipulateListeners=function(e,t,n){var i,r,o=e?this.removeListener:this.addListener,s=e?this.removeListeners:this.addListeners;if("object"!=typeof t||t instanceof RegExp)for(i=n.length;i--;)o.call(this,t,n[i]);else for(i in t)t.hasOwnProperty(i)&&(r=t[i])&&("function"==typeof r?o.call(this,i,r):s.call(this,i,r));return this},i.removeEvent=function(e){var t,n=typeof e,i=this._getEvents();if("string"===n)delete i[e];else if("object"===n)for(t in i)i.hasOwnProperty(t)&&e.test(t)&&delete i[t];else delete this._events;return this},i.removeAllListeners=n("removeEvent"),i.emitEvent=function(e,t){var n,i,r,o,s=this.getListenersAsObject(e);for(r in s)if(s.hasOwnProperty(r))for(i=s[r].length;i--;)n=s[r][i],n.once===!0&&this.removeListener(e,n.listener),o=n.listener.apply(this,t||[]),o===this._getOnceReturnValue()&&this.removeListener(e,n.listener);return this},i.trigger=n("emitEvent"),i.emit=function(e){var t=Array.prototype.slice.call(arguments,1);return this.emitEvent(e,t)},i.setOnceReturnValue=function(e){return this._onceReturnValue=e,this},i._getOnceReturnValue=function(){return this.hasOwnProperty("_onceReturnValue")?this._onceReturnValue:!0},i._getEvents=function(){return this._events||(this._events={})},e.noConflict=function(){return r.EventEmitter=o,e},"function"==typeof define&&define.amd?define("eventEmitter/EventEmitter",[],function(){return e}):"object"==typeof module&&module.exports?module.exports=e:this.EventEmitter=e}).call(this),function(e){function t(t){var n=e.event;return n.target=n.target||n.srcElement||t,n}var n=document.documentElement,i=function(){};n.addEventListener?i=function(e,t,n){e.addEventListener(t,n,!1)}:n.attachEvent&&(i=function(e,n,i){e[n+i]=i.handleEvent?function(){var n=t(e);i.handleEvent.call(i,n)}:function(){var n=t(e);i.call(e,n)},e.attachEvent("on"+n,e[n+i])});var r=function(){};n.removeEventListener?r=function(e,t,n){e.removeEventListener(t,n,!1)}:n.detachEvent&&(r=function(e,t,n){e.detachEvent("on"+t,e[t+n]);try{delete e[t+n]}catch(i){e[t+n]=void 0}});var o={bind:i,unbind:r};"function"==typeof define&&define.amd?define("eventie/eventie",o):e.eventie=o}(this),function(e,t){"function"==typeof define&&define.amd?define(["eventEmitter/EventEmitter","eventie/eventie"],function(n,i){return t(e,n,i)}):"object"==typeof exports?module.exports=t(e,require("wolfy87-eventemitter"),require("eventie")):e.imagesLoaded=t(e,e.EventEmitter,e.eventie)}(window,function(e,t,n){function i(e,t){for(var n in t)e[n]=t[n];return e}function r(e){return"[object Array]"===d.call(e)}function o(e){var t=[];if(r(e))t=e;else if("number"==typeof e.length)for(var n=0,i=e.length;i>n;n++)t.push(e[n]);else t.push(e);return t}function s(e,t,n){if(!(this instanceof s))return new s(e,t);"string"==typeof e&&(e=document.querySelectorAll(e)),this.elements=o(e),this.options=i({},this.options),"function"==typeof t?n=t:i(this.options,t),n&&this.on("always",n),this.getImages(),a&&(this.jqDeferred=new a.Deferred);var r=this;setTimeout(function(){r.check()})}function f(e){this.img=e}function c(e){this.src=e,v[e]=this}var a=e.jQuery,u=e.console,h=u!==void 0,d=Object.prototype.toString;s.prototype=new t,s.prototype.options={},s.prototype.getImages=function(){this.images=[];for(var e=0,t=this.elements.length;t>e;e++){var n=this.elements[e];"IMG"===n.nodeName&&this.addImage(n);var i=n.nodeType;if(i&&(1===i||9===i||11===i))for(var r=n.querySelectorAll("img"),o=0,s=r.length;s>o;o++){var f=r[o];this.addImage(f)}}},s.prototype.addImage=function(e){var t=new f(e);this.images.push(t)},s.prototype.check=function(){function e(e,r){return t.options.debug&&h&&u.log("confirm",e,r),t.progress(e),n++,n===i&&t.complete(),!0}var t=this,n=0,i=this.images.length;if(this.hasAnyBroken=!1,!i)return this.complete(),void 0;for(var r=0;i>r;r++){var o=this.images[r];o.on("confirm",e),o.check()}},s.prototype.progress=function(e){this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded;var t=this;setTimeout(function(){t.emit("progress",t,e),t.jqDeferred&&t.jqDeferred.notify&&t.jqDeferred.notify(t,e)})},s.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";this.isComplete=!0;var t=this;setTimeout(function(){if(t.emit(e,t),t.emit("always",t),t.jqDeferred){var n=t.hasAnyBroken?"reject":"resolve";t.jqDeferred[n](t)}})},a&&(a.fn.imagesLoaded=function(e,t){var n=new s(this,e,t);return n.jqDeferred.promise(a(this))}),f.prototype=new t,f.prototype.check=function(){var e=v[this.img.src]||new c(this.img.src);if(e.isConfirmed)return this.confirm(e.isLoaded,"cached was confirmed"),void 0;if(this.img.complete&&void 0!==this.img.naturalWidth)return this.confirm(0!==this.img.naturalWidth,"naturalWidth"),void 0;var t=this;e.on("confirm",function(e,n){return t.confirm(e.isLoaded,n),!0}),e.check()},f.prototype.confirm=function(e,t){this.isLoaded=e,this.emit("confirm",this,t)};var v={};return c.prototype=new t,c.prototype.check=function(){if(!this.isChecked){var e=new Image;n.bind(e,"load",this),n.bind(e,"error",this),e.src=this.src,this.isChecked=!0}},c.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},c.prototype.onload=function(e){this.confirm(!0,"onload"),this.unbindProxyEvents(e)},c.prototype.onerror=function(e){this.confirm(!1,"onerror"),this.unbindProxyEvents(e)},c.prototype.confirm=function(e,t){this.isConfirmed=!0,this.isLoaded=e,this.emit("confirm",this,t)},c.prototype.unbindProxyEvents=function(e){n.unbind(e.target,"load",this),n.unbind(e.target,"error",this)},s});
+function(a){"use strict";function c(c){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof c&&c;e||d.data("bs.button",e=new b(this,f)),"toggle"==c?e.toggle():c&&e.setState(c)})}var b=function(c,d){this.$element=a(c),this.options=a.extend({},b.DEFAULTS,d),this.isLoading=!1};b.VERSION="3.3.7",b.DEFAULTS={loadingText:"loading..."},b.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},b.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=c,a.fn.button.Constructor=b,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(b){var d=a(b.target).closest(".btn");c.call(d,"toggle"),a(b.target).is('input[type="radio"], input[type="checkbox"]')||(b.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery);
Array.prototype.indexOf||(Array.prototype.indexOf=function(a){return $.inArray(a,this)}),$.fn.tabs=function(){var a=this;this.each(function(){var b=$(this);$(b.attr("href")).hide(),$(b).click(function(){return $(a).removeClass("selected"),$(a).each(function(a,b){$($(b).attr("href")).hide()}),$(this).addClass("selected"),$($(this).attr("href")).show(),!1})}),$(this).show(),$(this).first().click()};

if (void 0 === Currency) var Currency = {};
Currency.cookie={name:"roarStorage_currency",write:function(t){try{localStorage.setItem(this.name,t)}catch(t){}},read:function(){try{return localStorage.getItem(this.name)}catch(t){return null}},destroy:function(){try{localStorage.setItem(this.name,null)}catch(t){}}},Currency.moneyFormats={USD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} USD"},EUR:{money_format:"&euro;\{\{amount\}\}",money_with_currency_format:"&euro;\{\{amount\}\} EUR"},GBP:{money_format:"&pound;\{\{amount\}\}",money_with_currency_format:"&pound;\{\{amount\}\} GBP"},CAD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} CAD"},ALL:{money_format:"Lek \{\{amount\}\}",money_with_currency_format:"Lek \{\{amount\}\} ALL"},DZD:{money_format:"DA \{\{amount\}\}",money_with_currency_format:"DA \{\{amount\}\} DZD"},AOA:{money_format:"Kz\{\{amount\}\}",money_with_currency_format:"Kz\{\{amount\}\} AOA"},ARS:{money_format:"$\{\{amount_with_comma_separator\}\}",money_with_currency_format:"$\{\{amount_with_comma_separator\}\} ARS"},AMD:{money_format:"\{\{amount\}\} AMD",money_with_currency_format:"\{\{amount\}\} AMD"},AWG:{money_format:"Afl\{\{amount\}\}",money_with_currency_format:"Afl\{\{amount\}\} AWG"},AUD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} AUD"},BBD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} Bds"},AZN:{money_format:"m.\{\{amount\}\}",money_with_currency_format:"m.\{\{amount\}\} AZN"},BDT:{money_format:"Tk \{\{amount\}\}",money_with_currency_format:"Tk \{\{amount\}\} BDT"},BSD:{money_format:"BS$\{\{amount\}\}",money_with_currency_format:"BS$\{\{amount\}\} BSD"},BHD:{money_format:"\{\{amount\}\}0 BD",money_with_currency_format:"\{\{amount\}\}0 BHD"},BYR:{money_format:"Br \{\{amount\}\}",money_with_currency_format:"Br \{\{amount\}\} BYR"},BZD:{money_format:"BZ$\{\{amount\}\}",money_with_currency_format:"BZ$\{\{amount\}\} BZD"},BTN:{money_format:"Nu \{\{amount\}\}",money_with_currency_format:"Nu \{\{amount\}\} BTN"},BAM:{money_format:"KM \{\{amount_with_comma_separator\}\}",money_with_currency_format:"KM \{\{amount_with_comma_separator\}\} BAM"},BRL:{money_format:"R$ \{\{amount_with_comma_separator\}\}",money_with_currency_format:"R$ \{\{amount_with_comma_separator\}\} BRL"},BOB:{money_format:"Bs\{\{amount_with_comma_separator\}\}",money_with_currency_format:"Bs\{\{amount_with_comma_separator\}\} BOB"},BWP:{money_format:"P\{\{amount\}\}",money_with_currency_format:"P\{\{amount\}\} BWP"},BND:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} BND"},BGN:{money_format:"\{\{amount\}\} лв",money_with_currency_format:"\{\{amount\}\} лв BGN"},MMK:{money_format:"K\{\{amount\}\}",money_with_currency_format:"K\{\{amount\}\} MMK"},KHR:{money_format:"KHR\{\{amount\}\}",money_with_currency_format:"KHR\{\{amount\}\}"},KYD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} KYD"},XAF:{money_format:"FCFA\{\{amount\}\}",money_with_currency_format:"FCFA\{\{amount\}\} XAF"},CLP:{money_format:"$\{\{amount_no_decimals\}\}",money_with_currency_format:"$\{\{amount_no_decimals\}\} CLP"},CNY:{money_format:"&#165;\{\{amount\}\}",money_with_currency_format:"&#165;\{\{amount\}\} CNY"},COP:{money_format:"$\{\{amount_with_comma_separator\}\}",money_with_currency_format:"$\{\{amount_with_comma_separator\}\} COP"},CRC:{money_format:"&#8353; \{\{amount_with_comma_separator\}\}",money_with_currency_format:"&#8353; \{\{amount_with_comma_separator\}\} CRC"},HRK:{money_format:"\{\{amount_with_comma_separator\}\} kn",money_with_currency_format:"\{\{amount_with_comma_separator\}\} kn HRK"},CZK:{money_format:"\{\{amount_with_comma_separator\}\} K&#269;",money_with_currency_format:"\{\{amount_with_comma_separator\}\} K&#269;"},DKK:{money_format:"\{\{amount_with_comma_separator\}\}",money_with_currency_format:"kr.\{\{amount_with_comma_separator\}\}"},DOP:{money_format:"RD$ \{\{amount\}\}",money_with_currency_format:"RD$ \{\{amount\}\}"},XCD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"EC$\{\{amount\}\}"},EGP:{money_format:"LE \{\{amount\}\}",money_with_currency_format:"LE \{\{amount\}\} EGP"},ETB:{money_format:"Br\{\{amount\}\}",money_with_currency_format:"Br\{\{amount\}\} ETB"},XPF:{money_format:"\{\{amount_no_decimals_with_comma_separator\}\} XPF",money_with_currency_format:"\{\{amount_no_decimals_with_comma_separator\}\} XPF"},FJD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"FJ$\{\{amount\}\}"},GMD:{money_format:"D \{\{amount\}\}",money_with_currency_format:"D \{\{amount\}\} GMD"},GHS:{money_format:"GH&#8373;\{\{amount\}\}",money_with_currency_format:"GH&#8373;\{\{amount\}\}"},GTQ:{money_format:"Q\{\{amount\}\}",money_with_currency_format:"\{\{amount\}\} GTQ"},GYD:{money_format:"G$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} GYD"},GEL:{money_format:"\{\{amount\}\} GEL",money_with_currency_format:"\{\{amount\}\} GEL"},HNL:{money_format:"L \{\{amount\}\}",money_with_currency_format:"L \{\{amount\}\} HNL"},HKD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"HK$\{\{amount\}\}"},HUF:{money_format:"\{\{amount_no_decimals_with_comma_separator\}\}",money_with_currency_format:"\{\{amount_no_decimals_with_comma_separator\}\} Ft"},ISK:{money_format:"\{\{amount_no_decimals\}\} kr",money_with_currency_format:"\{\{amount_no_decimals\}\} kr ISK"},INR:{money_format:"Rs. \{\{amount\}\}",money_with_currency_format:"Rs. \{\{amount\}\}"},IDR:{money_format:"\{\{amount_with_comma_separator\}\}",money_with_currency_format:"Rp \{\{amount_with_comma_separator\}\}"},ILS:{money_format:"\{\{amount\}\} NIS",money_with_currency_format:"\{\{amount\}\} NIS"},JMD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} JMD"},JPY:{money_format:"&#165;\{\{amount_no_decimals\}\}",money_with_currency_format:"&#165;\{\{amount_no_decimals\}\} JPY"},JEP:{money_format:"&pound;\{\{amount\}\}",money_with_currency_format:"&pound;\{\{amount\}\} JEP"},JOD:{money_format:"\{\{amount\}\}0 JD",money_with_currency_format:"\{\{amount\}\}0 JOD"},KZT:{money_format:"\{\{amount\}\} KZT",money_with_currency_format:"\{\{amount\}\} KZT"},KES:{money_format:"KSh\{\{amount\}\}",money_with_currency_format:"KSh\{\{amount\}\}"},KWD:{money_format:"\{\{amount\}\}0 KD",money_with_currency_format:"\{\{amount\}\}0 KWD"},KGS:{money_format:"лв\{\{amount\}\}",money_with_currency_format:"лв\{\{amount\}\}"},LVL:{money_format:"Ls \{\{amount\}\}",money_with_currency_format:"Ls \{\{amount\}\} LVL"},LBP:{money_format:"L&pound;\{\{amount\}\}",money_with_currency_format:"L&pound;\{\{amount\}\} LBP"},LTL:{money_format:"\{\{amount\}\} Lt",money_with_currency_format:"\{\{amount\}\} Lt"},MGA:{money_format:"Ar \{\{amount\}\}",money_with_currency_format:"Ar \{\{amount\}\} MGA"},MKD:{money_format:"ден \{\{amount\}\}",money_with_currency_format:"ден \{\{amount\}\} MKD"},MOP:{money_format:"MOP$\{\{amount\}\}",money_with_currency_format:"MOP$\{\{amount\}\}"},MVR:{money_format:"Rf\{\{amount\}\}",money_with_currency_format:"Rf\{\{amount\}\} MRf"},MXN:{money_format:"$ \{\{amount\}\}",money_with_currency_format:"$ \{\{amount\}\} MXN"},MYR:{money_format:"RM\{\{amount\}\} MYR",money_with_currency_format:"RM\{\{amount\}\} MYR"},MUR:{money_format:"Rs \{\{amount\}\}",money_with_currency_format:"Rs \{\{amount\}\} MUR"},MDL:{money_format:"\{\{amount\}\} MDL",money_with_currency_format:"\{\{amount\}\} MDL"},MAD:{money_format:"\{\{amount\}\} dh",money_with_currency_format:"Dh \{\{amount\}\} MAD"},MNT:{money_format:"\{\{amount_no_decimals\}\} &#8366",money_with_currency_format:"\{\{amount_no_decimals\}\} MNT"},MZN:{money_format:"\{\{amount\}\} Mt",money_with_currency_format:"Mt \{\{amount\}\} MZN"},NAD:{money_format:"N$\{\{amount\}\}",money_with_currency_format:"N$\{\{amount\}\} NAD"},NPR:{money_format:"Rs\{\{amount\}\}",money_with_currency_format:"Rs\{\{amount\}\} NPR"},ANG:{money_format:"&fnof;\{\{amount\}\}",money_with_currency_format:"\{\{amount\}\} NA&fnof;"},NZD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} NZD"},NIO:{money_format:"C$\{\{amount\}\}",money_with_currency_format:"C$\{\{amount\}\} NIO"},NGN:{money_format:"&#8358;\{\{amount\}\}",money_with_currency_format:"&#8358;\{\{amount\}\} NGN"},NOK:{money_format:"kr \{\{amount_with_comma_separator\}\}",money_with_currency_format:"kr \{\{amount_with_comma_separator\}\} NOK"},OMR:{money_format:"\{\{amount_with_comma_separator\}\} OMR",money_with_currency_format:"\{\{amount_with_comma_separator\}\} OMR"},PKR:{money_format:"Rs.\{\{amount\}\}",money_with_currency_format:"Rs.\{\{amount\}\} PKR"},PGK:{money_format:"K \{\{amount\}\}",money_with_currency_format:"K \{\{amount\}\} PGK"},PYG:{money_format:"Gs. \{\{amount_no_decimals_with_comma_separator\}\}",money_with_currency_format:"Gs. \{\{amount_no_decimals_with_comma_separator\}\} PYG"},PEN:{money_format:"S/. \{\{amount\}\}",money_with_currency_format:"S/. \{\{amount\}\} PEN"},PHP:{money_format:"&#8369;\{\{amount\}\}",money_with_currency_format:"&#8369;\{\{amount\}\} PHP"},PLN:{money_format:"\{\{amount_with_comma_separator\}\} zl",money_with_currency_format:"\{\{amount_with_comma_separator\}\} zl PLN"},QAR:{money_format:"QAR \{\{amount_with_comma_separator\}\}",money_with_currency_format:"QAR \{\{amount_with_comma_separator\}\}"},RON:{money_format:"\{\{amount_with_comma_separator\}\} lei",money_with_currency_format:"\{\{amount_with_comma_separator\}\} lei RON"},RUB:{money_format:"&#1088;&#1091;&#1073;\{\{amount_with_comma_separator\}\}",money_with_currency_format:"&#1088;&#1091;&#1073;\{\{amount_with_comma_separator\}\} RUB"},RWF:{money_format:"\{\{amount_no_decimals\}\} RF",money_with_currency_format:"\{\{amount_no_decimals\}\} RWF"},WST:{money_format:"WS$ \{\{amount\}\}",money_with_currency_format:"WS$ \{\{amount\}\} WST"},SAR:{money_format:"\{\{amount\}\} SR",money_with_currency_format:"\{\{amount\}\} SAR"},STD:{money_format:"Db \{\{amount\}\}",money_with_currency_format:"Db \{\{amount\}\} STD"},RSD:{money_format:"\{\{amount\}\} RSD",money_with_currency_format:"\{\{amount\}\} RSD"},SCR:{money_format:"Rs \{\{amount\}\}",money_with_currency_format:"Rs \{\{amount\}\} SCR"},SGD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} SGD"},SYP:{money_format:"S&pound;\{\{amount\}\}",money_with_currency_format:"S&pound;\{\{amount\}\} SYP"},ZAR:{money_format:"R \{\{amount\}\}",money_with_currency_format:"R \{\{amount\}\} ZAR"},KRW:{money_format:"&#8361;\{\{amount_no_decimals\}\}",money_with_currency_format:"&#8361;\{\{amount_no_decimals\}\} KRW"},LKR:{money_format:"Rs \{\{amount\}\}",money_with_currency_format:"Rs \{\{amount\}\} LKR"},SEK:{money_format:"\{\{amount_no_decimals\}\} kr",money_with_currency_format:"\{\{amount_no_decimals\}\} kr SEK"},CHF:{money_format:"SFr. \{\{amount\}\}",money_with_currency_format:"SFr. \{\{amount\}\} CHF"},TWD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} TWD"},THB:{money_format:"\{\{amount\}\} &#xe3f;",money_with_currency_format:"\{\{amount\}\} &#xe3f; THB"},TZS:{money_format:"\{\{amount\}\} TZS",money_with_currency_format:"\{\{amount\}\} TZS"},TTD:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\} TTD"},TND:{money_format:"\{\{amount\}\}",money_with_currency_format:"\{\{amount\}\} DT"},TRY:{money_format:"\{\{amount\}\}TL",money_with_currency_format:"\{\{amount\}\}TL"},UGX:{money_format:"Ush \{\{amount_no_decimals\}\}",money_with_currency_format:"Ush \{\{amount_no_decimals\}\} UGX"},UAH:{money_format:"₴\{\{amount\}\}",money_with_currency_format:"₴\{\{amount\}\} UAH"},AED:{money_format:"Dhs. \{\{amount\}\}",money_with_currency_format:"Dhs. \{\{amount\}\} AED"},UYU:{money_format:"$\{\{amount_with_comma_separator\}\}",money_with_currency_format:"$\{\{amount_with_comma_separator\}\} UYU"},VUV:{money_format:"$\{\{amount\}\}",money_with_currency_format:"$\{\{amount\}\}VT"},VEF:{money_format:"Bs. \{\{amount_with_comma_separator\}\}",money_with_currency_format:"Bs. \{\{amount_with_comma_separator\}\} VEF"},VND:{money_format:"\{\{amount_no_decimals_with_comma_separator\}\}&#8363;",money_with_currency_format:"\{\{amount_no_decimals_with_comma_separator\}\} VND"},XBT:{money_format:"\{\{amount_no_decimals\}\} BTC",money_with_currency_format:"\{\{amount_no_decimals\}\} BTC"},XOF:{money_format:"CFA\{\{amount\}\}",money_with_currency_format:"CFA\{\{amount\}\} XOF"},ZMW:{money_format:"K\{\{amount_no_decimals_with_comma_separator\}\}",money_with_currency_format:"ZMW\{\{amount_no_decimals_with_comma_separator\}\}"},AFN:{money_format:"&#65;&#102; \{\{amount\}\}",money_with_currency_format:"&#65;&#102; \{\{amount\}\} AFN"},CVE:{money_format:"&#36; \{\{amount\}\}",money_with_currency_format:"&#36; \{\{amount\}\} CVE"},KMF:{money_format:"&#67;&#70; \{\{amount\}\}",money_with_currency_format:"&#67;&#70; \{\{amount\}\} KMF"},CDF:{money_format:"&#70;&#67; \{\{amount\}\}",money_with_currency_format:"&#70;&#67; \{\{amount\}\} CDF"},HTG:{money_format:"&#71; \{\{amount\}\}",money_with_currency_format:"&#71; \{\{amount\}\} HTG"},LAK:{money_format:"&#8365; \{\{amount\}\}",money_with_currency_format:"&#8365; \{\{amount\}\} LAK"},LSL:{money_format:"&#76; \{\{amount\}\}",money_with_currency_format:"&#76; \{\{amount\}\} LSL"},LRD:{money_format:"&#36; \{\{amount\}\}",money_with_currency_format:"&#36; \{\{amount\}\} LRD"},MWK:{money_format:"&#77;&#75; \{\{amount\}\}",money_with_currency_format:"&#77;&#75; \{\{amount\}\} MWK"},SDG:{money_format:"&#163; \{\{amount\}\}",money_with_currency_format:"&#163; \{\{amount\}\} SDG"},SBD:{money_format:"&#36; \{\{amount\}\}",money_with_currency_format:"&#36; \{\{amount\}\} SBD"},SRD:{money_format:"&#36; \{\{amount\}\}",money_with_currency_format:"&#36; \{\{amount\}\} SRD"},SZL:{money_format:"&#76; \{\{amount\}\}",money_with_currency_format:"&#76; \{\{amount\}\} SZL"},TMT:{money_format:"&#109; \{\{amount\}\}",money_with_currency_format:"&#109; \{\{amount\}\} TMT"},UZS:{money_format:"&#1083;&#1074; \{\{amount\}\}",money_with_currency_format:"&#1083;&#1074; \{\{amount\}\} UZS"},YER:{money_format:"&#65020; \{\{amount\}\}",money_with_currency_format:"&#65020; \{\{amount\}\} YER"}},Currency.formatMoney=function(o,m){if("function"==typeof Shopify.formatMoney)return Shopify.formatMoney(o,m);"string"==typeof o&&(o=o.replace(".",""));var t="",n=/\{\{\s*(\w+)\s*\}\}/,a=m||"$\{\{amount\}\}";function r(o,m){return void 0===o?m:o}
function _(o,m,t,n){if(m=r(m,2),t=r(t,","),n=r(n,"."),isNaN(o)||null==o)return 0;var a=(o=(o/100).toFixed(m)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+t)+(a[1]?n+a[1]:"")}
switch(a.match(n)[1]){case "amount":t=_(o,2);break;case "amount_no_decimals":t=_(o,0);break;case "amount_with_comma_separator":t=_(o,2,".",",");break;case "amount_no_decimals_with_comma_separator":t=_(o,0,".",",")}
return a.replace(n,t)},Currency.currentCurrency="",Currency.format="money_with_currency_format",Currency.convertAll=function(o,m,t,n){jQuery(t||"span.money").each(function(){if(jQuery(this).attr("data-currency")!==m){if(jQuery(this).attr("data-currency-"+m))jQuery(this).html(jQuery(this).attr("data-currency-"+m));else{var t=0,a=Currency.moneyFormats[o][n||Currency.format]||"\{\{amount\}\}",r=Currency.moneyFormats[m][n||Currency.format]||"\{\{amount\}\}";t=-1!==a.indexOf("amount_no_decimals")?Currency.convert(100*parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10),o,m):"JOD"===o||"KWD"==o||"BHD"==o?Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10)/10,o,m):Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10),o,m);var _=Currency.formatMoney(t,r);jQuery(this).html(_),jQuery(this).attr("data-currency-"+m,_)}
jQuery(this).attr("data-currency",m)}}),this.currentCurrency=m,this.cookie.write(m)};

/* jQuery Storage API Plugin 1.7.5 https://github.com/julien-maurel/jQuery-Storage-API */
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e("object"==typeof exports?require("jquery"):jQuery)}(function(e){function t(t){var r,i,n,o=arguments.length,s=window[t],a=arguments,u=a[1];if(2>o)throw Error("Minimum 2 arguments must be given");if(e.isArray(u)){i={};for(var f in u){r=u[f];try{i[r]=JSON.parse(s.getItem(r))}catch(c){i[r]=s.getItem(r)}}return i}if(2!=o){try{i=JSON.parse(s.getItem(u))}catch(c){throw new ReferenceError(u+" is not defined in this storage")}for(var f=2;o-1>f;f++)if(i=i[a[f]],void 0===i)throw new ReferenceError([].slice.call(a,1,f+1).join(".")+" is not defined in this storage");if(e.isArray(a[f])){n=i,i={};for(var m in a[f])i[a[f][m]]=n[a[f][m]];return i}return i[a[f]]}try{return JSON.parse(s.getItem(u))}catch(c){return s.getItem(u)}}function r(t){var r,i,n=arguments.length,o=window[t],s=arguments,a=s[1],u=s[2],f={};if(2>n||!e.isPlainObject(a)&&3>n)throw Error("Minimum 3 arguments must be given or second parameter must be an object");if(e.isPlainObject(a)){for(var c in a)r=a[c],e.isPlainObject(r)?o.setItem(c,JSON.stringify(r)):o.setItem(c,r);return a}if(3==n)return"object"==typeof u?o.setItem(a,JSON.stringify(u)):o.setItem(a,u),u;try{i=o.getItem(a),null!=i&&(f=JSON.parse(i))}catch(m){}i=f;for(var c=2;n-2>c;c++)r=s[c],i[r]&&e.isPlainObject(i[r])||(i[r]={}),i=i[r];return i[s[c]]=s[c+1],o.setItem(a,JSON.stringify(f)),f}function i(t){var r,i,n=arguments.length,o=window[t],s=arguments,a=s[1];if(2>n)throw Error("Minimum 2 arguments must be given");if(e.isArray(a)){for(var u in a)o.removeItem(a[u]);return!0}if(2==n)return o.removeItem(a),!0;try{r=i=JSON.parse(o.getItem(a))}catch(f){throw new ReferenceError(a+" is not defined in this storage")}for(var u=2;n-1>u;u++)if(i=i[s[u]],void 0===i)throw new ReferenceError([].slice.call(s,1,u).join(".")+" is not defined in this storage");if(e.isArray(s[u]))for(var c in s[u])delete i[s[u][c]];else delete i[s[u]];return o.setItem(a,JSON.stringify(r)),!0}function n(t,r){var n=a(t);for(var o in n)i(t,n[o]);if(r)for(var o in e.namespaceStorages)u(o)}function o(r){var i=arguments.length,n=arguments,s=(window[r],n[1]);if(1==i)return 0==a(r).length;if(e.isArray(s)){for(var u=0;u<s.length;u++)if(!o(r,s[u]))return!1;return!0}try{var f=t.apply(this,arguments);e.isArray(n[i-1])||(f={totest:f});for(var u in f)if(!(e.isPlainObject(f[u])&&e.isEmptyObject(f[u])||e.isArray(f[u])&&!f[u].length)&&f[u])return!1;return!0}catch(c){return!0}}function s(r){var i=arguments.length,n=arguments,o=(window[r],n[1]);if(2>i)throw Error("Minimum 2 arguments must be given");if(e.isArray(o)){for(var a=0;a<o.length;a++)if(!s(r,o[a]))return!1;return!0}try{var u=t.apply(this,arguments);e.isArray(n[i-1])||(u={totest:u});for(var a in u)if(void 0===u[a]||null===u[a])return!1;return!0}catch(f){return!1}}function a(r){var i=arguments.length,n=window[r],o=arguments,s=(o[1],[]),a={};if(a=i>1?t.apply(this,o):n,a._cookie)for(var u in e.cookie())""!=u&&s.push(u.replace(a._prefix,""));else for(var f in a)s.push(f);return s}function u(t){if(!t||"string"!=typeof t)throw Error("First parameter must be a string");g?(window.localStorage.getItem(t)||window.localStorage.setItem(t,"{}"),window.sessionStorage.getItem(t)||window.sessionStorage.setItem(t,"{}")):(window.localCookieStorage.getItem(t)||window.localCookieStorage.setItem(t,"{}"),window.sessionCookieStorage.getItem(t)||window.sessionCookieStorage.setItem(t,"{}"));var r={localStorage:e.extend({},e.localStorage,{_ns:t}),sessionStorage:e.extend({},e.sessionStorage,{_ns:t})};return e.cookie&&(window.cookieStorage.getItem(t)||window.cookieStorage.setItem(t,"{}"),r.cookieStorage=e.extend({},e.cookieStorage,{_ns:t})),e.namespaceStorages[t]=r,r}function f(e){var t="jsapi";try{return window[e]?(window[e].setItem(t,t),window[e].removeItem(t),!0):!1}catch(r){return!1}}var c="ls_",m="ss_",g=f("localStorage"),l={_type:"",_ns:"",_callMethod:function(e,t){var r=[this._type],t=Array.prototype.slice.call(t),i=t[0];return this._ns&&r.push(this._ns),"string"==typeof i&&-1!==i.indexOf(".")&&(t.shift(),[].unshift.apply(t,i.split("."))),[].push.apply(r,t),e.apply(this,r)},get:function(){return this._callMethod(t,arguments)},set:function(){var t=arguments.length,i=arguments,n=i[0];if(1>t||!e.isPlainObject(n)&&2>t)throw Error("Minimum 2 arguments must be given or first parameter must be an object");if(e.isPlainObject(n)&&this._ns){for(var o in n)r(this._type,this._ns,o,n[o]);return n}var s=this._callMethod(r,i);return this._ns?s[n.split(".")[0]]:s},remove:function(){if(arguments.length<1)throw Error("Minimum 1 argument must be given");return this._callMethod(i,arguments)},removeAll:function(e){return this._ns?(r(this._type,this._ns,{}),!0):n(this._type,e)},isEmpty:function(){return this._callMethod(o,arguments)},isSet:function(){if(arguments.length<1)throw Error("Minimum 1 argument must be given");return this._callMethod(s,arguments)},keys:function(){return this._callMethod(a,arguments)}};if(e.cookie){window.name||(window.name=Math.floor(1e8*Math.random()));var h={_cookie:!0,_prefix:"",_expires:null,_path:null,_domain:null,setItem:function(t,r){e.cookie(this._prefix+t,r,{expires:this._expires,path:this._path,domain:this._domain})},getItem:function(t){return e.cookie(this._prefix+t)},removeItem:function(t){return e.removeCookie(this._prefix+t)},clear:function(){for(var t in e.cookie())""!=t&&(!this._prefix&&-1===t.indexOf(c)&&-1===t.indexOf(m)||this._prefix&&0===t.indexOf(this._prefix))&&e.removeCookie(t)},setExpires:function(e){return this._expires=e,this},setPath:function(e){return this._path=e,this},setDomain:function(e){return this._domain=e,this},setConf:function(e){return e.path&&(this._path=e.path),e.domain&&(this._domain=e.domain),e.expires&&(this._expires=e.expires),this},setDefaultConf:function(){this._path=this._domain=this._expires=null}};g||(window.localCookieStorage=e.extend({},h,{_prefix:c,_expires:3650}),window.sessionCookieStorage=e.extend({},h,{_prefix:m+window.name+"_"})),window.cookieStorage=e.extend({},h),e.cookieStorage=e.extend({},l,{_type:"cookieStorage",setExpires:function(e){return window.cookieStorage.setExpires(e),this},setPath:function(e){return window.cookieStorage.setPath(e),this},setDomain:function(e){return window.cookieStorage.setDomain(e),this},setConf:function(e){return window.cookieStorage.setConf(e),this},setDefaultConf:function(){return window.cookieStorage.setDefaultConf(),this}})}e.initNamespaceStorage=function(e){return u(e)},g?(e.localStorage=e.extend({},l,{_type:"localStorage"}),e.sessionStorage=e.extend({},l,{_type:"sessionStorage"})):(e.localStorage=e.extend({},l,{_type:"localCookieStorage"}),e.sessionStorage=e.extend({},l,{_type:"sessionCookieStorage"})),e.namespaceStorages={},e.removeAllStorages=function(t){e.localStorage.removeAll(t),e.sessionStorage.removeAll(t),e.cookieStorage&&e.cookieStorage.removeAll(t),t||(e.namespaceStorages={})}});
/*! [be]Lazy.js - v1.8.2 - 2016.10.25 (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy */
(function(q,m){"function"===typeof define&&define.amd?define(m):"object"===typeof exports?module.exports=m():q.Blazy=m()})(this,function(){function q(b){var c=b._util;c.elements=E(b.options);c.count=c.elements.length;c.destroyed&&(c.destroyed=!1,b.options.container&&l(b.options.container,function(a){n(a,"scroll",c.validateT)}),n(window,"resize",c.saveViewportOffsetT),n(window,"resize",c.validateT),n(window,"scroll",c.validateT));m(b)}function m(b){for(var c=b._util,a=0;a<c.count;a++){var d=c.elements[a],e;a:{var g=d;e=b.options;var p=g.getBoundingClientRect();if(e.container&&y&&(g=g.closest(e.containerClass))){g=g.getBoundingClientRect();e=r(g,f)?r(p,{top:g.top-e.offset,right:g.right+e.offset,bottom:g.bottom+e.offset,left:g.left-e.offset}):!1;break a}e=r(p,f)}if(e||t(d,b.options.successClass))b.load(d),c.elements.splice(a,1),c.count--,a--}0===c.count&&b.destroy()}function r(b,c){return b.right>=c.left&&b.bottom>=c.top&&b.left<=c.right&&b.top<=c.bottom}function z(b,c,a){if(!t(b,a.successClass)&&(c||a.loadInvisible||0<b.offsetWidth&&0<b.offsetHeight))if(c=b.getAttribute(u)||b.getAttribute(a.src)){c=c.split(a.separator);var d=c[A&&1<c.length?1:0],e=b.getAttribute(a.srcset),g="img"===b.nodeName.toLowerCase(),p=(c=b.parentNode)&&"picture"===c.nodeName.toLowerCase();if(g||void 0===b.src){var h=new Image,w=function(){a.error&&a.error(b,"invalid");v(b,a.errorClass);k(h,"error",w);k(h,"load",f)},f=function(){g?p||B(b,d,e):b.style.backgroundImage='url("'+d+'")';x(b,a);k(h,"load",f);k(h,"error",w)};p&&(h=b,l(c.getElementsByTagName("source"),function(b){var c=a.srcset,e=b.getAttribute(c);e&&(b.setAttribute("srcset",e),b.removeAttribute(c))}));n(h,"error",w);n(h,"load",f);B(h,d,e)}else b.src=d,x(b,a)}else"video"===b.nodeName.toLowerCase()?(l(b.getElementsByTagName("source"),function(b){var c=a.src,e=b.getAttribute(c);e&&(b.setAttribute("src",e),b.removeAttribute(c))}),b.load(),x(b,a)):(a.error&&a.error(b,"missing"),v(b,a.errorClass))}function x(b,c){v(b,c.successClass);c.success&&c.success(b);b.removeAttribute(c.src);b.removeAttribute(c.srcset);l(c.breakpoints,function(a){b.removeAttribute(a.src)})}function B(b,c,a){a&&b.setAttribute("srcset",a);b.src=c}function t(b,c){return-1!==(" "+b.className+" ").indexOf(" "+c+" ")}function v(b,c){t(b,c)||(b.className+=" "+c)}function E(b){var c=[];b=b.root.querySelectorAll(b.selector);for(var a=b.length;a--;c.unshift(b[a]));return c}function C(b){f.bottom=(window.innerHeight||document.documentElement.clientHeight)+b;f.right=(window.innerWidth||document.documentElement.clientWidth)+b}function n(b,c,a){b.attachEvent?b.attachEvent&&b.attachEvent("on"+c,a):b.addEventListener(c,a,{capture:!1,passive:!0})}function k(b,c,a){b.detachEvent?b.detachEvent&&b.detachEvent("on"+c,a):b.removeEventListener(c,a,{capture:!1,passive:!0})}function l(b,c){if(b&&c)for(var a=b.length,d=0;d<a&&!1!==c(b[d],d);d++);}function D(b,c,a){var d=0;return function(){var e=+new Date;e-d<c||(d=e,b.apply(a,arguments))}}var u,f,A,y;return function(b){if(!document.querySelectorAll){var c=document.createStyleSheet();document.querySelectorAll=function(a,b,d,h,f){f=document.all;b=[];a=a.replace(/\[for\b/gi,"[htmlFor").split(",");for(d=a.length;d--;){c.addRule(a[d],"k:v");for(h=f.length;h--;)f[h].currentStyle.k&&b.push(f[h]);c.removeRule(0)}return b}}var a=this,d=a._util={};d.elements=[];d.destroyed=!0;a.options=b||{};a.options.error=a.options.error||!1;a.options.offset=a.options.offset||100;a.options.root=a.options.root||document;a.options.success=a.options.success||!1;a.options.selector=a.options.selector||".b-lazy";a.options.separator=a.options.separator||"|";a.options.containerClass=a.options.container;a.options.container=a.options.containerClass?document.querySelectorAll(a.options.containerClass):!1;a.options.errorClass=a.options.errorClass||"b-error";a.options.breakpoints=a.options.breakpoints||!1;a.options.loadInvisible=a.options.loadInvisible||!1;a.options.successClass=a.options.successClass||"b-loaded";a.options.validateDelay=a.options.validateDelay||25;a.options.saveViewportOffsetDelay=a.options.saveViewportOffsetDelay||50;a.options.srcset=a.options.srcset||"data-srcset";a.options.src=u=a.options.src||"data-src";y=Element.prototype.closest;A=1<window.devicePixelRatio;f={};f.top=0-a.options.offset;f.left=0-a.options.offset;a.revalidate=function(){q(a)};a.load=function(a,b){var c=this.options;void 0===a.length?z(a,b,c):l(a,function(a){z(a,b,c)})};a.destroy=function(){var a=this._util;this.options.container&&l(this.options.container,function(b){k(b,"scroll",a.validateT)});k(window,"scroll",a.validateT);k(window,"resize",a.validateT);k(window,"resize",a.saveViewportOffsetT);a.count=0;a.elements.length=0;a.destroyed=!0};d.validateT=D(function(){m(a)},a.options.validateDelay,a);d.saveViewportOffsetT=D(function(){C(a.options.offset)},a.options.saveViewportOffsetDelay,a);C(a.options.offset);l(a.options.breakpoints,function(a){if(a.width>=window.screen.width)return u=a.src,!1});setTimeout(function(){q(a)})}});

/* global Shopify, theme */

let badges = $('#product-badges').html();
badges = JSON.parse(badges);
window.updatingCart = false;
window.queueUpdatesDrawer = [];
window.timing = '';
window.cartData = {};
window.firstLoad = true;
window.freeOnCart = [];
window.removalOnCart = [];
window.updateOnCart = [];
window.checkingDrawer = '';
window.processingCart = '';
window.storeSite = window.location.hostname;

window.waitFor = (condition, cb, count = 0) => {
	// only try for 10s
	if (typeof condition === 'function' && typeof cb === 'function' && count < 50) {
		setTimeout(() => {
			if (condition()) {
				cb();
			} else {
				waitFor(condition, cb, count + 1);
			}
		}, 200);
	}
};

window.isABTest = (store, testID) => new Promise((resolve) => {
	if (window.storeSite === store) {
		window.waitFor(() => window.google_optimize && window.google_optimize.get, () => {
			const testValue = window.google_optimize.get(testID);
			if (!testValue) {
				console.log(`AB Test ${store} ${testID}: false`);
				resolve({ test: false });
			} else {
				console.log(`AB Test ${store} ${testID}: variant ${testValue}`);
				resolve({ test: true, value: `${testValue}` });
			}
		});
	} else {
		console.log(`AB Test ${store} ${testID}: false`);
		resolve({ test: false });
	}
});

if (window.storeSite === 'us.skinnymint.com') {
	window.isABTest('us.skinnymint.com', 'UUpfaB8vRNekLMKun_Bghg').then(({ test, value }) => {
		$(document).on('click', '#cart_block', function(){
			if (test && value === '1') {
				hj('trigger', 'cart_upsell_redesign_carousel');
				console.log('variant abtest');
			} else {
				hj('trigger', 'cart_upsell_redesign_original');
				console.log('original abtest');
			}
		});
	});
}

window.allProducts = null;
window.getAllProducts = (cb = () => {}) => {
	if (typeof cb === 'function') {
		if (window.allProducts !== null) {
			cb(window.allProducts);
		} else {
			setTimeout(() => {
				window.getAllProducts(cb);
			}, 500);
		}
	}
};
$.ajax({
	url: '/collections/all-items?view=json',
	success(resp) {
		window.allProducts = JSON.parse(resp);
	},
	error() {
		window.allProducts = {};
	},
});

window.upsellProducts = null;
if (window.smUpsell.enabled) {
	$.ajax({
		url: '/collections/upsell-products?view=json',
		success(resp) {
			window.upsellProducts = JSON.parse(resp);
		},
		error() {
			window.upsellProducts = {};
		},
	});
}

const RoarCookie = {
	cookie: {
		rtread(b) {
			try {
				return localStorage.getItem(b);
			} catch (t) {
				return null;
			}
		},
		rtwrite(b, c) {
			try {
				return localStorage.setItem(b, c);
			} catch (e) {
				return null;
			}
		},
		destroy(t) {
			try {
				return localStorage.setItem(t, null);
			} catch (e) {
				return null;
			}
		},
	},
};
const roar = {
	init() {
		this.setCurrencyFormat();
		this.handleCustom();
		this.handleAccount();
		this.handleAddress();
		this.initCountdown();
		this.addToWishlist();
		this.handleCompare();
		this.removeToWishlist();
		this.handleGMap();
		this.handleSmoothScroll();
		this.mapFilters();
		this.handleCookie();
		this.handleDropdown();
		this.handleHeaderNotice();
		this.handleBoldProductCampaign();
		this.setBadge(false);
	},
	setCurrencyFormat() {
		$('.money').each(function (el, i) {
			const parents = $(i).parents('.price-save');
			if (!parents.length) {
				const c = $(i).text();
				const numberPattern = /\d+/g;
				const b = c.match(numberPattern);
				if (b) {
					const d = b.join(Shopify.currency.active === 'EUR' ? ',' : '.');
					const formatted = theme.settings.moneyFormat.replace('\{\{amount\}\}', d);
					$(i).text(formatted);
				}
			}
		});
	},
	handleBoldProductCampaign() {
		$('.cart-window-body .cart-item.discounted, .cart-window-body .cart-item.discount-upsell').each(function (i, el) {
			try {
				const anchor = $(el).find('.thumbnail a');
				let href = $(anchor).attr('href');
				if (typeof href !== 'undefined') {
					href = href.split('?')[0].split('/');
					href = href[href.length - 1].split('-');
					href.pop();
					const newHandle = href.join('-');
					const newHref = `/products/${newHandle}`;
					$(anchor).attr('href', newHref);
				}
			} catch (e) {
				console.log(e);
			}
		});
	},
	setBadge(variant_only) {
		$.each(badges, function (index, prd) {
			if (prd.show) {
				if (!variant_only) {
					$(`div[data-badge='${prd.productId}'],figure[data-badge='${prd.productId}']`).each(function (i, el) {
						if ($(el).find('.block-badge').length === 0) {
							$(el).prepend(
								`<div class='block-badge'><img data-src='${prd.badge_image}' class='lazyload'></img></div>`,
							);
						}
					});

					if ($('.templateCollection').length && prd.collection_badge_image) {
						const mainCol = $('.custom-collection-wrapper');
						const id = prd.productId;
						mainCol.find(`[data-badge='${id}'] .block-badge`).remove();
						if (window.location.href.indexOf('we-are-6') === -1) {
							const htm = `<div class='block-badge badge-collection'><img data-src='${prd.collection_badge_image}' class='lazyload'></img></div>`;
							mainCol.find(`[data-badge='${id}']`).append(htm);
						}
					}

					if ($('.product-spotlight').length && prd.collection_badge_image) {
						const mainCol = $('.product-spotlight');
						const id = prd.productId;
						const badge = mainCol.find(`[data-badge='${id}'] .block-badge`);
						if (!badge.hasClass('badge-spotlight')) {
							badge.remove();
							if (window.location.href.indexOf('we-are-6') === -1) {
								const htm = `<div class='block-badge badge-collection'><img data-src='${prd.collection_badge_image}' class='lazyload'></img></div>`;
								mainCol.find(`[data-badge='${id}']`).append(htm);
							}
						}
					}

					if ($('.templateProduct').length && prd.pdp_badge_image) {
						const pcontent = $(`.product-page-section .rt-fastor-product-gallery [data-badge='${prd.productId}']`);
						if (pcontent) {
							pcontent.find('.block-badge').remove();
							const htm = `<div class='block-badge badge-main-pdp'><img data-src='${prd.pdp_badge_image}' class='lazyload'></img></div>`;
							pcontent.prepend(htm);
						}
					}

					if ($('.templateProduct').length && prd.pdp_badge_topleft) {
						const pcontent = $(`.product-page-section .rt-fastor-product-gallery [data-badge='${prd.productId}']`);
						if (pcontent) {
							pcontent.find('.block-badge-top-left').remove();
							const htm = `<div class='block-badge-top-left badge-main-pdp ab-variant'><img data-src='${prd.pdp_badge_topleft}' class='lazyload'></img></div>`;
							pcontent.prepend(htm);
						}
					}
				}

				const variants = prd.variant_ids.split(',');
				$.each(variants, function (i, vrt) {
					$(`div[data-badge-variant='${vrt}']`).each(function (j, el) {
						if ($(el).find('.block-badge').length === 0) {
							$(el).prepend(
								`<div class='block-badge'><img data-src='${prd.badge_image}' class='lazyload'></img></div>`,
							);
						}
					});
				});

				const subVariants = prd.sub_variant_ids.split(',');
				$.each(subVariants, function (i, vrt) {
					$(`div[data-badge-variant='${vrt}']`).each(function (j, el) {
						if ($(el).find('.block-badge').length === 0) {
							$(el).prepend(
								`<div class='block-badge'><img data-src='${prd.badge_image}' class='lazyload'></img></div>`,
							);
						}
					});
				});
			}
		});
		// on homepage remove badge from featured product if badge from section already exist
		if ($('.templateIndex').length && $('.templateIndex .product-badge')) {
			$('.templateIndex .product-images-content .block-badge').remove();
		}

		$('body').on('updatedCart', function () {
			setTimeout(function () {
				roar.setBadge(true);
			}, 1000);
		});
	},
	handleCartUpsell() {
		$('.cart-upsell-item .cart-button-upsell button')
			.off('click')
			.on('click', function () {
				id = $(this).data('id');
				parent = $(this).parent().parent().addClass('checked');
				$('.cart-window').scrollTop(0);
				roar.upsellAddToCart(id);
			});
	},
	upsellAddToCart(id) {
		_this = this;
		data = {
			id,
			quantity: 1,
			properties: {
				_product_upsell: true,
			},
		};
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			async: !0,
			cache: !1,
			data,
			dataType: 'json',
			beforeSend() {
				$('.loading-overlay').height($('.cart-window-body').height());
				$('#cart-info').addClass('loading');
				$('.cart-window-body').addClass('loading');
				$('.cart-window-bg').removeClass('window-hide');
				$('#fake-checkout,#update-cart').attr('disabled', 'disabled');
			},
			success(cart) {
				roar.updateCart(cart, !0);
				window.queueUpdatesDrawer.push(Date.now());
			},
			complete() {
				// $(".cart-window-body").removeClass("loading");
				// $("#update-cart").removeAttr('disabled');
			},
		});
	},
	handleCustom() {
		$('.add-review-button')
			.off('click')
			.on('click', function (y) {
				y.preventDefault(), $('.spr-summary-actions-newreview').trigger('click');
			}),
		$('.item-benefit').length > 0 &&
				$('.item-benefit .tab-heading').unbind('click') &&
				$('.item-benefit .tab-heading').click(function (y) {
					y.preventDefault();
					const S = $(this);
					const T = S.closest('.item-benefit');
					T.hasClass('active')
						? (T.removeClass('active'), T.find('.product-accordion-content').stop(!0, !0).slideUp())
						: (T.addClass('active'), T.find('.product-accordion-content').stop(!0, !0).slideDown());
				}),
		$('.collection-top .top-item a')
			.off('click')
			.on('click', function (y) {
				y.preventDefault(),
				$('.collection-top .top-item').removeClass('active'),
				$(this).closest('.top-item').addClass('active');
				const S = $($(this).data('id')).offset().top - 30;
				$('html,body').animate(
					{
						scrollTop: S,
					},
					500,
					'swing',
				);
			}),
		$('.home-video-button a')
			.off('click')
			.click(function (y) {
				y.stopPropagation();
				const S = $(this).data('video');
				$.magnificPopup.open({
					items: {
						src: S,
						type: 'iframe',
					},
					type: 'iframe',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: !1,
					disableOn: !1,
					fixedContentPos: !1,
					callbacks: {
						beforeClose() {
							console.log('Popup close has been initiated');
						},
					},
				});
			}),
		window.shopping_cart_type === 'sidebar' &&
				($('body .cart-block-click')
					.off('click')
					.on('click', function (y) {
						$('.cart-window-bg').toggleClass('window-hide');
						$('html,body').addClass('drawer-opened');
						if ($('html').hasClass('instagram-browser')) {
							$('html').removeClass('browser-hide-bar');
            	$(".instagram-browser").scrollTop(-50);
						}
					}),
				$('body .close-cart')
					.off('click')
					.on('click', function (y) {
						y.preventDefault(), $('.cart-window-bg').addClass('window-hide');
						$('html,body').removeClass('drawer-opened');
						$('body').css({'overflow': 'initial'});
					}));
	},
	handleAddress() {
		const y = $('#AddressNewForm');
		y.length &&
			(Shopify &&
				new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
					hideElement: 'AddressProvinceContainerNew',
				}),
			$('.address-country-option').each(function () {
				const S = $(this).data('form-id');
				new Shopify.CountryProvinceSelector(`AddressCountry_${S}`, `AddressProvince_${S}`, {
					hideElement: `AddressProvinceContainer_${S}`,
				});
			}),
			$('.address-new-toggle').on('click', function () {
				$('.form-edit').addClass('hide');
				y.removeClass('hide');
			}),
			$('.address-edit-toggle').on('click', function () {
				$('.form-edit').addClass('hide');
				y.addClass('hide');
				const S = $(this).data('form-id');
				$(`#EditAddress_${S}`).removeClass('hide');
			}),
			$('.address-delete').on('click', function () {
				const S = $(this);
				const T = S.data('form-id');
				const P = S.data('confirm-message');
				confirm(P || 'Are you sure you wish to delete this address?') &&
					Shopify.postLink(`/account/addresses/${T}`, {
						parameters: {
							_method: 'delete',
						},
					});
			}));

			$('.cancel-toggle').on('click', function(){
				$('.form-edit').addClass('hide');
				$('.form-add').addClass('hide');
			});
	},
	handleAccount() {
		function y() {
			return $('#recover-password').fadeIn(), $('#customer-login').hide(), (window.location.hash = '#recover'), !1;
		}

		function S() {
			return $('#recover-password').hide(), $('#customer-login').fadeIn(), !1;
		}
		$('#forgot_password a').click(function () {
			y();
		}),
		window.location.hash === '#recover' ? y() : S(),
		$('#recover-password .cancel').click(function () {
			S();
		});
	},
	handleHeaderNotice() {
		if (window.hn_use) {
			let y = !0;
			window.hn_once && localStorage.getItem('displayNotice') === 'yes' && (y = !1),
			!0 === y &&
					($('#header-notice .header-notice').show(),
					$('#header-notice .close-notice').on('click', function () {
						return (
							window.hn_once && localStorage.setItem('displayNotice', 'yes'),
							$('#header-notice .header-notice').hide(),
							!1
						);
					}));
		}
	},
	initLazyLoading(y, S) {
		var y = y || 'body';
		var S = S || !1;
		const T = new Blazy({
			selector: `${y} .b-lazy`,
			success(P) {
				setTimeout(function () {
					const I = P.parentNode;
					I.className = I.className.replace(/\bb-loading\b/, '');
				}, 200);
			},
		});
		!0 === S && T.load($(`${y} .b-lazy`), !0);

		// $('.rich-banner-wrapper img, .section-why-teatox img, #shopify-section-ingredients img').each(function (index, el) {
		// 	if (!$(el).hasClass('lazyload')) {
		// 		$(el).addClass('lazyload');
		// 	}
		// });
		$('#shopify-section-ingredients p').each(function () {
			$(this).html(
				$(this)
					.html()
					.replace(/&nbsp;/gi, ''),
			);
		});
	},
	destroyCountdown() {
		$.fn.countdown && $('.is-countdown').countdown('destroy');
	},
	initCountdown() {
		$.fn.countdown &&
			$('.countdown:not(.is-countdown)').each(function () {
				const y = $(this);
				const S = new Date();
				const T = new Date(parseInt(y.data('year')), parseInt(y.data('month')) - 1, y.data('day'));
				T > S
					? y.countdown({
						until: T,
					  })
					: y.parent().hide();
			});
	},
	handleCookie() {
		function S() {
			try {
				const P = `domain=.${document.domain}`;
				const z = new Date();
				z.setTime(z.getTime() + 31536e6);
				const N = `; expires=${z.toGMTString()}`;
				document.cookie = `${'popup-module-cookie' + '=' + 'true'}${N}; path=/; ${P}`;
			} catch (L) {
				console.log(L.message);
			}
		}
		!(function () {
			try {
				const P = 'popup-module-cookie';
				if (document.cookie.length > 0) {
					let I = document.cookie.indexOf(`${P}=`);
					if (I != -1) {
						I = I + P.length + 1;
						let A = document.cookie.indexOf(';', I);
						return A === -1 && (A = document.cookie.length), unescape(document.cookie.substring(I, A));
					}
				}
			} catch (z) {
				console.log(z.message);
			}
		})() &&
			$('#cookie').length &&
			((function () {
				$('#cookie.cookie').length
					? $('#cookie').fadeIn('slow')
					: $('#cookie.popup').length &&
					  $.magnificPopup.open({
					  	items: {
					  		src: '#cookie',
					  		type: 'inline',
					  	},
					  	tLoading: '',
					  	mainClass: 'popup-module mfp-with-zoom popup-type-2',
					  	removalDelay: 200,
					  	modal: !0,
					  });
			})(),
			$('#cookie .accept').click(function () {
				S(),
				$('#cookie.cookie').length
					? $('#cookie').fadeOut('slow')
					: $('#cookie.popup').length && $.magnificPopup.close();
			}));
	},
	handleCompare() {
		window.compare === '1' && (roar.handleCompareEvent(), roar.autoloadCompare(), roar.handleCompareScroll());
	},
	handleCompareEvent() {
		const y = $('body');
		const S = $('a.add_to_compare');
		y.on('click', 'a.add_to_compare', function () {
			const P = $(this);
			const I = P.data('pid');
			let A = '';
			let z = RoarCookie.cookie.rtread('rt-compare');
			if (((z = z != null && z != '' ? z.split(',') : []), z.indexOf(I) < 0 && !1 === $(this).hasClass('added'))) {
				z.push(I);
				let N = z.join(',');
				N.substring(0, 1) === ',' && (N = N.substring(1)), RoarCookie.cookie.rtwrite('rt-compare', N);
			}
			!1 === $(this).hasClass('added') || A === ''
				? ((A = ''),
				  $.ajax({
					url: `/search?view=compare&q=${z}`,
					dataType: 'html',
					type: 'GET',
					success(L) {
						A = L;
					},
					error() {
						console.log('ajax error');
					},
					complete() {
						$.magnificPopup.open({
							items: {
								src: A,
								type: 'inline',
							},
							preloader: !0,
							tLoading: '',
							mainClass: 'quickview compareview',
							removalDelay: 200,
							gallery: {
								enabled: !0,
							},
							callbacks: {
								open() {
									$(`[data-pid="${I}"]`)
										.addClass('added')
										.attr('title', $(`[data-pid="${I}"]`).attr('data-added')),
									$(`[data-pid="${I}"]`)
										.find('span')
										.html($(`[data-pid="${I}"]`).attr('data-add')),
									window.show_multiple_currencies && theme.CurrencyPicker.convert('.compare-content .money'),
									roar.handleReviews(),
									roar.handleCompareScroll();
								},
							},
						});
					},
				  }))
				: $.ajax({
					url: `/search?view=compare&q=${z}`,
					dataType: 'html',
					type: 'GET',
					success(L) {
						A = L;
					},
					error() {
						console.log('ajax error');
					},
					complete() {
						$.magnificPopup.open({
							items: {
								src: A,
								type: 'inline',
							},
							preloader: !0,
							tLoading: '',
							mainClass: 'quickview compareview',
							removalDelay: 200,
							gallery: {
								enabled: !0,
							},
							callbacks: {
								open() {
									window.show_multiple_currencies && theme.CurrencyPicker.convert('.compare-content .money'),
									roar.handleReviews(),
									roar.handleCompareScroll();
								},
							},
						});
					},
				  });
		}),
		y.on('click', '.remove_from_compare', function (P) {
			P.preventDefault();
			const I = $(this);
			const A = I.attr('data-rev');
			const z = $('.compare-content');
			$(`[data-pid="${A}"]`)
				.removeClass('added')
				.attr('title', $(`[data-pid="${A}"]`).attr('data-add')),
			$(`[data-pid="${A}"]`)
				.find('span')
				.html($(`[data-pid="${A}"]`).attr('data-add'));
			let N = decodeURI(RoarCookie.cookie.rtread('rt-compare'));
			N != null && (N = N.split(',')),
			(N = jQuery.grep(N, function (L) {
				return L != A;
			})),
			(N = $.trim(N)),
			RoarCookie.cookie.rtwrite('rt-compare', N),
			$(`.fastor_${A}`).remove(),
			N.length <= 0 && $('.mfp-close').trigger('click');
		});
	},
	autoloadCompare() {
		if (parseInt(window.compare) != 0) {
			let y = RoarCookie.cookie.rtread('rt-compare');
			y === null
				? (y = [])
				: ((y = y.split(',')),
				  y.map(function (S) {
					$(`[data-pid="${S}"]`)
						.addClass('added')
						.attr('title', $(`[data-pid="${S}"]`).attr('data-added')),
					$(`[data-pid="${S}"]`)
						.find('span')
						.html($(`[data-pid="${S}"]`).attr('data-added'));
				  }));
		}
	},
	handleCompareScroll() {
		jQuery('#be_compare_features_table').on('scroll', function () {
			const y = jQuery(this).parent();
			jQuery(this).scrollLeft() + jQuery(this).innerWidth() >= jQuery(this)[0].scrollWidth
				? y.hasClass('scroll-right') && y.removeClass('scroll-right')
				: jQuery(this).scrollLeft() === 0
					? y.hasClass('scroll-left') && y.removeClass('scroll-left')
					: (!y.hasClass('scroll-right') && y.addClass('scroll-right'),
				  !y.hasClass('scroll-left') && y.addClass('scroll-left'));
		}),
		(be_compare_container = document.getElementById('be_compare_features_table')),
		be_compare_container !== null &&
				be_compare_container.offsetWidth < be_compare_container.scrollWidth &&
				!jQuery('#be_compare_features_table_inner').hasClass('scroll-right') &&
				jQuery('#be_compare_features_table_inner').addClass('scroll-right'),
		jQuery(window).on('resize', function () {
			roar.be_compare_products_table_shadows();
		}),
		jQuery('#be_compare_features_table_inner').hasClass('scroll-left') ||
			jQuery('#be_compare_features_table_inner').hasClass('scroll-right')
			? $('.compareview').addClass('no-flex')
			: $('.compareview').removeClass('no-flex');
	},
	be_compare_products_table_shadows() {
		be_compare_container = document.getElementById('be_compare_features_table');
		be_compare_container === null ||
			(be_compare_container.offsetWidth < be_compare_container.scrollWidth
				? !jQuery('#be_compare_features_table_inner').hasClass('scroll-right') &&
				  jQuery('#be_compare_features_table_inner').addClass('scroll-right')
				: (jQuery('#be_compare_features_table_inner').hasClass('scroll-right') &&
						jQuery('#be_compare_features_table_inner').removeClass('scroll-right'),
				  jQuery('#be_compare_features_table_inner').hasClass('scroll-left') &&
						jQuery('#be_compare_features_table_inner').removeClass('scroll-left')),
			jQuery('#be_compare_features_table_inner').hasClass('scroll-left') ||
			jQuery('#be_compare_features_table_inner').hasClass('scroll-right')
				? $('.compareview').addClass('no-flex')
				: $('.compareview').removeClass('no-flex'));
	},
	removeToWishlist() {
		$(document).on('click', '.remove-wishlist', function (y) {
			y.preventDefault();
			const S = $(this);
			const T = S.closest('form');
			let P = {
				action: 'remove_wishlist',
			};
			return (
				(P = `${T.serialize()}&${$.param(P)}`),
				$.ajax({
					type: 'POST',
					url: '/a/wishlist',
					async: !0,
					cache: !1,
					data: P,
					dataType: 'json',
					beforeSend() {
						$('.page-wishlist').addClass('is_loading');
					},
					error(I) {
						console.log(I), $('.page-wishlist').removeClass('is_loading');
					},
					success(I) {
						I.code === 1
							? S.closest('.item').slideUp('fast', function () {
								S.closest('.item').remove(),
								$('.page-wishlist .infos').removeClass('hide'),
								$('.wishlist_items_number').text(I.json),
								I.json === 0 && $('.wishlist-empty').removeClass('hide');
							  })
							: (alert(I.json), console.log(I.json)),
						$('.page-wishlist').removeClass('is_loading');
					},
				}),
				!1
			);
		});
	},
	addToWishlist() {
		$(document).on('click', '.add-to-wishlist:not(.added)', function () {
			if ($(this).hasClass('need-login')) {
				const S = $('#wishlist_error').html();
				return (
					$.notify(
						{
							message: S,
							target: '_blank',
						},
						{
							type: 'info',
							showProgressbar: !0,
							z_index: 2031,
							mouse_over: 'pause',
							placement: {
								from: 'top',
								align: window.rtl ? 'left' : 'right',
							},
						},
					),
					!1
				);
			}
			const T = $(this);
			const P = T.closest('form');
			let I = {
				action: 'add_wishlist',
			};
			return (
				(I = `${P.serialize()}&${$.param(I)}`),
				$.ajax({
					type: 'POST',
					url: '/a/wishlist',
					async: !0,
					cache: !1,
					data: I,
					dataType: 'json',
					beforeSend() {
						T.hasClass('btooltip')
							? T.addClass('loading')
							: T.attr('title', T.attr('data-loading-text')).find('span').text(T.attr('data-loading-text'));
					},
					complete() {
						T.hasClass('btooltip') && T.removeClass('loading'),
						$(`.wishlist${T.prev().val()}`)
							.attr('title', T.attr('data-added'))
							.addClass('added')
							.find('span')
							.text(T.attr('data-added'));
					},
					error(A) {
						const z = (i = $.parseJSON(A.responseText));
						const N = `${z.message}: ${z.description}`;
						$.notify(
							{
								message: N,
								target: '_blank',
							},
							{
								type: 'info',
								showProgressbar: !0,
								z_index: 2031,
								mouse_over: 'pause',
								placement: {
									from: 'top',
									align: window.rtl ? 'left' : 'right',
								},
							},
						);
					},
					success() {
						const A = T.closest('.product');
						const z = [
							{
								product_url: A.find('.name a').attr('href'),
								product_name: A.find('.name a').text(),
							},
						];
						$.notify(
							{
								message: $('<div>').append($('#wishlist_success').tmpl(z).clone()).html(),
								target: '_blank',
							},
							{
								type: 'success',
								showProgressbar: !0,
								z_index: 2031,
								mouse_over: 'pause',
								placement: {
									from: 'top',
									align: window.rtl ? 'left' : 'right',
								},
							},
						);
					},
				}),
				!1
			);
		});
	},
	checkDrawer() {
		clearTimeout(window.checkingDrawer);
		window.checkingDrawer = setTimeout(function () {
			getCart = $.getJSON('/cart.js');
			currentTotalItem = $('.cart-item:not(.cart-upsell-item):not(.subscription-action)').length;
			qty = parseInt($('.cart-window-header .mycart-counter').text());
			handleMoneyFormat();
			// convertCurrencySubscription();
			if (window.use_fake_counter_1) {
				qty = parseInt($('.cart-window-header .mycart-counter').attr('data-real-counter'));
			}
			if (window.updatingCart) {
				setTimeout(function () {
					roar.checkDrawer();
				}, 100);
				return;
			}

			getCart.done(function (resp) {
				handleMoneyFormat();
				convertCurrencySubscription();
				crtQty = 0;
				resp.items.forEach(function (item, index) {
					crtQty += item.quantity;
				});
				if (currentTotalItem != resp.items.length || qty != crtQty) {
					roar.updateCart('', !0);
				}
			});
		}, 100);
	},
	delayAdd(item, data, i, count = 1) {
		setTimeout(function () {
			$.ajax({
				url: '/cart/add.js',
				type: 'POST',
				dataType: 'json',
				data,
				beforeSend() {
					$('.loading-overlay').css({
						height: `${$('.cart-window-body').innerHeight()}px`,
					});
					$('.cart-window-body').addClass('loading');
					$('.cart-window-bg').removeClass('window-hide');
					$('#fake-checkout, #update-cart').attr('disabled', 'disabled');
				},
				success() {
					if (window.updatingCart) {
						setTimeout(function () {
							roar.checkDrawer();
						}, 500);
					} else {
						setTimeout(function () {
							roar.updateCart('', !0);
						}, 200);
					}
				},
				error() {
					if (count < 3) {
						roar.delayAdd(item, data, i, count + 1);
					} else {
						$('.cart-window-body').removeClass('loading');
						$('#fake-checkout, #update-cart').removeAttr('disabled');
					}
				},
			});
		}, i * 500);
	},
	updateCart(y, S, tt) {
		if (!0 === S) {
			window.shopping_cart_type === 'sidebar'
				? $.ajax({
					url: '/pages/cart-ajax',
					dataType: 'html',
					contentType: 'text/html;charset=UTF-8',
					beforeSend() {
						window.updatingCart = true;
						$('#cart_info').addClass('loading');
						$('.loading-overlay').css({
							height: '100%',
						});
						$('.cart-window-body').addClass('loading');
						$('#fake-checkout,#update-cart').attr('disabled', 'disabled');
						$('.cart-window-bg').removeClass('window-hide');
					},
					success(P) {
						clearTimeout(window.processingCart);
						window.processingCart = setTimeout(function () {
							const I = 'div#cart_block';
							const L = 'div#cart_info';
							$(I).html($(P).find(I).html()), $(L).html($(P).filter(L).html());
							$('.cart-window-bg').removeClass('window-hide');

							// function getpin exist in theme-custom.js file
							roar.handleCustom();
							roar.handleReviews();
							roar.checkDrawer();
							roar.setCurrencyFormat();
							roar.handleCartUpsell();
							roar.handleBoldProductCampaign();
							$('body').trigger('updatedCart');
							document.dispatchEvent(new CustomEvent('drawerUpdated'));
							// refresh yotpo
							if (typeof yotpo === 'object') {
								setTimeout(function () {
									y = new Yotpo.API(yotpo);
									y.refreshWidgets();
								}, 500);
							}
						}, 1000);
					},
					error(P) {
						console.log(P);
					},
				  }).done(function () {
					window.updatingCart = false;
					// $("#cart_info").removeClass("loading");
					// $(".cart-window-body").removeClass('loading');
					// $("#fake-checkout,#update-cart").removeAttr('disabled');
					// checkBBTone();
					// handleBoldCurrency();
				  })
				: $.ajax({
					url: `/search?view=cart&q=${y.handle}_sp_${y.variant_id}_sp_${y.quantity}_sp_${y.price}`,
					beforeSend() {
						window.updatingCart = true;
						$('.loading-overlay').css({
							height: '100%',
						});
						$('.cart-window-body').addClass('loading');
						$('.cart-window-bg').removeClass('window-hide');
						$('#fake-checkout,#update-cart').attr('disabled', 'disabled');
					},
					success(P) {
						const I = 'div#cart_block';
						const z = '.mobile-nav-cart';
						$(I).html($(P).filter(I).html()), $(z).html($(P).filter(z).html());
						roar.checkDrawer();

						roar.handleBoldProductCampaign();
						roar.handleCartUpsell();
						$('body').trigger('updatedCart');
					},
					error(P) {
						console.log(P);
					},
				  }).done(function () {
					window.updatingCart = true;
					$('.cart-window-body').removeClass('loading');
					$('#update-cart, #fake-checkout').removeAttr('disabled');

					if (window.shopping_cart_type === 'ajax_notify') {
						const P = [
							{
								product_url: y.url,
								product_name: y.title,
							},
						];
						$.notify(
							{
								message: $('<div>').append($('#cart_success').tmpl(P).clone()).html(),
								target: '_blank',
							},
							{
								type: 'success',
								showProgressbar: !0,
								z_index: 2031,
								mouse_over: 'pause',
								placement: {
									from: 'top',
									align: window.rtl ? 'left' : 'right',
								},
							},
						);
					} else roar.popupCart(S);
				  });
		} else {
			const T = $.parseJSON(y.responseText);
			$.ajax({
				url: `/search?view=cart_error&q=${T.description}`,
				beforeSend() {},
				success(P) {
					const I = 'div#cart_error_popup';
					$(I).html($(P).filter(I).html());
				},
				error(P) {
					console.log(P);
				},
			}).done(function () {
				if (window.shopping_cart_type === 'ajax_notify') {
					const P = (i = $.parseJSON(y.responseText));
					const I = `${P.message}: ${P.description}`;
					$.notify(
						{
							message: I,
							target: '_blank',
						},
						{
							type: 'info',
							showProgressbar: !0,
							z_index: 2031,
							mouse_over: 'pause',
							placement: {
								from: 'top',
								align: window.rtl ? 'left' : 'right',
							},
						},
					);
				} else roar.popupCart(S);
			});
		}
	},
	mapFilters() {
		roar.handleGridList(), roar.mapPagination();
	},
	mapPaginationCallback() {
		roar.handleGridList(),
		roar.handleReviews(),
		roar.initCountdown(),
		roar.initLazyLoading('#sandbox', !0),
		window.show_multiple_currencies && theme.CurrencyPicker.convert('#sandbox .money');
	},
	mapPagination() {
		if (
			($(document.body).on('click', '.fastor_ajax_load_button a', function (S) {
				if ((S.preventDefault(), $('.pagination a.next').length)) {
					$('.fastor_ajax_load_button a').attr('data-processing', 1);
					const T = $('.pagination a.next').attr('href');
					const P = $('.fastor_ajax_load_button a').attr('data-loading-items');
					var I = $('.fastor_ajax_load_button a').attr('data-no-more');
					$('.fastor_ajax_load_button').hide(),
					$('.pagination').before(
						`<div class="fastor_ajax_load_more_loader animated fadeIn"><a href="#"><i class="icon-px-outline-load"></i>&nbsp;&nbsp;<span>${P}</span></a></div>`,
					),
					$.get(T, function (A) {
						$('.advanced-pagination').html($(A).find('.advanced-pagination').html()),
						$(A)
							.find('.product-list .product')
							.each(function () {
								$('.product-list .product:last').after($(this));
							}),
						$(A)
							.find('.product-grid .product-item')
							.each(function () {
								$('.product-grid .product-item:last').after($(this));
							}),
						roar.mapPaginationCallback(),
						$('.fastor_ajax_load_more_loader').fadeOut('slow'),
						$('.fastor_ajax_load_button').fadeIn('slow'),
						$('.fastor_ajax_load_button a').attr('data-processing', 0),
						$('.pagination a.next').length === 0 &&
									($('.fastor_ajax_load_button').addClass('finished').removeClass('fastor_ajax_load_more_hidden'),
									$('.fastor_ajax_load_button a').show().html(I).addClass('disabled'));
					});
				} else {
					var I = $('.fastor_ajax_load_button a').attr('data-no-more');
					$('.fastor_ajax_load_button').addClass('finished').removeClass('fastor_ajax_load_more_hidden'),
					$('.fastor_ajax_load_button a').show().html(I).addClass('disabled');
				}
			}),
			$('.fastor_ajax_load_button').hasClass('fastor_ajax_load_more_hidden'))
		) {
			const y = Math.abs(0);
			$(window).scroll(function () {
				if ($('.products').length) {
					const S = $('.products').offset().top + $('.products').outerHeight();
					const T = S - $(window).scrollTop();
					T - y < $(window).height() &&
						$('.fastor_ajax_load_button a').attr('data-processing') === 0 &&
						$('.fastor_ajax_load_button a').trigger('click');
				}
			});
		}
	},
	filterCreateUrl(y) {
		const S = $.param(Shopify.queryParams).replace(/%2B/g, '+');
		return y ? (S === '' ? y : `${y}?${S}`) : `${location.pathname}?${S}`;
	},
	updateQueryStringParameter(y, S, T) {
		const P = new RegExp(`([?&])${S}=.*?(&|$)`, 'i');
		const I = y.indexOf('?') === -1 ? '?' : '&';
		return y.match(P) ? y.replace(P, `$1${S}=${T}$2`) : `${y + I + S}=${T}`;
	},
	filterCreateUrlPaging(y) {
		let S = 1;
		const T = y.split('page=');
		return T.length > 1 && (S = parseInt(T[1])), roar.updateQueryStringParameter(window.location.href, 'page', S);
	},
	filterAjaxClick(y) {
		delete Shopify.queryParams.page;
		const S = roar.filterCreateUrl(y);
		roar.filterGetContent(S);
	},
	filterGetContent(y) {
		$.ajax({
			type: 'get',
			url: y,
			beforeSend() {
				roar.destroyCountdown(), $('body').addClass('is_loading').removeClass('open_filter');
			},
			success(S) {
				const T = S.match('<title>(.*?)</title>')[1];
				$(S).find('.breadcrumb-content').length &&
					$('.breadcrumb-content').html($(S).find('.breadcrumb-content').html()),
				$('.category-info').remove(),
				$(S).find('.category-info').length && $('#mfilter-content-container').prepend($(S).find('.category-info')),
				$('#sandbox').empty().html($(S).find('#sandbox').html()),
				$('.mfilter-box .mfilter-content').empty().html($(S).find('.mfilter-box .mfilter-content').html()),
				$('#mfilter-content-container .advanced-pagination')
					.empty()
					.html($(S).find('#mfilter-content-container .advanced-pagination').html()),
				$('.page-top').empty().html($(S).find('.page-top').html()),
				History.pushState(
					{
						param: Shopify.queryParams,
					},
					T,
					y,
				),
				setTimeout(function () {
					$('html,body').animate(
						{
							scrollTop: $('body #sandbox').offset().top,
						},
						500,
						'swing',
					);
				}, 100),
				$('body').removeClass('is_loading'),
				roar.handleReviews(),
				roar.initCountdown(),
				roar.initLazyLoading('#sandbox', !0),
				window.show_multiple_currencies && theme.CurrencyPicker.convert('#sandbox .money');
			},
			error() {
				$('body').removeClass('is_loading');
			},
		});
	},
	handleReviews() {
		typeof SPR !== 'undefined' &&
			(SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
	},
	getWidthBrowser() {
		let y;
		return (
			typeof window.innerWidth === 'number'
				? (y = window.innerWidth)
				: document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)
					? (y = document.documentElement.clientWidth)
					: document.body && (document.body.clientWidth || document.body.clientHeight) && (y = document.body.clientWidth),
			y
		);
	},
	handleGMap() {
		$('#contact_map').length &&
			$().gMap &&
			$('#contact_map').gMap({
				zoom: 17,
				scrollwheel: !1,
				maptype: 'ROADMAP',
				markers: [
					{
						address: window.contact_map_address,
						html: '_address',
						icon: {
							iconsize: [188, 68],
							iconanchor: [0, 68],
						},
					},
				],
			});
	},
	handleGridList() {
		$(document).on('click', '#grid', function () {
			$('#mfilter-content-container').removeClass('list').addClass('grid');
		}),
		$(document).on('click', '#list', function () {
			$('#mfilter-content-container').removeClass('grid').addClass('list'),
			$('body').removeClass('flex-view-2 flex-view-3 flex-view-4 flex-view-6').addClass('flex-view-1');
		});
	},
	handleSmoothScroll() {
		$(document).on('click', '.smoothscroll', function (y) {
			y.preventDefault();
			const S = $(this).attr('href');
			$(S).trigger('click'),
			setTimeout(function () {
				$('html,body').animate(
					{
						scrollTop: $(S).offset().top - 100,
					},
					800,
					'swing',
				);
			}, 300);
		});
	},
	handleDropdown() {
		$("[data-toggle='dropdown']").on('click', function () {
			$(this).parent().toggleClass('open');
		});
	},
};

/* global theme */

window.theme = window.theme || {};
window.slate = window.slate || {};

theme.CurrencyPicker = (function () {
	function y() {
		if (N.auto_switch === 'false') return console.log('xxx'), !1;
		const L = Currency.cookie.read();
		L === null &&
			$.getJSON('//ipinfo.io/json', function (q) {
				const M = JSON.parse(JSON.stringify(q, null, 2));
				typeof M.country !== 'undefined' &&
					$.getJSON(`//restcountries.eu/rest/v1/alpha/${M.country}`, function (O) {
						const F = O.currencies;
						const E = F[0];
						$(`${z.currencyPicker}[data-code="${E}"]`).trigger('click');
					});
			});
	}

	function S() {
		if (N.original_price === 'false') return !1;
		let L = Currency.currentCurrency;
		const q = Currency.cookie.read();
		const M = N.shop_currency;
		q && (L = q),
		$(z.selector).each(function () {
			const O = $(this);
			if ((O.removeAttr('data-currency-default'), M != L)) {
				let F = O.attr(`data-currency-${M}`);
				M === 'USD' && (F += ' USD'), O.attr('data-currency-default', F);
			}
		});
	}

	function T() {
		return $(z.currencyNotification).length
			? Currency.currentCurrency === N.shop_currency
				? void $(z.currencyNotification).removeClass('loaded').slideUp()
				: void $(z.currencyNotification).each(function () {
					const L = $(this);
					let q = L.data('html');
					const M = `<strong>${Currency.currentCurrency}</strong>`;
					(q = q.replace(/\{\{ current_currency \}\}/g, M)),
					L.html(q),
					L.hasClass('loaded') || L.addClass('loaded').slideDown();
				  })
			: void 0;
	}
	var z = {
		selector: '.money',
		container: '.currency__picker',
		currency: '.currency__picker .currency__switcher',
		currencyPicker: '.currency__picker .currency',
		currencyActive: '.currency__picker .currency.active',
		currencyCurrent: '.currency__picker .currency__current',
		currencyNotification: '.currency__notification',
	};
	var N = {
		currency_format: '',
		shop_currency: '',
		default_currency: '',
		money_with_currency_format: '',
		money_format: '',
		auto_switch: 'true',
		original_price: 'true',
	};
	return {
		init() {
			console.log('initial currency');
			if ($(z.currency).length) {
				const L = $(z.container);
				(N.currency_format = L.find('.currency_format').val()),
				(N.shop_currency = L.find('.shop_currency').val()),
				(N.default_currency = L.find('.default_currency').val()),
				(N.money_with_currency_format = L.find('.money_with_currency_format').val()),
				(N.money_format = L.find('.money_format').val()),
				(N.auto_switch = L.find('.auto_switch').val()),
				(N.original_price = L.find('.original_price').val()),
				(Currency.format = N.currency_format);
				const q = N.shop_currency;
				(Currency.moneyFormats[q].money_with_currency_format = N.money_with_currency_format),
				(Currency.moneyFormats[q].money_format = N.money_format);
				const M = N.default_currency;
				const O = Currency.cookie.read();
				$('.money .money').each(function () {
					$(this).parents('.money').removeClass('money');
				}),
				$(z.selector).each(function () {
					const B = $(this);
					if (typeof B.attr(`data-currency-${N.shop_currency}`) === 'undefined') {
						const D = B.text();
						B.attr(`data-currency-${N.shop_currency}`, D);
					}
				}),
				O === null
					? q === M
						? (Currency.currentCurrency = M)
						: Currency.convertAll(q, M, z.selector)
					: $(z.currency).length && $(`${z.currency} .currency[data-code=${O}]`).length === 0
						? ((Currency.currentCurrency = q), Currency.cookie.write(q))
						: O === q
							? (Currency.currentCurrency = q)
							: Currency.convertAll(q, O, z.selector),
				$(z.currency).on('click', '.currency:not(.active)', function () {
					const B = $(this).data('code');
					Currency.convertAll(Currency.currentCurrency, B, z.selector),
					$(z.currencyPicker).removeClass('active'),
					$(this).addClass('active'),
					$(z.currencyCurrent).text(Currency.currentCurrency).attr('data-code', Currency.currentCurrency),
					S(),
					T();
				});
				const F = window.selectCallback;
				$(z.currencyPicker).removeClass('active'),
				$(`${z.currency} .currency[data-code=${Currency.currentCurrency}]`).addClass('active'),
				$(z.currencyCurrent).text(Currency.currentCurrency).attr('data-code', Currency.currentCurrency),
				S(),
				y(),
				T();
			}
		},
		convert(L) {
			return;
			$(z.currency).length &&
				($(L).each(function () {
					const q = $(this);
					if (typeof q.attr(`data-currency-${N.shop_currency}`) === 'undefined') {
						const M = q.text();
						q.attr(`data-currency-${N.shop_currency}`, M);
					}
				}),
				Currency.convertAll(N.shop_currency, $(z.currencyActive).attr('data-code'), L, N.currency_format),
				S());
		},
		convertAll() {
			return;
			$(z.currency).length &&
				($(z.selector).each(function () {
					const L = $(this);
					if (typeof L.attr(`data-currency-${N.shop_currency}`) === 'undefined') {
						const q = L.text();
						L.attr(`data-currency-${N.shop_currency}`, q);
					}
				}),
				Currency.convertAll(N.shop_currency, $(z.currencyActive).attr('data-code'), z.selector),
				S());
		},
	};
})();

theme.Currency = (function () {
	return {
		formatMoney(T, P) {
			function I(L, q, M, O) {
				if (M = M || ',', O = O || '.', isNaN(L) || L === null) return 0;
				L = (L / 100).toFixed(q);
				const F = L.split('.');
				const E = F[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${M}`);
				const B = F[1] ? O + F[1] : '';
				return E + B;
			}
			typeof T === 'string' && (T = T.replace('.', ''));
			let A = '';
			const z = /\{\{\s*(\w+)\s*\}\}/;
			const N = P || '$\{\{amount\}\}';
			switch (N.match(z)[1]) {
				case 'amount':
					A = I(T, 2);
					break;
				case 'amount_no_decimals':
					A = I(T, 0);
					break;
				case 'amount_with_comma_separator':
					A = I(T, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					A = I(T, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					A = I(T, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					A = I(T, 2, "'");
			}
			return N.replace(z, A);
		},
	};
}());

slate.Variants = (function () {
	function y(S) {
		this.$container = S.$container, this.product = S.product, this.singleOptionSelector = S.singleOptionSelector, this.originalSelectorId = S.originalSelectorId, this.enableHistoryState = S.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_getCurrentOptions() {
			let S = _.map($(this.singleOptionSelector, this.$container), function (T) {
				const P = $(T);
				const I = P.attr('type');
				const A = {};
				return I === 'radio' || I === 'checkbox' ? !!P[0].checked && (A.value = P.val(), A.index = P.data('index'), A) : (A.value = P.val(), A.index = P.data('index'), A);
			});
			return S = _.compact(S), S;
		},
		_getVariantFromOptions() {
			const S = this._getCurrentOptions();
			const T = this.product.variants;
			const P = _.find(T, function (I) {
				return S.every(function (A) {
					return _.isEqual(I[A.index], A.value);
				});
			});
			return P;
		},
		_onSelectChange() {
			const S = this._getVariantFromOptions();
			this.$container.trigger({
				type: 'variantChange',
				variant: S,
			}), S && (this._updateMasterSelect(S), this._updateImages(S), this._updatePrice(S), this._updateSKU(S), this.currentVariant = S, this.enableHistoryState && this._updateHistoryState(S));
		},
		_updateImages(S) {
			const T = S.featured_image || {};
			const P = this.currentVariant.featured_image || {};
			S.featured_image && T.src !== P.src && this.$container.trigger({
				type: 'variantImageChange',
				variant: S,
			});
		},
		_updatePrice(S) {
			S.price === this.currentVariant.price && S.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
				type: 'variantPriceChange',
				variant: S,
			});
		},
		_updateSKU(S) {
			S.sku === this.currentVariant.sku || this.$container.trigger({
				type: 'variantSKUChange',
				variant: S,
			});
		},
		_updateHistoryState(S) {
			if (history.replaceState && S) {
				const T = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${S.id}`;
				window.history.replaceState({
					path: T,
				}, '', T);
			}
		},
		_updateMasterSelect(S) {
			$(this.originalSelectorId, this.$container).val(S.id);
		},
	}), y;
}());

theme.Product = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		// override P for sls template or for another product template
		this.settings = {
			imageSize: null,
			namespace: '.product-page-section',
			sectionId: P,
			sliderActive: !1,
			swatch_color: T.attr('data-product_swatch_color'),
			swatch_size: T.attr('data-product_swatch_size'),
			variant_image_grouped: T.attr('data-variant_image_grouped'),
			swatch_color_advanced: T.attr('data-product_swatch_color_advanced'),
			product_design: T.attr('data-product_design'),
			product_image_count: T.data('product_image_count'),
		}, this.selectors = {
			product: `#ProductSection-${P}`,
			addToCart: `#AddToCart-${P}`,
			addToCartText: `#AddToCartText-${P}`,
			stockText: `.stock-${P}`,
			comparePrice: `#ComparePrice-${P}`,
			originalPrice: `#ProductPrice-${P}`,
			SKU: '.variant-sku',
			originalPriceWrapper: `.product-price__price-${P}`,
			originalSelectorId: `#ProductSelect-${P}`,
			productFeaturedImage: `.FeaturedImage-${P}`,
			productImageWrap: `#FeaturedImageZoom-${P}`,
			productPrices: `.product-single__price-${P}`,
			productThumbImages: `#product-thumbnails-${P}`,
			productMainImages: `#product-images-${P}`,
			productPreviewMainImages: `.product-preview-images-${P}`,
			saleLabel: `.product-price__sale-label-${P}`,
			singleOptionSelector: `.single-option-selector-${P}`,
			singleOptionSelectorId: `#single-option-selector-${P}`,
			singleOptionSwatches: `wrapper-swatches-${P}`,
			instagramProduct: `#product-instagram-${P}`,
			instagramProductNameSpace: `product-instagram-${P}`,
			variationsSelector: `#variations-${P}`,
			variationSelector: `.variation-select-${P}`,
			qtyVariant: `.qty-variant-${P}`,
			threedId: `.threed-id-${P}`,
			countDownId: `.countdown-${P}`,
			couponCode: `#coupon-code-${P}`,
			couponBtn: `#coupon-btn-${P}`,
			sidebarSlide: `.sidebar-slick-vertical-${P}`,
			optionsSelect: `#single-option-selector-${P}`,
			stickCart: `#sticky-info-${P}`,
			cartAgree: `#product-cart__agree-${P}`,
			cartCheckout: `#product-buy__1click-${P}`,
			groupedProduct: `#products-grouped-${P}`,
			groupedButton: `#grouped-add-button-${P}`,
			groupedCheckbox: `#products-grouped-${P} .grouped-checkbox`,
		};

		if (P.indexOf('product-') != -1 && P.indexOf('template') != -1) {
			this._initUpsellProducts();
		}

		$(`#ProductJson-${P}`).html() && (this.productSingleObject = JSON.parse(document.getElementById(`ProductJson-${P}`).innerHTML), this.productSwatchSingleObject = JSON.parse(document.getElementById(`ProductSwatchJson-${P}`).innerHTML), this._stringOverrides(), this._initVariants(), this._initFeature(), this._initCompact(), this._initStickyImages(), this._initThumbnailsGallery(), this._initImages(), this._initSidebar(), this._initQuantity(), this._initTabs(), this._initHandleProduct(), this._checkoutCart(), P == 'product-template' && this._initUpsellProducts());
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_stringOverrides() {
			theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings);
		},
		_checkoutCart() {
			const S = this;
			$(document).on('DOMNodeInserted', S.selectors.cartCheckout, function () {
				const T = $(this);
				setTimeout(function () {
					const P = T.find('.shopify-payment-button__button');
					P.length && (T.hide(), setTimeout(function () {
						const I = $(S.selectors.cartAgree);
						I.is(':checked') ? P.removeClass('btn-disabled') : P.addClass('btn-disabled'), T.fadeIn();
					}, 300));
				}, 0);
			}), $(document).on('change', S.selectors.cartAgree, function () {
				const P = $(this);
				const I = $(S.selectors.cartCheckout).find('.shopify-payment-button__button');
				P.is(':checked') ? I.removeClass('btn-disabled') : I.addClass('btn-disabled');
			});
		},
		_initTabs() {
			$('#tabs a').tabs();
		},
		_initHandleProduct() {
			$('#main').next('#popup-product-sizechart').length == 0 && $('#main').after($('#popup-product-sizechart')), $('#main').next('#popup-product-question').length == 0 && $('#main').after($('#popup-product-question')), $('.button-product-question').click(function () {
				const T = $(this).data('question');
				const P = $(this).data('_qid');
				return $.magnificPopup.open({
					items: {
						src: '#popup-product-question',
						type: 'inline',
					},
					tLoading: '',
					mainClass: 'popup-module mfp-with-zoom',
					removalDelay: 200,
				}), !1, void(($('.quickview .mfp-content').find('#popup-product-question').length > 0 || $('.quickview .mfp-content').find('#popup-product-sizechart').length > 0) && ($('.quickview.mfp-wrap').addClass('_reopen'), $('.quickview.mfp-wrap').data('_qid', P)));
			}), $('.button-product-sizechart').click(function () {
				const T = $(this).data('sizechart');
				const P = $(this).data('_qid');
				return $.magnificPopup.open({
					items: {
						src: T,
						type: 'inline',
					},
					tLoading: '',
					mainClass: 'popup-module mfp-with-zoom',
					removalDelay: 200,
				}), !1, void(($('.quickview .mfp-content').find('#popup-product-sizechart').length > 0 || $('.quickview .mfp-content').find('#popup-product-question').length > 0) && ($('.quickview.mfp-wrap').addClass('_reopen'), $('.quickview.mfp-wrap').data('_qid', P)));
			}), $(document).on('click', '#tabProduct a', function (S) {
				S.preventDefault(), $(this).tab('show');
			});
		},
		_initUpsellProducts() {
			const S = '#upsellProducts .carousel-inner';
			const slideToShow = $(S).data('perview') ? $(S).data('perview') : 3;

			$('#upsellProducts.carousel').length > 0 && $(S).slick({
				arrows: !1,
				slidesToShow: slideToShow,
				dots: !0,
				prevArrow: '<span class="slick-arrow-custom slick-prev-arrow"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-left-arrow"></use></svg></span>',
				nextArrow: '<span class="slick-arrow-custom slick-next-arrow"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-right-arrow"></use></svg></span>',
				responsive: [{
					breakpoint: 1200,
					settings: {
						slidesToShow: slideToShow,
						slidesToScroll: 4,
					},
				}, {
					breakpoint: 768,
					settings: {
						centerMode: !0,
						slidesToShow: slideToShow,
						slidesToScroll: 4,
					},
				}, {
					breakpoint: 550,
					settings: {
						centerMode: !0,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				}],
				rtl: window.rtl,
			}), $('#upsellProduct_next').click(function () {
				return $(S).slick('slickNext'), !1;
			}), $('#upsellProduct_prev').click(function () {
				return $(S).slick('slickPrev'), !1;
			}), roar.initLazyLoading(S, !0);
		},
		_initImages() {
			const S = this;
			const T = $(S.selectors.productMainImages);
			let P = !1;
			if (parseInt(window.rtl) == 1 && (P = !0), this.settings.product_design == 'left' || this.settings.product_design == 'bottom' || this.settings.product_design == 'compact2' || this.settings.product_design == 'split' || this.settings.product_design == 'sidebar' || this.settings.product_design == 'simple' || this.settings.product_design == 'full-screen') {
				if ($(S.selectors.productThumbImages).length > 0) {
					var I = $(S.selectors.productThumbImages).find('.thumbnails');
					const A = $(S.selectors.productThumbImages).data('vertical') != '0';
					let z = 4;
					let N = !1;
					if (this.settings.product_image_count > 4 ? (z = 4, N = !0) : z = this.settings.product_image_count - 1, $('.product-page-section').hasClass('product-has-sidebar') && (this.settings.product_image_count > 3 ? (z = 3, N = !0) : z = this.settings.product_image_count - 1), !0 == N) {
						T.not('.slick-initialized').slick({
							rtl: P,
							slidesToShow: 1,
							lazyload: 'ondemand',
							slidesToScroll: 1,
							infinite: !1,
							adaptiveHeight: 0,
							asNavFor: I,
							arrows: true,
							prevArrow: '<span class="slick-arrow-custom slick-prev-arrow"><svg style="fill:#ff6ea9;width: 70px; height: 70px;left: 20px;"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-left-arrow"></use></svg></span>',
							nextArrow: '<span class="slick-arrow-custom slick-next-arrow"><svg style="fill:#ff6ea9;width: 70px; height: 70px;right: 20px;"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-right-arrow"></use></svg></span>',
							responsive: [{
								breakpoint: 768,
								settings: {
									slidesToShow: 1,
									arrows: true,
									dots: true,
								},
							}, ],
						}), I.not('.slick-initialized').slick({
							slidesToShow: 6,
							slidesToScroll: 1,
							asNavFor: T,
							focusOnSelect: !0,
							vertical: A,
							infinite: !1,
							arrows: false,
							responsive: [{
								breakpoint: 768,
								settings: {
									slidesToShow: 5,
								},
							}],
						});
					} else {
						T.not('.slick-initialized').slick({
							rtl: P,
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: !1,
							adaptiveHeight: !0,
							arrows: true,
							prevArrow: '<span class="slick-arrow-custom slick-prev-arrow"><svg style="fill:#ff6ea9;width: 70px; height: 70px;left: 20px;"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-left-arrow"></use></svg></span>',
							nextArrow: '<span class="slick-arrow-custom slick-next-arrow"><svg style="fill:#ff6ea9;width: 70px; height: 70px;right: 20px;"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-right-arrow"></use></svg></span>',
							responsive: [{
								breakpoint: 768,
								settings: {
									slidesToShow: 1,
									arrows: false,
									dots: true,
								},
							}, ],
						});
						const L = this.settings.product_design;
						const q = $(this.selectors.productFeaturedImage);
						const M = $(this.selectors.productMainImages);
						I.find('.thumbnails-item').on('click', function (F) {
							F.preventDefault();
							const E = $(this).data('href').replace('https:', '').replace('http:', '')
								.split('?v=')[0];
							q.each(function () {
								const D = $(this);
								const U = D.data('href');
								if (U.indexOf(E) >= 0 && !D.closest('.slick-slide').hasClass('slick-cloned')) {
									const W = D.closest('.slick-slide').attr('data-slick-index');
									return void(L == 'carousel' ? M.slick('slickGoTo', W) : M.slick('slickGoTo', W, !0));
								}
							}), I.find('.thumbnails-item').removeClass('current'), $(this).addClass('current');
						}), M.on('beforeChange', function (F, E, B, D) {
							const U = $(q[D]).attr('href').replace('https:', '').replace('http:', '')
								.split('?v=')[0];
							I.find('.thumbnails-item').each(function () {
								const H = $(this);
								const V = H.data('href');
								if (V.indexOf(U) >= 0) return I.find('.thumbnails-item').removeClass('current'), void $(this).addClass('current');
							});
						});
					}
				}
			} else if (this.settings.product_design == 'carousel') {
				const O = T.width() / 4;
				T.not('.slick-initialized').slick({
					rtl: P,
					centerMode: !0,
					centerPadding: `${O}px`,
					slidesToShow: 1,
					slidesToScroll: 1,
					adaptiveHeight: !0,
					arrows: !1,
					responsive: [{
						breakpoint: 1680,
						settings: {
							centerMode: !0,
							centerPadding: '400px',
							slidesToShow: 1,
						},
					}, {
						breakpoint: 1440,
						settings: {
							centerMode: !0,
							centerPadding: '350px',
							slidesToShow: 1,
						},
					}, {
						breakpoint: 1200,
						settings: {
							centerMode: !0,
							centerPadding: '300px',
							slidesToShow: 1,
						},
					}, {
						breakpoint: 1024,
						settings: {
							arrows: !1,
							centerMode: !0,
							centerPadding: '250px',
							slidesToShow: 1,
						},
					}, {
						breakpoint: 992,
						settings: {
							centerMode: !0,
							centerPadding: '200px',
							slidesToShow: 1,
						},
					}, {
						breakpoint: 768,
						settings: {
							arrows: !1,
							centerMode: !0,
							centerPadding: '125px',
							slidesToShow: 1,
						},
					}, {
						breakpoint: 480,
						settings: {
							arrows: !1,
							centerMode: !0,
							centerPadding: '50px',
							slidesToShow: 1,
						},
					}],
				});
			} else {
				T.not('.slick-initialized').slick({
					rtl: P,
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: !1,
					adaptiveHeight: !0,
					asNavFor: I,
					arrows: !1,
				});
			}
			T.imagesLoaded(function () {
				T.addClass('loaded');
			});
		},
		_initThumbnailsGallery() {
			const S = $(this.selectors.productMainImages);
			this.settings.product_design == 'gallery' && $('.thumbnail-gallery-item').on('click', function () {
				const T = $(this);
				T.hasClass('active') || ($('.thumbnail-gallery-item').removeClass('active'), T.addClass('active'), $('.thumbnail-gallery-item').each(function (P) {
					if ($(this).attr('id') == T.attr('id')) return void S.slick('slickGoTo', P, !0);
				}));
			});
		},
		_initQuantity() {
			$('.q_up').unbind('click'), $('.q_up').on('click', function () {
				const S = $(this).data('product_id');
				const T = parseInt($(`.quantity-cart-${S}`).val()) + 1;
				$(`.quantity-cart-${S}`).val(T);
			}), $('.q_down').unbind('click'), $('.q_down').on('click', function () {
				const S = $(this).data('product_id');
				const T = parseInt($(`.quantity-cart-${S}`).val());
				T > 1 && $(`.quantity-cart-${S}`).val(T - 1);
			});
		},
		_initFeature() {
			if ($(`${this.selectors.product} .product-video-button a`).length > 0 && $(`${this.selectors.product} .product-video-button a`).unbind('click') && $(`${this.selectors.product} .product-video-button a`).click(function (M) {
					M.stopPropagation();
					const O = $(this).data('video');
					const F = $(this).data('_qid');
					$.magnificPopup.open({
						items: {
							src: O,
							type: 'iframe',
						},
						type: 'iframe',
						mainClass: 'mfp-fade',
						removalDelay: 160,
						preloader: !1,
						disableOn: !1,
						fixedContentPos: !1,
						callbacks: {
							beforeClose() {
								console.log('Popup close has been initiated');
							},
						},
					}), ($('.quickview .mfp-content').find('.product-360-view-wrapper').length > 0 || $('.quickview .mfp-content').find('.mfp-iframe-scaler').length > 0) && ($('.quickview.mfp-wrap').addClass('_reopen'), $('.quickview.mfp-wrap').data('_qid', F));
				}), $(`${this.selectors.product} .product-360-button a`).length > 0) {
				for (var L, T = $(`${this.selectors.product} .product-360-button a`).data('id'), P = $(`${this.selectors.product} .product-360-button a`).data('_qid'), I = $(`${this.selectors.product} .product-360-button a`), A = [], z = JSON.parse(document.getElementById(`threed-id-${this.sectionId}`).innerHTML), N = 1; N <= 72; N++) L = `f${N}`, z[L] && A.push(z[L]);
				if (A.length > 0) {
					const q = A.length;
					$(this.selectors.threedId).ThreeSixty({
						totalFrames: q,
						endFrame: q,
						currentFrame: 1,
						imgList: '.threed-view-images',
						progress: '.spinner',
						imgArray: A,
						height: null,
						width: null,
						responsive: !0,
						navigation: !0,
						onReady() {
							$('#main').next('.product-360-view-wrapper').length == 0 && $('#main').after($(T)), I.unbind('click') && I.click(function () {
								$.magnificPopup.open({
									items: {
										src: T,
										type: 'inline',
									},
									type: 'inline',
									mainClass: 'mfp-fade',
									removalDelay: 160,
									disableOn: !1,
									preloader: !1,
									fixedContentPos: !1,
									callbacks: {
										open() {
											console.log('xx11'), $(window).resize();
										},
									},
								}), $(window).resize(), ($('.quickview .mfp-content').find('.product-360-view-wrapper').length > 0 || $('.quickview .mfp-content').find('.mfp-iframe-scaler').length > 0) && ($('.quickview.mfp-wrap').addClass('_reopen'), $('.quickview.mfp-wrap').data('_qid', P));
							});
						},
					});
				}
			}
		},
		_initCompact() {
			$('.product-accordions').length > 0 && $('.product-accordions .product-accordion:not(.product-scroll) .tab-heading').unbind('click') && $('.product-accordions .product-accordion:not(.product-scroll) .tab-heading').click(function (S) {
				S.preventDefault();
				const T = $(this);
				const P = T.closest('.product-accordion');
				const I = T.closest('.product-accordions');
				P.hasClass('active') ? (P.removeClass('active'), P.find('.product-accordion-content').stop(!0, !0).slideUp()) : (I.find('.product-accordion').removeClass('active'), P.addClass('active'), I.find('.product-accordion-content').stop(!0, !0).slideUp(), P.find('.product-accordion-content').stop(!0, !0).slideDown());
			}), $('.product-scroll a').on('click', function (S) {
				S.preventDefault();
				const T = parseInt($(`.${$(this).data('id')}`).offset().top) - 50;
				$('html,body').animate({
					scrollTop: T,
				}, 'slow');
			});
		},
		_initStickyImages() {
			$('body').hasClass('fastor-product-design-sticky') && $('.product-design-sticky .product-summary').stick_in_parent();
		},
		_initSidebar() {
			const S = this;
			const $sidebarSlide = $(S.selectors.sidebarSlide);
			if ($sidebarSlide.length > 0) $sidebarSlide.each(function () {
				const T = $(this);
				const P = $(this).data('per_view');
				$(this).not('.slick-initialized').slick({
					slidesToShow: P,
					slidesToScroll: 1,
					vertical: !0,
					focusOnSelect: !0,
					infinite: !1,
					prevArrow: '<span class="fa fa-angle-up slick-prev-arrow"></span>',
					nextArrow: '<span class="fa fa-angle-down slick-next-arrow"></span>',
				}), T.imagesLoaded(function () {
					T.addClass('loaded');
				});
			});
		},
		_initForceHeight() {
			$(this.selectors.productPreviewMainImages).length > 0 && $(this.selectors.productPreviewMainImages).not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: !1,
				prevArrow: '<span class="fa fa-angle-left slick-prev-arrow"></span>',
				nextArrow: '<span class="fa fa-angle-right slick-next-arrow"></span>',
			});
		},
		htmlEntities(S) {
			return (`${S}`).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		},
		_initVariants() {
			const S = {
				$container: this.$container,
				enableHistoryState: this.$container.data('enable-history-state') || !1,
				singleOptionSelector: this.selectors.singleOptionSelector,
				originalSelectorId: this.selectors.originalSelectorId,
				product: this.productSingleObject,
			};
			this.variants = new slate.Variants(S), this.$container.on(`variantChange${this.settings.namespace}`, this._updateAddToCart.bind(this)), this.$container.on(`variantImageChange${this.settings.namespace}`, this._updateImages.bind(this)), this.$container.on(`variantPriceChange${this.settings.namespace}`, this._updatePrice.bind(this)), this.$container.on(`variantSKUChange${this.settings.namespace}`, this._updateSKU.bind(this));
		},
		_updateAddToCart(S) {
			const T = S.variant;
			T ? ($(this.selectors.productPrices).removeClass('invisible').attr('aria-hidden', 'true'), $('.variations_button').removeClass('hide'), T.available ? ($(this.selectors.addToCart).prop('disabled', !1).toggleClass('hide', !1), $(this.selectors.addToCart).val(theme.strings.addToCart), $(this.selectors.stockText).html(theme.strings.inStock).removeClass('out-of-stock unavailable').addClass('in-stock'), T.inventory_management == 'shopify' && T.inventory_policy != 'continue' && (T.inventory_quantity > 0 && parseInt(theme.inventory) == 1 ? $(this.selectors.stockText).html(`${T.inventory_quantity} ${theme.strings.inStock}`) : $(this.selectors.stockText).html(theme.strings.inStock))) : ($(this.selectors.addToCart).prop('disabled', !0).toggleClass('hide', !1), $(this.selectors.addToCart).val(theme.strings.soldOut), $(this.selectors.stockText).html(theme.strings.outStock).removeClass('in-stock unavailable').addClass('out-of-stock'))) : ($('.variations_button').addClass('hide'), $(this.selectors.addToCart).prop('disabled', !0).toggleClass('hide', !0), $(this.selectors.addToCart).val(theme.strings.unavailable), $(this.selectors.stockText).html(theme.strings.unavailable).removeClass('in-stock').addClass('out-of-stock unavailable'), $(this.selectors.productPrices).addClass('invisible').attr('aria-hidden', 'false'));
		},
		_updateImages(S) {
			const T = S.variant;
			const P = this;
			const I = this.settings.product_design;
			const A = T.featured_image.src.replace('https:', '').replace('http:', '').split('?v=')[0];
			console.log(1), $(this.selectors.productFeaturedImage).each(function () {
				const N = $(this);
				const L = N.attr('href');
				if (L.indexOf(A) >= 0 && !N.closest('.slick-slide').hasClass('slick-cloned')) {
					console.log(3);
					const q = $(P.selectors.productMainImages);
					const M = N.closest('.slick-slide').attr('data-slick-index');
					if (console.log(`pos: ${M}`), I == 'carousel' ? q.slick('slickGoTo', M) : (console.log(4), q.slick('slickGoTo', M, !0)), I == 'scroll') {
						const O = parseInt(N.closest('.shopify-product-gallery__image').offset().top) - 50;
						$('html,body').animate({
							scrollTop: O,
						}, 'slow');
					}
					return void(I == 'gallery' && $('.thumbnails .thumbnail-gallery-item').length > 0 && $('.thumbnails .thumbnail-gallery-item').each(function () {
						const F = $(this).data('href');
						F.indexOf(A) >= 0 && $(this).trigger('click');
					}));
				}
			});
		},
		_updatePrice(S) {
			const T = S.variant;
			if ($(this.selectors.originalPrice).html(`<span class="money">${theme.Currency.formatMoney(T.price, theme.settings.moneyFormat)}</span>`), T.compare_at_price > T.price) {
				if ($(this.selectors.productPrices).addClass('has-sale'), $(this.selectors.productPrices).removeClass('not-sale'), $(this.selectors.comparePrice).html(`<span class="money">${theme.Currency.formatMoney(T.compare_at_price, theme.settings.moneyFormat)}</span>`).removeClass('hide'), $(this.selectors.saleLabel).find('span').text(theme.strings.sale), theme.sale_percentages != '') {
					const P = Math.round(100 * (T.compare_at_price - T.price) / T.compare_at_price);
					$(this.selectors.saleLabel).find('span').text(`-${P}%`);
				}
				$(this.selectors.saleLabel).addClass('hide');
			} else $(this.selectors.productPrices).removeClass('has-sale'), $(this.selectors.productPrices).addClass('not-sale'), $(this.selectors.comparePrice).addClass('hide'), $(this.selectors.saleLabel).addClass('hide');
			theme.CurrencyPicker.convert(`${this.selectors.product} .money`);
		},
		_updateSKU(S) {
			const T = S.variant;
			T.sku == '' ? $(this.selectors.SKU).addClass('hide') : $(this.selectors.SKU).removeClass('hide').find('.sku').text(T.sku);
		},
		onUnload() {
			this.$container.off(this.settings.namespace);
		},
	}), y;
}());

theme.Filters = (function () {
	function y() {
		$(P.filter).length && ($(P.fiterTarget).html(''), $(P.filter).clone().appendTo(P.fiterTarget), $('.offcanvas_shop_sidebar').fitVids());
	}

	function S(I) {
		const A = this.$container = $(I);
		this.$filterSelect = $(P.filter, A), this.$sortSelect = $(P.sortSelection, A), this.$viewSelect = $(P.defaultView, A), this.$filterClear = $(P.filterClear, A), y(), $(document).on('change', P.viewSelection, this._onViewChange.bind(this)), $(document).on('change', P.sortSelection, this._onSortChange.bind(this)), $(document).on('change', P.filterSelection, this._onFilterChange.bind(this)), $(document).on('click', P.filterClear, this._onFilterClear.bind(this));
	}
	var P = {
		sortSelection: '.filters-toolbar__input--sort',
		defaultSort: '.collection-header__default-sort',
		viewSelection: '.filters-toolbar__input--view',
		defaultView: '.collection-header__default-view',
		filter: '.shop-page #secondary',
		fiterTarget: '.offcanvas_aside_left .offcanvas_shop_sidebar .widget-area',
		filterSelection: '.mfilter-content .filter',
		filterClear: '.mfilter-content .clear',
	};
	return S.prototype = _.assignIn({}, S.prototype, {
		_filterAjaxClick(I) {
			delete Shopify.queryParams.page;
			const A = this._filterCreateUrl(I);
			this._filterGetContent(A);
		},
		_filterCreateUrl(I) {
			const A = $.param(Shopify.queryParams).replace(/%2B/g, '+');
			return I ? A == '' ? I : `${I}?${A}` : `${location.pathname}?${A}`;
		},
		_filterGetContent(I) {
			const A = '#mfilter-content-container';
			const z = '.mfilter-box .mfilter-content';
			const N = this;
			$.ajax({
				type: 'get',
				url: I,
				beforeSend() {
					roar.destroyCountdown(), $('body').addClass('is_loading').removeClass('open_filter');
				},
				success(L) {
					const q = $(L).filter('title').text();
					$(A).empty().html($(L).find(A).html()), $(z).empty().html($(L).find(z).html()), roar.mapPaginationCallback(), History.pushState({
						param: Shopify.queryParams,
					}, q, I), setTimeout(function () {
						$('html,body').animate({
							scrollTop: $('body #sandbox').offset().top,
						}, 500, 'swing');
					}, 100), $('body').removeClass('is_loading'), N._mapReviews();
				},
				error() {
					$('body').removeClass('is_loading');
				},
			});
		},
		_mapReviews() {
			typeof SPR !== 'undefined' && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
		},
		_onFilterClear(I) {
			let A = [];
			Shopify.queryParams.constraint && (A = Shopify.queryParams.constraint.split('+'));
			const z = $(I.currentTarget);
			const N = z.closest('.column').find('input:checked');
			N.length > 0 && N.each(function () {
				const L = $(this).val();
				if (L) {
					const q = A.indexOf(L);
					q >= 0 && A.splice(q, 1);
				}
			}), A.length ? Shopify.queryParams.constraint = A.join('+') : delete Shopify.queryParams.constraint, this._filterAjaxClick();
		},
		_onViewChange(I) {
			const A = $(I.currentTarget);
			const z = $(P.defaultView, this.$container).val();
			const N = A.val() ? A.val() : z;
			Shopify.queryParams.view = N, this._filterAjaxClick();
		},
		_onSortChange(I) {
			const A = $(I.currentTarget);
			const z = $(P.defaultSort, this.$container).val();
			const N = A.val() ? A.val() : z;
			Shopify.queryParams.sort_by = N, this._filterAjaxClick();
		},
		_onFilterChange(I) {
			const A = $(I.currentTarget);
			const z = A.closest('.column').attr('data-multi_choice');
			let N = [];
			if (Shopify.queryParams.constraint && (N = Shopify.queryParams.constraint.split('+')), z == 'false' && !A.closest('.field').hasClass('active')) {
				const L = A.closest('.column').find('input:checked');
				L.length > 0 && L.each(function () {
					const O = $(this).val();
					if (O) {
						const F = N.indexOf(O);
						F >= 0 && N.splice(F, 1);
					}
				});
			}
			const q = A.val();
			if (q) {
				console.log(N);
				const M = N.indexOf(q);
				M >= 0 ? (console.log(q), N.splice(M, 1)) : N.push(q);
			}
			N.length ? Shopify.queryParams.constraint = N.join('+') : delete Shopify.queryParams.constraint, this._filterAjaxClick();
		},
		onUnload() {
			this.$sortSelect.off('change', this._onSortChange), this.$filterSelect.off('change', this._onFilterChange), this.$filterClear.off('click', this._onFilterClear);
		},
	}), S;
}());

theme.MegaMenuSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.MegaMenu = $(`#megamenu-${P}`), this.megaMenuNamspace = `#megamenu-${P}`, this.megaMenuId = $(`#shopify-section-${P}`), $('.section-megamenu-content').length > 0 && $('.section-megamenu-content').each(function () {
			const A = $(this).data('menu_width_class');
			$(this).closest('.shopify-section').length > 0 && (!$(this).closest('.shopify-section').hasClass(A) && $(this).closest('.shopify-section').addClass(A), $(this).closest('.shopify-section').removeClass('hidden'));
		}), $('#header-phantom .shopify-section').length > 0 && $('#header-phantom .shopify-section').each(function () {
			$(this).removeClass('shopify-section');
		}), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			this._products(), this._handleMegaMenu(), this._handleVermenuCategory();
		},
		_products() {
			$('.products-carousel-megamenu').length > 0 && $('.products-carousel-megamenu').each(function () {
				const S = $(this).data('_id');
				const T = $(this).data('_one');
				const P = $(this).data('_two');
				const I = $(this).data('_three');
				const A = $(this).data('_four');
				const z = $(`#productsCarousel${S}`);
				z.not('.slick-initialized').slick({
					arrows: !1,
					slidesToShow: A,
					slidesToScroll: A,
					responsive: [{
						breakpoint: 1920,
						settings: {
							slidesToShow: A,
							slidesToScroll: A,
						},
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: I,
							slidesToScroll: I,
						},
					}, {
						breakpoint: 480,
						settings: {
							slidesToShow: P,
							slidesToScroll: P,
						},
					}],
					rtl: window.rtl,
				}), $(`.productsCarousel${S}_next`).click(function () {
					return z.slick('slickNext'), !1;
				}), $(`.productsCarousel${S}_prev`).click(function () {
					return z.slick('slickPrev'), !1;
				}), $(window).resize(function () {
					z.slick('setPosition');
				});
			});
		},
		_handleVermenuCategory() {
			if ($('#vermenu_cat_gap').length && roar.getWidthBrowser() >= 992 && $('.container-megamenu.vertical .megamenu-wrapper').length > 0) {
				const S = $('.container-megamenu.vertical .megamenu-wrapper').outerHeight();
				const T = $('.container-megamenu.vertical .megamenu-wrapper').offset().top;
				const P = $('#sidebar').offset().top;
				$('#vermenu_cat_gap').css('height', S - (P - T));
			}
		},
		_handleMegaMenu() {
			const S = this._handleVermenuCategory();
			window.megamenu_responsive_design == 'yes' && $(window).width() < 992 && (window.megamenu_responsive = !0), $('ul.megamenu > li').each(function () {
				let T = 0;
				$(this).find('.mobile-enabled').each(function () {
					T++;
				}), T == 0 && $(this).find('.open-menu').addClass('mobile-disabled');
			}), $('ul.megamenu li .sub-menu .content .hover-menu ul li').hover(function () {
				$(this).children('ul').addClass('active');
			}, function () {
				$(this).children('ul').removeClass('active');
			}), $('.close-categories').unbind('click'), $('.close-categories').on('click', function () {
				return $(this).parent().removeClass('active'), $(this).next().animate({
					height: 'hide',
				}, 400), !1;
			}), $('.open-categories').unbind('click'), $('.open-categories').on('click', function () {
				return $('.open-categories').parent().removeClass('active'), $('.open-categories').next().next().animate({
					height: 'hide',
				}, 400), $(this).parent().addClass('active'), $(this).next().next().animate({
					height: 'show',
				}, 400), !1;
			}), $('.close-menu').unbind('click'), $('.close-menu').on('click', function () {
				return $(this).parent().removeClass('active'), $(this).next().next().next()
					.animate({
						height: 'hide',
					}, 400), !1;
			}), $('.open-menu').unbind('click'), $('.open-menu').on('click', function () {
				return $('ul.megamenu > li').removeClass('active'), $('ul.megamenu > li').find('.sub-menu').animate({
					height: 'hide',
				}, 400), $(this).parent().addClass('active'), $(this).next().next().animate({
					height: 'show',
				}, 400), $(window).trigger('resize'), window.megamenu_responsive = !0, !1;
			}), $('ul.megamenu > li.click .content a').unbind('click'), $('ul.megamenu > li.click .content a').click(function () {
				window.location = $(this).attr('href');
			}), jQuery(window).resize(function () {
				$('ul.megamenu > li.hover').hover(function () {
					if (window.megamenu_responsive == 0) {
						if (window.megamenu_active = $(this), window.megamenu_hover = !0, $('ul.megamenu > li').removeClass('active'), $(this).addClass('active'), window.rtl) {
							$(this).children('.sub-menu').css('right', 'auto'), $(this).children('.sub-menu').css('left', 'auto');
							var T = $(this).children('.sub-menu');
							var P = T.offset().left;
							var I = $('.horizontal ul.megamenu');
							var A = I.offset().left - 45;
							A > P && $(this).children('.sub-menu').css('left', '0');
						} else {
							$(this).children('.sub-menu').css('right', 'auto');
							var T = $(this).children('.sub-menu');
							var offsetT = 0;
							if (T.length > 0) {
								offsetT = (T.offset().left + T.outerWidth());
							}
							var P = $(window).width() - offsetT;

							if ($('.header-type-3').length || $('.header-type-30').length) {
								var I = $('#top .container');
								var A = $(window).width() - (I.offset().left + I.outerWidth());
							} else {
								var I = $('.overflow-megamenu');
								var A = $(window).width() - (I.offset().left + I.outerWidth());
							}
							A > P && $(this).children('.sub-menu').css('right', '0');
						}
						var contentOffset = 0;
						if ($(this).find('.content').length > 0){
							contentOffset = $(this).find('.content').offset().left
						}
						const z = $(this).children('a').outerWidth() / 2;
						const N = $(this).children('a').offset().left - contentOffset;
						$(this).find('.content > .arrow').css('left', N + z);
					}
				}, function () {
					if (window.megamenu_responsive == 0) {
						const T = $(this).attr('title');
						if (window.megamenu_hover = !1, T == 'hover-intent') {
							const P = $(this);
							setTimeout(function () {
								window.megamenu_hover == 0 && $(P).removeClass('active');
							}, 500);
						} else $(this).removeClass('active');
					}
				});
			}).resize(), $('ul.megamenu > li.click').unbind('click'), $('ul.megamenu > li.click').click(function () {
				if ($(this).removeClass('active') == 1) return !1;
				if (window.megamenu_active = $(this), window.megamenu_hover = !0, $('ul.megamenu > li').removeClass('active'), $(this).addClass('active'), window.megamenu_responsive == 1 && $(this).children('.sub-menu').animate({
						height: 'show',
					}, 400), window.rtl) {
					$(this).children('.sub-menu').css('right', 'auto'), $(this).children('.sub-menu').css('left', 'auto');
					var T = $(this).children('.sub-menu');
					var P = T.offset().left;
					var I = $('.horizontal ul.megamenu');
					var A = I.offset().left - 45;
					A > P && $(this).children('.sub-menu').css('left', '0');
				} else {
					$(this).children('.sub-menu').css('right', 'auto');
					var T = $(this).children('.sub-menu');
					var P = $(window).width() - (T.offset().left + T.outerWidth());

					if ($('.header-type-3').length) {
						var I = $('#top .container');
						var A = $(window).width() - (I.offset().left + I.outerWidth());
					} else {
						var I = $('.overflow-megamenu');
						var A = $(window).width() - (I.offset().left + I.outerWidth());
					}
					A > P && $(this).children('.sub-menu').css('right', '0');
				}
				const z = $(this).children('a').outerWidth() / 2;
				const N = $(this).children('a').offset().left - $(this).find('.content').offset().left;
				return $(this).find('.content > .arrow').css('left', N + z), !1;
			}), $('.categories-image-right ul > li > a').hover(function () {
				$(this).closest('.categories-image-right').find('img').attr('src', $(this).attr('data-image'));
			}, function () {
				const T = $(this).closest('.categories-image-right').attr('data-image');
				$(this).closest('.categories-image-right').find('img').attr('src', T);
			}), $('.megaMenuToggle').unbind('click'), $('.megaMenuToggle').click(function () {
				return $(this).removeClass('active') == 1 ? $(this).parent().find('.megamenu-wrapper').stop(!0, !0)
					.animate({
						height: 'hide',
					}, 400) : ($(this).parent().find('.megamenu-wrapper').stop(!0, !0)
						.animate({
							height: 'toggle',
						}, 400), $(this).addClass('active')), !1;
			}), $('html').unbind('click'), $('html').on('click', function () {
				window.megamenu_responsive_design == 'yes' && $(window).width() < 992 || $('ul.megamenu > li.click').removeClass('active');
			}), S, $(window).resize(function () {
				window.megamenu_responsive = !1, window.megamenu_responsive_design == 'yes' && $(window).width() < 992 && (window.megamenu_responsive = !0), S;
			}), roar.initLazyLoading('.section-megamenu-content', !0);
		},
		onUnload() {
			this.$container.off(this.megaMenuNamspace);
		},
		onSelect() {
			$(`${this.megaMenuNamspace} .product-grid.rich-banner`).length > 0 && roar.initCountdown();
		},
		onBlockSelect() {},
		onBlockDeselect() {},
	}), y;
}());

theme.TopBlockSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.topBlockId = $(`#shopify-section-${P}`), this.topBlock = $(`#top-block-${P}`), this.topBlockNamspace = `#top-block-wrapper-${P}`, this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {},
		onUnload() {
			this.$container.off(this.topBlockNamspace);
		},
	}), y;
}());

theme.productCustomers = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.customWidgetId = $(`#shopify-section-${P}`), this.customWidgetNamspace = `#product-customers-${P}`, this.placement_fullwidth = $(this.customWidgetNamspace).data('placement_fullwidth'), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			if (this.placement_fullwidth == '1' && !window.sidebar) {
				const S = this.sectionId;
				onFullWidthOption(S);
			}
			const T = this.customWidgetId.find('.slider-content');
			let ST = 4;
			let arrowMobile = true;
			let centerPaddingMobile = '45px';
			let prevArrow = '<span class=\"slick-arrow-custom slick-prev-arrow\"><svg><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#global__symbols-left-arrow\"></use></svg></span>';
    		let nextArrow = '<span class=\"slick-arrow-custom slick-next-arrow\"><svg><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#global__symbols-right-arrow\"></use></svg></span>';
			if ($('.homepage-ab-running').length || $('.template-product-type-two').length) {
				centerPaddingMobile = '45px';
				prevArrow = '<span class=\"slick-arrow-custom slick-prev-arrow\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.182\" height=\"18.121\"><path d=\"M10.121 1.061l-8 8 8 8\" fill=\"none\" stroke=\"#ff6ea9\" stroke-width=\"3\"/></svg></span>';
        		nextArrow = '<span class=\"slick-arrow-custom slick-next-arrow\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.182\" height=\"18.121\"><path d=\"M1.061 1.061l8 8-8 8\" fill=\"none\" stroke=\"#ff6ea9\" stroke-width=\"3\"/></svg></span>';
			}

			T.find('.customer-item').length > 1 && T.slick({
				centerMode: true,
				centerPadding: '100px',
				slidesToShow: ST,
				dots: true,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [{
						breakpoint: 1360,
						settings: {
							arrows: arrowMobile,
							centerMode: !0,
							centerPadding: '40px',
							slidesToShow: 4,
						},
					},
					{
						breakpoint: 800,
						settings: {
							arrows: arrowMobile,
							centerMode: !0,
							centerPadding: '40px',
							slidesToShow: 2,
						},
					},
					{
						breakpoint: 1100,
						settings: {
							arrows: arrowMobile,
							centerMode: !0,
							centerPadding: '40px',
							slidesToShow: 3,
						},
					},

					{
						breakpoint: 480,
						settings: {
							arrows: arrowMobile,
							dots: false,
							centerMode: true,
							centerPadding: centerPaddingMobile,
							slidesToShow: 1,
						},
					}
				],
			});
		},
		onUnload() {
			this.$container.off(this.customWidgetNamspace);
		},
	}), y;
}());

theme.CollectionCustom = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.customWidgetId = $(`#shopify-section-${P}`), this.customWidgetNamspace = `#custom-collection-${P}`, this.placement_fullwidth = $(this.customWidgetNamspace).data('placement_fullwidth'), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			if (this.placement_fullwidth == '1' && !window.sidebar) {
				const S = this.sectionId;
				onFullWidthOption(S);
			}
		},
		onUnload() {
			this.$container.off(this.customWidgetNamspace);
		},
	}), y;
}());

theme.CustomWidgetSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.customWidgetId = $(`#shopify-section-${P}`), this.customWidgetNamspace = `#custom-widget-${P}`, this.placement_fullwidth = $(this.customWidgetNamspace).data('placement_fullwidth'), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			if (this.placement_fullwidth == '1' && !window.sidebar) {
				const S = this.sectionId;
				onFullWidthOption(S);
			}
		},
		onUnload() {
			this.$container.off(this.customWidgetNamspace);
		},
	}), y;
}());

theme.DeliveryBarSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.deliveryBarId = $(`#shopify-section-${P}`), this.deliveryBar = $(`#delivery-bar-${P}`), this.deliveryBarNamspace = `#delivery-bar-${P}`, this.placement_fullwidth = $(this.deliveryBarNamspace).data('placement_fullwidth'), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			if (this.placement_fullwidth == '1' && !window.sidebar) {
				const S = this.sectionId;
				onFullWidthOption(S);
			}
		},
		onUnload() {
			this.$container.off(this.deliveryBarNamspace);
		},
	}), y;
}());

theme.SlideShowSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.slideShowId = $(`#shopify-section-${P}`), this.slideShow = $(`#home-slider-${P}`), this.slideShowNamspace = `#home-slider-${P}`, this.option = {
			slider_auto: this.slideShow.data('slider_auto'),
			slider_interval: this.slideShow.data('slider_interval'),
			slider_scale: this.slideShow.data('slider_scale'),
			slider_auto_height: this.slideShow.data('slider_auto_height'),
			slider_height: this.slideShow.data('slider_height'),
			slider_align_top: this.slideShow.data('slider_align_top'),
			is_header_slider: this.slideShow.data('is_header_slider'),
			full_width: this.slideShow.data('full_width'),
			is_megamenu: this.slideShow.data('is_megamenu'),
		}, this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			if (this.option.is_header_slider == '1' && (this.option.slider_align_top == '1' ? $('.templateIndex').addClass('slider-align-top') : $('.templateIndex').removeClass('slider-align-top')), this._handleSlideshow(), this._initResize(), this.option.full_width == '1' && !window.sidebar) {
				const S = this.sectionId;
				onFullWidthOption(S);
			}
			this.option.is_megamenu == '1' && this._handleMegaMenu();
		},
		_handleVermenuCategory() {
			if ($('#vermenu_cat_gap').length && roar.getWidthBrowser() >= 992 && $('.container-megamenu.vertical .megamenu-wrapper').length > 0) {
				const S = $('.container-megamenu.vertical .megamenu-wrapper').outerHeight();
				const T = $('.container-megamenu.vertical .megamenu-wrapper').offset().top;
				const P = $('#sidebar').offset().top;
				$('#vermenu_cat_gap').css('height', S - (P - T));
			}
		},
		_handleMegaMenu() {
			const S = this._handleVermenuCategory();
			window.megamenu_responsive_design == 'yes' && $(window).width() < 992 && (window.megamenu_responsive = !0), $('ul.megamenu > li').each(function () {
				let T = 0;
				$(this).find('.mobile-enabled').each(function () {
					T++;
				}), T == 0 && $(this).find('.open-menu').addClass('mobile-disabled');
			}), $('ul.megamenu li .sub-menu .content .hover-menu ul li').hover(function () {
				$(this).children('ul').addClass('active');
			}, function () {
				$(this).children('ul').removeClass('active');
			}), $('.close-categories').unbind('click'), $('.close-categories').on('click', function () {
				return $(this).parent().removeClass('active'), $(this).next().animate({
					height: 'hide',
				}, 400), !1;
			}), $('.open-categories').unbind('click'), $('.open-categories').on('click', function () {
				return $('.open-categories').parent().removeClass('active'), $('.open-categories').next().next().animate({
					height: 'hide',
				}, 400), $(this).parent().addClass('active'), $(this).next().next().animate({
					height: 'show',
				}, 400), !1;
			}), $('.close-menu').unbind('click'), $('.close-menu').on('click', function () {
				return $(this).parent().removeClass('active'), $(this).next().next().next()
					.animate({
						height: 'hide',
					}, 400), !1;
			}), $('.open-menu').unbind('click'), $('.open-menu').on('click', function () {
				return $('ul.megamenu > li').removeClass('active'), $('ul.megamenu > li').find('.sub-menu').animate({
					height: 'hide',
				}, 400), $(this).parent().addClass('active'), $(this).next().next().animate({
					height: 'show',
				}, 400), $(window).trigger('resize'), window.megamenu_responsive = !0, !1;
			}), $('ul.megamenu > li.click .content a').unbind('click'), $('ul.megamenu > li.click .content a').click(function () {
				window.location = $(this).attr('href');
			}), $('ul.megamenu > li.hover').hover(function () {
				if (window.megamenu_responsive == 0) {
					if (window.megamenu_active = $(this), window.megamenu_hover = !0, $('ul.megamenu > li').removeClass('active'), $(this).addClass('active'), window.rtl) {
						$(this).children('.sub-menu').css('right', 'auto'), $(this).children('.sub-menu').css('left', 'auto');
						var T = $(this).children('.sub-menu');
						var P = T.offset().left;
						var I = $('.horizontal ul.megamenu');
						var A = I.offset().left - 45;
						A > P && $(this).children('.sub-menu').css('left', '0');
					} else {
						$(this).children('.sub-menu').css('right', 'auto');
						var T = $(this).children('.sub-menu');

						var P = $(window).width() - (T.offset().left + T.outerWidth());
						if ($('.header-type-3').length) {
							var I = $('#top .container');
							var A = $(window).width() - (I.offset().left + I.outerWidth());
						} else {
							var I = $('.overflow-megamenu');
							var A = $(window).width() - (I.offset().left + I.outerWidth());
						}
						A > P && $(this).children('.sub-menu').css('right', '0');
					}
					const z = $(this).children('a').outerWidth() / 2;
					const N = $(this).children('a').offset().left - $(this).find('.content').offset().left;
					$(this).find('.content > .arrow').css('left', N + z);
				}
			}, function () {
				if (window.megamenu_responsive == 0) {
					const T = $(this).attr('title');
					if (window.megamenu_hover = !1, T == 'hover-intent') {
						const P = $(this);
						setTimeout(function () {
							window.megamenu_hover == 0 && $(P).removeClass('active');
						}, 500);
					} else $(this).removeClass('active');
				}
			}), $('ul.megamenu > li.click').unbind('click'), $('ul.megamenu > li.click').click(function () {
				if ($(this).removeClass('active') == 1) return !1;
				if (window.megamenu_active = $(this), window.megamenu_hover = !0, $('ul.megamenu > li').removeClass('active'), $(this).addClass('active'), window.megamenu_responsive == 1 && $(this).children('.sub-menu').animate({
						height: 'show',
					}, 400), window.rtl) {
					$(this).children('.sub-menu').css('right', 'auto'), $(this).children('.sub-menu').css('left', 'auto');
					var T = $(this).children('.sub-menu');
					var P = T.offset().left;
					var I = $('.horizontal ul.megamenu');
					var A = I.offset().left - 45;
					A > P && $(this).children('.sub-menu').css('left', '0');
				} else {
					$(this).children('.sub-menu').css('right', 'auto');
					var T = $(this).children('.sub-menu');
					var P = $(window).width() - (T.offset().left + T.outerWidth());

					if ($('.header-type-3').length) {
						var I = $('#top .container');
						var A = $(window).width() - (I.offset().left + I.outerWidth());
					} else {
						var I = $('.overflow-megamenu');
						var A = $(window).width() - (I.offset().left + I.outerWidth());
					}
					A > P && $(this).children('.sub-menu').css('right', '0');
				}
				const z = $(this).children('a').outerWidth() / 2;
				const N = $(this).children('a').offset().left - $(this).find('.content').offset().left;
				return $(this).find('.content > .arrow').css('left', N + z), !1;
			}), $('.categories-image-right ul > li > a').hover(function () {
				$(this).closest('.categories-image-right').find('img').attr('src', $(this).attr('data-image'));
			}, function () {
				const T = $(this).closest('.categories-image-right').attr('data-image');
				$(this).closest('.categories-image-right').find('img').attr('src', T);
			}), $('.megaMenuToggle').unbind('click'), $('.megaMenuToggle').click(function () {
				return $(this).removeClass('active') == 1 ? $(this).parent().find('.megamenu-wrapper').stop(!0, !0)
					.animate({
						height: 'hide',
					}, 400) : ($(this).parent().find('.megamenu-wrapper').stop(!0, !0)
						.animate({
							height: 'toggle',
						}, 400), $(this).addClass('active')), !1;
			}), $('html').unbind('click'), $('html').on('click', function () {
				window.megamenu_responsive_design == 'yes' && $(window).width() < 992 || $('ul.megamenu > li.click').removeClass('active');
			}), S, $(window).resize(function () {
				window.megamenu_responsive = !1, window.megamenu_responsive_design == 'yes' && $(window).width() < 992 && (window.megamenu_responsive = !0), S;
			});
		},
		_handleSlideshow() {
			let S;
			let T;
			let P;
			let I;
			let A;
			let z;
			let N;
			let
				L;
			if (this.slideShow.length) {
				const q = this.slideShow;
				S = q.data('afx-head'), T = q.data('afx-cap'), P = q.data('afx-cta'), I = q.data('afx-sticker'), A = q.data('dfx-head'), z = q.data('dfx-cap'), N = q.data('dfx-cta'), L = q.data('dfx-sticker');
			}
			let D;
			const M = this.slideShowNamspace;
			const O = this.option.slider_auto;
			const F = this.option.slider_interval;
			const E = this.option.slider_scale;
			const B = this;
			this.slideShow.length && (D = this.slideShow.flexslider({
				animation: 'fade',
				prevText: '',
				nextText: '',
				controlNav: !1,
				directionNav: !1,
				slideshowSpeed: F,
				slideshow: O,
				controlNav: !1,
				start() {
					jQuery('body').removeClass('loading'), jQuery(`${M} ul.slides h2.caption-content`).css('opacity', '0'), jQuery(`${M} ul.slides .real-caption`).css('opacity', '0'), jQuery(`${M} ul.slides .caption-link`).css('opacity', '0'), jQuery(`${M} ul.slides .slide-sticker-wrapper img`).css('opacity', '0'), jQuery(`${M} ul.slides li:nth-child(1) h2.caption-content`).css('opacity', '1.0').addClass(`rt-animated ${S}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${S}`);
					}), jQuery(`${M} ul.slides li:nth-child(1) .real-caption`).css('opacity', '1.0').addClass(`rt-animated ${T}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${T}`);
					}), jQuery(`${M} ul.slides li:nth-child(1) .caption-link`).css('opacity', '1.0').addClass(`rt-animated ${P}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${P}`);
					}), jQuery(`${M} ul.slides li:nth-child(1) .slide-sticker-wrapper img`).css('opacity', '1.0').addClass(`rt-animated ${I}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${I}`);
					});
				},
				after(U) {
					const W = parseInt(U.currentSlide, 10) + 1;
					jQuery(`${M} ul.slides li:nth-child(${W}) h2.caption-content`).css('opacity', '1.0').addClass(`rt-animated ${S}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${S}`);
					}), jQuery(`${M} ul.slides li:nth-child(${W}) .real-caption`).css('opacity', '1.0').addClass(`rt-animated ${T}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${T}`);
					}), jQuery(`${M} ul.slides li:nth-child(${W}) .caption-link`).css('opacity', '1.0').addClass(`rt-animated ${P}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${P}`);
					}), jQuery(`${M} ul.slides li:nth-child(${W}) .slide-sticker-wrapper img`).css('opacity', '1.0').addClass(`rt-animated ${I}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${I}`);
					});
				},
				before(U) {
					const W = parseInt(U.currentSlide, 10) + 1;
					jQuery(`${M} ul.slides li:nth-child(${W}) h2.caption-content`).addClass(`rt-animated ${A}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${A}`).css('opacity', '0');
					}), jQuery(`${M} ul.slides li:nth-child(${W}) .real-caption`).addClass(`rt-animated ${z}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${z}`).css('opacity', '0');
					}), jQuery(`${M} ul.slides li:nth-child(${W}) .caption-link`).addClass(`rt-animated ${N}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${N}`).css('opacity', '0');
					}), jQuery(`${M} ul.slides li:nth-child(${W}) .slide-sticker-wrapper img`).addClass(`rt-animated ${L}`).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$(this).removeClass(`rt-animated ${L}`).css('opacity', '0');
					});
				},
			}), imagesLoaded(M, function () {
				E ? B._mockupCaptionSlider2() : B._mockupCaptionSlider();
			})), this.slideShow.find('.flex-direction-nav .flex-next').click(function (U) {
				return U.preventDefault(), U.stopPropagation(), D.flexslider('next'), !1;
			}), this.slideShow.find('.flex-direction-nav .flex-prev').click(function (U) {
				return U.preventDefault(), U.stopPropagation(), D.flexslider('prev'), !1;
			});
		},
		_mockupCaptionSlider2() {
			if (this.slideShow.length) {
				const S = this.slideShowNamspace;
				const T = roar.getWidthBrowser();
				$(`${S} .slide-body`).each(T < 1200 ? function () {
					const P = $(this).data('height');
					$(this).css({
						height: P * T / 1200,
					});
				} : function () {
					const P = $(this).data('height');
					$(this).css({
						height: P,
					});
				}), $(`${S} .caption-content`).each(T < 1200 ? function () {
					const P = $(this).data('min');
					const I = $(this).data('max');
					let A = I * T / 1200;
					P > A && (A = P), $(this).css({
						'font-size': A,
					});
				} : function () {
					const P = $(this).data('max');
					$(this).css({
						'font-size': P,
					});
				});
			}
		},
		_mockupCaptionSlider() {
			if (this.slideShow.length) {
				const S = this.slideShowNamspace;
				const T = this.option.slider_auto_height;
				const P = this.option.slider_height;
				const I = roar.getWidthBrowser();
				if (I < 767 && T == 0 && P > 0) {
					$(`${S} .slide-body`).css('height', P * I / 1200);
				}
				I >= 767 && T == 0 && P > 0 && $(`${S} .slide-body`).css('height', P), $(`${S} .caption-content`).each(I < 767 ? function () {
					const z = $(this).data('min');
					const N = $(this).data('max');
					let L = N;
					N > 50 && (L = 50), z > L && (L = z), $(this).css({
						'font-size': L,
					});
				} : function () {
					const z = $(this).data('max');
					$(this).css({
						'font-size': z,
					});
				});
			}
		},
		_initResize() {
			const S = this.option.slider_scale;
			const T = this;
			jQuery(window).resize(function () {
				S ? T._mockupCaptionSlider2() : T._mockupCaptionSlider();
			});
		},
		onUnload() {
			this.$container.off(this.slideShowNamspace);
		},
	}), y;
}());

theme.SidebarSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.sideBarId = $(`#shopify-section-${P}`), this.sideBar = $(`#sidebar-${P}`), this.sideBarNamspace = `#sidebar-${P}`, this.tabSideBar = $(`.tab-filter-tabs${P} a`), this.tabItem = $(`.procduct_tab_item-${P}`), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			const S = this;
			this.tabItem.length > 0 && this.tabItem.each(function () {
				const T = {
					_tabcount: $(this).data('_tabcount'),
					_ptab_carousel: $(this).data('_ptab_carousel'),
					_id: $(this).data('_id'),
				};
				parseInt(T._tabcount) > 0 ? (S._initTab(), T._ptab_carousel && S._initMultiSlide(T), S._initMultiSlides(T)) : (T._ptab_carousel && S._initSlide(T), S._initSlides(T));
			});
		},
		_initTab() {
			this.tabSideBar.each(function () {
				$(this).click(function (S) {
					S.preventDefault(), $(this).tab('show');
				});
			});
		},
		_initSlide(S) {
			const T = $(`.box #myCarousel${S._id} .carousel-inner`);
			$(`#myCarousel${S._id}_next`).click(function () {
				return T.trigger('next.owl.carousel'), !1;
			}), $(`#myCarousel${S._id}_prev`).click(function () {
				return T.trigger('prev.owl.carousel'), !1;
			}), T.owlCarousel({
				slideSpeed: 500,
				items: 1,
				rtl: window.rtl,
			});
		},
		_initSlides(S) {
			const T = $(`.box #myCarousel${S._id}s .carousel-inner`);
			T.owlCarousel({
				slideSpeed: 500,
				rtl: window.rtl,
				responsive: {
					0: {
						items: 1,
					},
					320: {
						items: 1,
					},
					479: {
						items: 1,
					},
					767: {
						items: 1,
					},
					979: {
						items: 1,
					},
					1199: {
						items: 1,
					},
				},
			}), $(`#myCarousel${S._id}s_next`).click(function () {
				return T.trigger('next.owl.carousel'), !1;
			}), $(`#myCarousel${S._id}s_prev`).click(function () {
				return T.trigger('prev.owl.carousel'), !1;
			});
		},
		_initMultiSlide(S) {
			const T = $(`.filter-product #myCarousel${S._id} .carousel-inner`);
			$(`#myCarousel${S._id}_next`).click(function () {
				return T.trigger('next.owl.carousel'), !1;
			}), $(`#myCarousel${S._id}_prev`).click(function () {
				return T.trigger('prev.owl.carousel'), !1;
			}), T.owlCarousel({
				slideSpeed: 500,
				items: 1,
				rtl: window.rtl,
			});
		},
		_initMultiSlides(S) {
			const T = $(`.filter-product #myCarousel${S._id}s .carousel-inner`);
			$(`#myCarousel${S._id}s_next`).click(function () {
				return T.trigger('next.owl.carousel'), !1;
			}), $(`#myCarousel${S._id}s_prev`).click(function () {
				return T.trigger('prev.owl.carousel'), !1;
			}), T.owlCarousel({
				slideSpeed: 500,
				rtl: window.rtl,
				responsive: {
					0: {
						items: 1,
					},
					320: {
						items: 1,
					},
					479: {
						items: 1,
					},
					767: {
						items: 1,
					},
					979: {
						items: 1,
					},
					1199: {
						items: 1,
					},
				},
			});
		},
		onUnload() {
			this.$container.off(this.sideBarNamspace);
		},
	}), y;
}());

theme.ProductTabSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.productTabId = $(`#shopify-section-${P}`), this.productTab = $(`#product-tab-${P}`), this.productTabNamspace = `#product-tab-${P}`, this.tabProductTabVertical = $(`.tab-filter-tabs-vertical-${P} a`), this.tabProductTab = $(`.tab-filter-tabs-${P} a`), this.tabItem = $(`.product-tab-item-${P}`), this._tabcount = this.productTab.data('_tabcount'), this.placement_fullwidth = this.productTab.data('placement_fullwidth'), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			const S = this;
			const T = this._tabcount;
			if (this.tabItem.length > 0 && this.tabItem.each(function () {
					const I = {
						_tabcount: T,
						_ptab_carousel: $(this).data('_ptab_carousel'),
						_id: $(this).data('_id'),
						_nextpage: $(this).data('_nextpage'),
						_itemsperpage: $(this).data('_itemsperpage'),
						_limit: parseInt($(this).data('_limit'), 10),
						_colclass: $(this).data('_colclass'),
						_catid: $(this).data('_catid'),
						_all_loaded: !1,
						_loaded_count: parseInt($(this).data('_itemsperpage'), 10),
					};
					S._initTab(), S._initMultiSlide(I);
				}), this.placement_fullwidth == '1' && !window.sidebar) {
				const P = this.sectionId;
				onFullWidthOption(P);
			}
		},
		_initTab() {
			this.tabProductTab.length > 0 && this.tabProductTab.each(function () {
				$(this).click(function (S) {
					S.preventDefault(), $(this).tab('show');
				});
			}), this.tabProductTabVertical.length > 0 && this.tabProductTabVertical.each(function () {
				$(this).click(function (S) {
					S.preventDefault(), $(this).tab('show');
				});
			});
		},
		_initMultiSlide(S) {
			let T = 1;
			let P = 0;
			if (S._ptab_carousel) {
				const I = $(`.filter-product #myCarousel${S._id}`);
				const A = $(`.filter-product #myCarousel${S._id} .carousel-inner`);
				A.slick({
					autoplaySpeed: 500,
					rtl: window.rtl,
					slidesToShow: 1,
					arrows: !1,
					infinite: !1,
				}), A.on('reInit ', function (z, N) {
					T = N.slideCount;
				}), A.on('afterChange', function (z, N) {
					P = N.currentSlide;
				}), $(`#myCarousel${S._id}_next`).click(function () {
					return T == P + 1 && S._catid != '' && !1 == S._all_loaded && S._loaded_count < S._limit ? (console.log('There we go...'), I.addClass('b-loading'), $.ajax({
						url: `/collections/${S._catid}`,
						type: 'get',
						dataType: 'html',
						data: {
							view: 'customlim',
							limit: `${S._itemsperpage}a${S._colclass}`,
							page: S._nextpage,
						},
						success(z) {
							const N = z.trim();
							if (N == '') S._all_loaded = !0;
							else {
								const L = $(N);
								const q = `row-${S._id}-${S._nextpage}`;
								let M = L.find('.row').first().attr('id', q).children();
								if (S._loaded_count + M.length <= S._limit) ++S._nextpage, S._loaded_count += M.length;
								else {
									for (let O = S._loaded_count + M.length - S._limit, F = 0; F < O; F++) M.last().remove(), M = L.find('.row').first().children();
									S._loaded_count = S._limit;
								}
								A.slick('slickAdd', L[0].outerHTML), A.slick('slickNext'), roar.initCountdown(), roar.initLazyLoading(`#${q}`, !0), window.show_multiple_currencies && theme.CurrencyPicker.convert('#sandbox .money');
							}
							I.removeClass('b-loading');
						},
						error() {
							console.log('Something went wrong');
						},
					}), !1) : (A.slick('slickNext'), !1);
				}), $(`#myCarousel${S._id}_prev`).click(function () {
					return A.slick('slickPrev'), !1;
				});
			}
		},
		onUnload() {
			this.$container.off(this.productTabNamspace);
		},
	}), y;
}());

theme.AdvancedGridSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.advancedGridId = $(`#shopify-section-${P}`), this.advancedGrid = $(`#advanced-grid-${P}`), this.advancedGridNamspace = `#advanced-grid-${P}`, this._ag_bgtype = this.advancedGrid.data('_ag_bgtype'), this._ag_fullwidth = this.advancedGrid.data('_ag_fullwidth'), this._agProductsCarousel = $(`.myProductsCarousel-${P}`), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			if (this._ag_fullwidth && !window.sidebar) {
				const S = this.sectionId;
				onFullWidthOption(S);
			}
			this._ag_bgtype == '2' && this._initParalax(), this._initProductTab(), this._initProductsSlide(), this._initCountdown();
		},
		_initCountdown() {
			$('.ag_product_countdown').length > 0 && $('.ag_product_countdown').each(function () {
				const S = parseInt($(this).data('offer_date_year'));
				const T = parseInt($(this).data('offer_date_month'));
				const P = parseInt($(this).data('offer_date_day'));
				const I = new Date();
				const A = new Date(S, T - 1, P);
				I < A ? $(this).countdown({
					until: A,
				}) : $(this).hide();
			});
		},
		_initParalax() {
			const S = this.sectionId;
			$(`.advanced-grid-${S} .parallax-window`).scrolly({
				bgParallax: !0,
			});
		},
		_initProductsSlide() {
			this._agProductsCarousel.length > 0 && this._agProductsCarousel.each(function () {
				const S = $(this);
				const T = S.data('_skin_type');
				const P = S.data('_id');
				T == 'sportwinter' ? S.owlCarousel({
					slideSpeed: 500,
					items: 1,
					rtl: window.rtl,
				}) : S.owlCarousel({
					responsive: {
						0: {
							items: window.pitem_row,
						},
						320: {
							items: window.pitem_row,
						},
						479: {
							items: 2,
						},
						767: {
							items: 3,
						},
						979: {
							items: 4,
						},
						1199: {
							items: 5,
						},
					},
					rtl: window.rtl,
				}), $(`#myCarousel${P}_next`).click(function () {
					return S.trigger('next.owl.carousel'), !1;
				}), $(`#myCarousel${P}_prev`).click(function () {
					return S.trigger('prev.owl.carousel'), !1;
				});
			});
		},
		_initProductTab() {
			const S = this.sectionId;
			const T = this;
			$(`.ag-products-tabs-${S}`).each(function () {
				const P = $(this).data('_tabcount');
				const I = $(this).data('_block_id');
				T._initTab(I), T._initMultiSlide(I);
			});
		},
		_initTab(S) {
			$(`.tab-filter-tabs-${S}`).length > 0 && $(`.tab-filter-tabs-${S} a`).each(function () {
				$(this).click(function (T) {
					T.preventDefault(), $(this).tab('show');
				});
			});
		},
		_initMultiSlide(S) {
			$(`.ag-product-tab-item-${S}`).length > 0 && $(`.ag-product-tab-item-${S}`).each(function () {
				const T = $(this).data('_pid');
				const P = $(this).data('_acm_carousel');
				const I = $(this).data('_catid');
				let A = $(this).data('_nextpage');
				const z = $(this).data('_itemsperpage');
				const N = parseInt($(this).data('_limit'), 10);
				const L = $(this).data('_colclass');
				let q = !1;
				let M = parseInt($(this).data('_itemsperpage'), 10);
				let O = 1;
				let F = 0;
				if (P) {
					const E = $(`.filter-product #myCarousel${T}`);
					const B = $(`.filter-product #myCarousel${T} .carousel-inner`);
					B.slick({
						autoplaySpeed: 500,
						rtl: window.rtl,
						slidesToShow: 1,
						arrows: !1,
						infinite: !1,
					}), B.on('reInit ', function (D, U) {
						O = U.slideCount;
					}), B.on('afterChange', function (D, U) {
						F = U.currentSlide;
					}), $(`#myCarousel${T}_next`).click(function () {
						return O == F + 1 && I != '' && !1 == q && M < N ? (E.addClass('b-loading'), $.ajax({
							url: `/collections/${I}`,
							type: 'get',
							dataType: 'html',
							data: {
								view: 'customlim',
								limit: `${z}a${L}`,
								page: A,
							},
							success(D) {
								const U = D.trim();
								if (U == '') q = !0;
								else {
									const W = $(U);
									const H = `row-${T}-${A}`;
									let V = W.find('.row').first().attr('id', H).children();
									if (M + V.length <= N) ++A, M += V.length;
									else {
										for (let G = M + V.length - N, R = 0; R < G; R++) V.last().remove(), V = W.find('.row').first().children();
										M = N;
									}
									B.slick('slickAdd', W[0].outerHTML), B.slick('slickNext'), roar.initCountdown(), roar.initLazyLoading(`#${H}`, !0), window.show_multiple_currencies && theme.CurrencyPicker.convert('#sandbox .money');
								}
								E.removeClass('b-loading');
							},
							error() {
								console.log('Something went wrong');
							},
						}), !1) : (B.slick('slickNext'), !1);
					}), $(`#myCarousel${T}_prev`).click(function () {
						return B.slick('slickPrev'), !1;
					});
				}
			});
		},
		onUnload() {
			this.$container.off(this.advancedGridNamspace);
		},
	}), y;
}());

theme.FooterCopyRightSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.footerCopyRightId = $(`#shopify-section-${P}`), this.footerCopyRight = $(`#footer-copyright-${P}`), this.footerCopyRightNamspace = `#footer-copyright-${P}`, this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {},
		onUnload() {
			this.$container.off(this.footerCopyRightNamspace);
		},
	}), y;
}());

theme.mobileNavSection = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.mobileNavId = $(`#shopify-section-${P}`), this.mobileNav = $(`#primary-${P}`), this.mobilenavNamespace = `#primary-${P}`, this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			this._initMobile();
		},
		_initMobile() {
			$('.mobile-nav-icon, .close-wrapper-x, .nav-overlay').on('click', function () {
				$(document.body).toggleClass('open-canvas-panel');
				if ($(document.body).hasClass('open-canvas-panel')) {
					console.log('mobile menu open')
    			hj('trigger', 'sm_mega_menu');
					if ($('.current-currency-flag').length && !$('.current-currency-flag').hasClass('lazyloaded')) {
						$('.current-currency-flag').addClass('lazyload');
					}
				}
			}), $('.mobile-child-menu').on('click', function () {
				const S = $(this).closest('.menu-item-has-children');
				S.toggleClass('mobile-active');
			}), $('.mobile-nav-search, .mobile-nav-search-close').on('click', function () {
				$(document.body).toggleClass('open-search-form'), $('.mobile-nav-search-form input').focus();
			}), $(window).on('resize', function () {
				$(window).width() > 991 && $(document.body).removeClass('open-canvas-panel');
			}), $('input[name=sequence-nav-1]').on('change', function(e) {
				$('input[name=sequence-nav-1]').not($(this)).siblings('ul').slideUp(300)
			  if ($(this).siblings('ul').css('display') == 'none') {
				  $(this).siblings('ul').slideDown(300)
				} else {
					$(this).siblings('ul').slideUp(300)
				}
			});
		},
		onUnload() {
			this.$container.off(this.mobilenavNamespace);
		},
	}), y;
}());

theme.ProductVariantMobile = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.wrapperId = $(`#${P}`), this.wrapper = $(`#${P}`), this.wrapperNamspace = `#${P}`, this.addCartId = $(`#btn-${P}.m-allow-cart`), this.addCartClass = $(`.variant-item-${P}.m-allow-cart`), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			const S = this;
			S._initScroll(), S._initCompact(), S._initEvents(), $(window).resize(function () {
				$(window).width() <= 991 && S._initCompact();
			});
		},
		_initScroll() {
			$(window).on('scroll', function () {
				const S = $('#shopify-section-product-variants-mobile').height();
				$(window).scrollTop() > S ? $(document.body).addClass('sticky-product-variants-mobile') : ($(document.body).removeClass('sticky-product-variants-mobile'), $('.product-variants-mobile').hasClass('active') && $('.product-variants-mobile').height($('.variants-header').data('height')));
			});
		},
		_initCompact() {
			if ($('.product-variant-mobile-section').length > 0) {
				const S = $('.product-variant-mobile-section');
				const T = $('.product-variants-mobile');
				T.each(function () {
					const P = $(this);
					const I = P.find('.variants-header');
					const A = I.innerHeight();
					const z = P.find('.variants-content').outerHeight();
					const N = I.closest('.product-variants-mobile');
					I.data('height', A), P.data('height', A + z);
				}), T.each(function () {
					const P = $(this);
					const I = P.find('.variants-header');
					const A = I.innerHeight();
					const z = P.find('.variants-content').outerHeight();
					const N = I.closest('.product-variants-mobile');
					I.data('height', A), P.data('height', A + z), N.hasClass('active') && N.height(N.data('height'));
				}), S.unbind('click') && S.on('click', '.variants-header .title', function () {
					const P = $(this);
					const I = P.closest('.variants-header');
					const A = P.closest('.product-variants-mobile');
					A.hasClass('active') || T.closest('.active').removeClass('active').height(P.data('height')), A.toggleClass('active'), A.hasClass('active') ? A.height(A.data('height')) : A.height(I.data('height'));
				});
			}
		},
		_initEvents() {
			const S = $('#ProductSelect-product-template.variation-select').val();
			this.addCartId.length > 0 && (this.addCartId.unbind('click'), this.addCartId.on('click', function () {
				$('#ProductSelect-product-template.variation-select').val(S), $('#AddToCart-product-template').trigger('click');
			})), this.addCartClass.length > 0 && (this.addCartClass.unbind('click'), this.addCartClass.on('click', function () {
				const T = $(this).data('id');
				$('#ProductSelect-product-template.variation-select').val(T), $('#AddToCart-product-template').trigger('click');
			}));
		},
		onUnload() {
			this.$container.off(this.wrapperNamspace);
		},
	}), y;
}());

theme.Brands = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.brandsId = $(`#brands-${P}`), this.featuredBrands = $(`.featured-brands-${P}`), this.brandsNamspace = `#brands-${P}`, this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			const S = this.featuredBrands.data('perview');
			const T = this.featuredBrands.data('autoplay');
			const P = this.featuredBrands.data('speed');
			let I = !1;
			T == '1' && (I = !0), this.featuredBrands.not('.slick-initialized').slick({
				rtl: window.rtl,
				slidesToShow: S,
				slidesToScroll: 1,
				autoplaySpeed: P,
				autoplay: T,
				infinite: !0,
				prevArrow: '<a class="prev-button arrow-btn" href="#"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-prev"></use></svg></a>',
				nextArrow: '<a class="next-button arrow-btn" href="#"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-next"></use></svg></a>',
				responsive: [{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
					},
				}, {
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				}],
			});
		},
		onUnload() {
			this.$container.off(this.brandsNamspace);
		},
	}), y;
}());

theme.CollectionsList = (function () {
	function y(S) {
		const T = this.$container = $(S);
		const P = this.sectionId = T.attr('data-section-id');
		const I = T.attr('data-section-type');
		this.latestCollectionId = $(`#shopify-section-${P}`), this.latestCollectionNamspace = $(`.collections-list-${P}`), this._limit = this.latestCollectionNamspace.data('limit'), this._total = this.latestCollectionNamspace.data('count'), this._speed = this.latestCollectionNamspace.data('speed'), this._autoplay = this.latestCollectionNamspace.data('autoplay'), this.placement_fullwidth = this.latestCollectionNamspace.data('placement_fullwidth'), this._init();
	}
	return y.prototype = _.assignIn({}, y.prototype, {
		_init() {
			const S = this.sectionId;
			const T = `.content-colection-list-${this.sectionId}`;
			roar.initLazyLoading(T, !0), $(T).slick({
				slidesToShow: this._limit,
				slidesToScroll: 1,
				autoplay: this._autoplay,
				autoplaySpeed: this._speed,
				prevArrow: '<a class="prev-button arrow-btn" href="#"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-prev"></use></svg></a>',
				nextArrow: '<a class="next-button arrow-btn" href="#"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#global__symbols-next"></use></svg></a>',
				rtl: window.rtl,
				responsive: [{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				}, {
					breakpoint: 469,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				}],
			});
		},
		onUnload() {
			this.$container.off(this.latestCollectionNamspace);
		},
	}), y;
}());

$(document).ready(function () {
	// Open product tab on page load
	const { hash } = window.location;
	if (hash != '') {
		const tab = $(`.tab-heading[href='${hash}']`);
		if (tab.length > 0) {
			setTimeout(() => {
				tab.trigger('click');
				$('html, body').animate({
					scrollTop: tab.offset().top - (window.innerWidth <= 768 ? 100 : 250),
				}, 'slow');
			}, 200);
		}
	}

	$('#dropdown-product-selector').on('click', function(obj) {
		console.log('open', obj)
		$('.pair-selector').toggleClass('open')
	})

	$('.pair-selector li[data-handle]').on('click', function(obj) {
        const handle = $(obj.target).data('handle')
        const category = $(obj.target).data('category')
        const title = $(obj.target).text()
        let price = 0
        if ($('.pair-selector').data('price')) {
        	price = parseInt($('.pair-selector').data('price'))
        }

        let c_price = 0
        if ($('.pair-selector').data('compare-price')) {
        	c_price = parseInt($('.pair-selector').data('compare-price'))
        }

        $('.pair-selector').toggleClass('open')
        $('.category-rounded').hide()
        $('.category-select').hide()
        $('.category-select.'+category).show()
        $('#dropdown-product-selector').text(title)
        $('#dropdown-product-selector').css({color:'#222222', fontStyle: 'normal'})

        jQuery.getJSON('/products/'+handle+'.js', function(product) {
        	const main_product_var_id = $('.pair-selector').data('id')
        	const main_product_new_compare_price = parseInt($('.pair-selector').data('price'))
        	const main_product_new_price = parseInt($('.pair-selector').data('new-price'))

        	const pair_product_new_compare_price = product.compare_at_price || 0
        	const pair_product_new_price = product.price

        	const subtotal = pair_product_new_price + main_product_new_price
        	const oldsubtotal = main_product_new_compare_price + pair_product_new_price
        	const savings = oldsubtotal - subtotal

			$('#main-selected-cross-price').text(theme.Currency.formatMoney(main_product_new_compare_price, theme.settings.moneyFormat))
		  	$('#main-selected-price').text(theme.Currency.formatMoney(main_product_new_price, theme.settings.moneyFormat))
		  	console.log(product)
		  	$('#pair-selected-title').text(product.title)

		  	$.ajax({
			    type: 'GET',
			    url: `/products/28-day-ultimate-teatox?view=metafields`,
			    success: function(response) {
			      let htmld = $(response).find('.review')
			      $('#stars-price__stars').html(htmld)
			    },
			    error: function(status) {
			      console.warn('ERROR', status);
			    }
			  });
		  	if (pair_product_new_compare_price > 0) {
		  		$('#pair-selected-cross-price').text(theme.Currency.formatMoney(pair_product_new_compare_price, theme.settings.moneyFormat))
		  	}
		  	$('#pair-selected-price').text(theme.Currency.formatMoney(pair_product_new_price, theme.settings.moneyFormat))

		  	$('#pair-selected-img').attr('src', product.featured_image)

		  	$('#summary__savings').text('SAVINGS: -'+theme.Currency.formatMoney(savings, theme.settings.moneyFormat))
		  	$('#summary__subtotal').text('SUBTOTAL: '+theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat))
		  	$('.col--cta').show()

		  	var metaUrl = '/admin/products/632910392/metafields.json';
				$.getJSON(metaUrl, function(data) {
					console.log(data);
				});

		  	$('#add-pair-cta').off().on('click', function() {
				const data = {
					items: [
						{
							id: product.variants[0].id,
							quantity: 1
						},
						{
							id: main_product_var_id,
							quantity: 1
						}
					]
				}
				smCart._addCart(data, false, function() {
					console.log('add BB guides')
				}, function(resp) {
			      smCart.checkCampaign();
			    }, function() {
			      $('.cart-notification').slideDown('fast', function () {
	                setTimeout(function () {
	                  $('.cart-notification').slideUp('fast');
	                }, 5000);
	              });
			    }, function() {
			      console.log('add error')
			    })
			})
		});
	})
	$('#to-pairing-section').on('click', function() {
		$('html,body').animate({
			scrollTop: parseInt($('#shopify-section-two-columns-pairing').offset().top - 50)
		})
	});

	//ab test product page new design
	var store = window.location.hostname.split(".")[0].replace("www", "us");
	store = store == 'skinnymint' ? 'us' : store;
	if (store == 'us' && window.location.href.includes('detox-cherry-bomb')) {
		var variations = false;
		var intValCounter = 0;
		var checkVariant = setInterval(function(){
			intValCounter++;
			if ($('body').hasClass('template-product-type-two')) {
				variations = true;
				clearInterval(checkVariant);
			}
			if (intValCounter >= 20) {
				clearInterval(checkVariant);
			}
		}, 500);

		setTimeout(function(){
			if (typeof hj === 'function') {
				if (!variations) {
					hj('trigger', 'dcb_original');
					console.log('hj-original trigger');
				}
			}
			clearInterval(checkVariant);
		}, 2500);
	}

});

$(function(){
 function handleClickMyAccountPopup(){
   $(".navigation-close").click(function(){
     $(".navigation-close").closest('.dropdown.open').removeClass('open');
   });
 }

 function openRegistrationForm(){
  $(".dropdown-menu #popup_customer_login").hide();
  $(".dropdown-menu #popup_create_customer").removeClass('hide');
}

function checkZopim(){
  setTimeout(function(){
    if(typeof zE !== "undefined"){
      zE(function(){
        $zopim(function() {
          $zopim.livechat.departments.filter('SkinnyMint');
          $zopim.livechat.departments.setVisitorDepartment('SkinnyMint');
        });
      });
    } else {
      checkZopim();
    }
  }, 500)
}

function productDescriptionTab() {
  $(".product-description-tabs li a").on('click', function(e) {
    var target = $(this).attr('data-target');
    $(".product-description-tabs .nav-link").removeClass('active')
    $(".product-description-tabs .accordion-tabs-content .tab-pane").removeClass('active')
    $(target).addClass('active');
    $(".product-description-tabs a[data-target='"+target+"']").addClass('active')
  });
}
productDescriptionTab()

function productBannerTab() {
  $(".banner-tabs li a").on('click', function(e) {
    var target = $(this).attr('data-target');
    $(".banner-content .nav-link").removeClass('active')
    $(".banner-content .tab-pane").removeClass('active')
    $(target).addClass('active');
    $(".banner-content a[data-target='"+target+"']").addClass('active')
  });
  if (window.matchMedia("(max-width: 768px)").matches) {
    $(".tabs-banner-features .tab-content").slick({
      infinite: true,
      dots: true,
      centerMode: true,
      slidesToShow: 1,
      centerPadding: '40px',
      arrows: false
    })
  }

}
productBannerTab()

function tabHandle(){
 $(".box-additional-content ul.nav-tabs li a").click(function(){
  var target = $(this).attr('href');
  $(".box-additional-content ul.nav-tabs li").removeClass('active');
  $(this).parent().addClass('active');
  $(".box-additional-content .tab-content .tab-pane").removeClass('active');
  if ($(".tab-select-mobile").length){
    txt = $(".tab-select-mobile li.select-list ul li[data-id='"+target+"']").text();
    $("ul.tab-select-mobile li.selected-active span").text(txt);
  }
  $(target).addClass('active');
});
 $(".tab-selection-for-mobile").change(function(){
  var target = $(this).val();
  $(".box-additional-content ul.nav-tabs li").removeClass('active');
  $(".box-additional-content ul.nav-tabs li a[href='"+target+"']").parent().addClass('active');
  $(".box-additional-content .tab-content .tab-pane").removeClass('active').show();
  $(target).addClass('active');
});

 $("ul.tab-select-mobile li.selected-active").off('click').on('click', function(){
  if($(this).hasClass('expanded')){
    $(this).removeClass('expanded');
  }else{
    $(this).addClass('expanded');
  }
});

 $("ul.tab-select-mobile li.select-list ul li").off('click').on('click', function(){
  id = $(this).attr('data-id');
  $("ul.tab-select-mobile li.selected-active").removeClass('expanded');
  txt = $(this).text();
  $("ul.tab-select-mobile li.selected-active span").text(txt);
  $(".tab-selection-for-mobile").val(id);
  $(".tab-selection-for-mobile").change();
});

 $(".box-additional-content ul.nav-tabs li a:first").click();
}

function slickVideo() {
  $(".box-video-images").slick({
    rtl: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: "<a class=\"prev-button arrow-btn\" href=\"#\"><i class='fa fa-angle-left'></i></a>",
    nextArrow: "<a class=\"next-button arrow-btn\" href=\"#\"><i class='fa fa-angle-right'></i></a>",
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }]
  });
  $(".box-video-images .videos-img").click(function(){
    var vid = $(this).attr('data-video');
    var yurl = vid + "?autoplay=1";
    $("#ytplayer").attr('src', yurl);
  });
}

function handleBadgeReview(){
  $("#ProductSection-product-template .review").click(function(){
    var S = $(".product-reviews #judgeme_product_reviews").offset().top - 100;
    $("html,body").animate({
      scrollTop: S
    }, 500, "swing");
  });
}

function promoteHtml(){
  var content = '<div class="product product-content-wrapper clearfix product-hover product-item-advanced-wrapper quickshop-type-advanced-wrapper dots" data-_dim="_"> \
  <div class="left"> \
  <img src="https://cdn.shopify.com/s/files/1/0088/7632/6976/products/SingleCocoa-SKU.jpg?v=1544873318"> \
  </div> \
  <div class="product-item-content"> \
  <div class="name"><a href="/products/28-day-fat-burning-hot-chocolate"><span>28 Day Fat Burning Hot Chocolate</span></a> \
  </div> \
  <div class="product-item-rating">\
  </div> \
  <div class="action-cart"> \
  <div class="cart-subscribe"> \
  <div class="price" data-price=""> \
  <span class="price-new black"></span>\
  <span class="price-old" style="display: none;"></span>\
  </div> \
  </div> \
  <form action="/cart/add" method="post" enctype="multipart/form-data"> \
  <input type="hidden" name="quantity" value="1"> \
  <button type="submit" class="button  addtocart-item-js add-to-cart" data-loading-text="Adding..." title="Add to cart"><span>Add to cart</span></button> \
  <input type="hidden" name="id" value="18152730492992"> \
  </form> \
  </div> \
  </div> \
  </div>';
  return content;
}

window.cartPromote = function() {
  if (window.cart_promote && $("#cartPromote").length) {
    if ($('.promote-product').length == 0 && $(".cart-window .empty").length) {
      $(".cart-window").append("<div class='cart-window-body'><div class='promote-product false'>"+promoteHtml()+"</div></div>");
    } else {
      $(".promote-product").html(promoteHtml());
    }
    var badges = JSON.parse($("#metafieldsData").html());
    var sjson = $("#cartPromote").html();
    var prod = JSON.parse(sjson);
    var badge = badges.badges[prod.id];
    var el = $(".promote-product");
    var variant = prod.variants[0];
    var price = money_format.replace("\{\{amount\}\}", variant.price);
    $(el).find(".left img").attr('src', prod.images[0].src);
    $(el).find(".name a").text(prod.title).attr('href', '/products/'+prod.handle);
    $(el).find(".price-new").text(price);
    if (badge) {
      $(el).find(".product-item-rating").html(badge);
    } else {
      var htmlBadge = '<div class="jdgm-rev-widg__summary"> \
      <div class="jdgm-rev-widg__summary-stars"><a class="jdgm-star jdgm--off"></a><a class="jdgm-star jdgm--off"></a><a class="jdgm-star jdgm--off"></a><a class="jdgm-star jdgm--off"></a><a class="jdgm-star jdgm--off"></a></div> \
      <div class="jdgm-rev-widg__summary-text">No reviews</div> \
      </div>';
      $(el).find(".product-item-rating").html(htmlBadge);
    }

    if (variant.compare_at_price) {
      var old_price = money_format.replace("\{\{amount\}\}", variant.compare_at_price);
      $(el).find(".price-new").removeClass('black');
      $(el).find(".price-old").show();
      $(el).find(".price-old").text(old_price);
    } else {
      $(el).find(".price-old").hide();
      $(el).find(".price-new").addClass('black');
    }
    if (variant.available) {
      $(".promote-product.false").show();
      var btn = $(el).find(".action-cart .add-to-cart");
      $(el).find("input[name='id']").val(variant.id);
      $(btn).removeAttr('disabled');
      $(btn).find("span").text($(btn).attr("title"));
    } else {
      $(".promote-product.false").hide();
    }
  }
}

window.getPin = function(){
  $(".promote-product.false").hide().html('');
  var badges = JSON.parse($("#metafieldsData").html());
  $.getJSON('/collections/all/products.json')
  .then(function(data){
    if ($('.promote-product').length == 0 && $(".cart-window .empty").length) {
      $(".cart-window").append("<div class='cart-window-body'><div class='promote-product false'>"+promoteHtml()+"</div></div>");
    } else {
      $(".promote-product").html(promoteHtml());
    }

    var i = Math.floor(Math.random() * data.products.length)
    var prod = data.products[i];
    var badge = badges.badges[prod.id];
    var el = $(".promote-product");
    var variant = prod.variants[0];
    var price = money_format.replace("\{\{amount\}\}", variant.price);
    $(el).find(".left img").attr('src', prod.images[0].src);
    $(el).find(".name a").text(prod.title).attr('href', '/products/'+prod.handle);
    $(el).find(".price-new").text(price);
    if (badge) {
      $(el).find(".product-item-rating").html(badge);
    } else {
      var htmlBadge = '<div class="jdgm-rev-widg__summary"> \
      <div class="jdgm-rev-widg__summary-stars"><a class="jdgm-star jdgm--off"></a><a class="jdgm-star jdgm--off"></a><a class="jdgm-star jdgm--off"></a><a class="jdgm-star jdgm--off"></a><a class="jdgm-star jdgm--off"></a></div> \
      <div class="jdgm-rev-widg__summary-text">No reviews</div> \
      </div>';
      $(el).find(".product-item-rating").html(htmlBadge);
    }

    if (variant.compare_at_price) {
      var old_price = money_format.replace("\{\{amount\}\}", variant.compare_at_price);
      $(el).find(".price-new").removeClass('black');
      $(el).find(".price-old").show();
      $(el).find(".price-old").text(old_price);
    } else {
      $(el).find(".price-old").hide();
      $(el).find(".price-new").addClass('black');
    }
    if (variant.available) {
      $(".promote-product.false").show();
      var btn = $(el).find(".action-cart .add-to-cart");
      $(el).find("input[name='id']").val(variant.id);
      $(btn).removeAttr('disabled');
      $(btn).find("span").text($(btn).attr("title"));
    } else {
      $(".promote-product.false").hide();
    }
  })
  .fail(function(){
    $(".promote-product").remove();
      //this is where you could hard-code a fallback
    })
}

function handleVideoPlace(firstload) {
  var videosWrapper = $(".product-videos-wrapper");
  var newplace = $(".info-wrapper");
  var originalplace = $(".product-images-content");
  var width = window.innerWidth;
  if (width < 798) {
    $(videosWrapper).insertAfter(newplace);
  } else {
    if (!firstload) {
      $(videosWrapper).insertAfter(originalplace);
    }
  }
}

function handleTopCollection() {
  $(".collection-top .top-item").click(function(e){

    if ($(this).hasClass('no-scroll')) {
      window.location.href = $(this).find('a').attr('href');
    }

    if ($(this).hasClass('active') && false) {
      $(".collection-top .top-item").fadeIn('slow');
      console.log('test');
    } else {
      $(".collection-top .top-item").removeClass('active');
      $(this).addClass('active');
        //$(".collection-top .top-item").hide();
        //$(".collection-top .top-item.active").show();
        var targetId = $(this).find('a').attr('data-id');
        var targetUrl = $(this).find('a').attr('data-href');
        var fixedNav = 0;
        if ($('.mobile-coll-fixed').length > 0) {
          fixedNav = $('.mobile-coll-fixed').height();
        }
        var handle = $(this).find('a').attr('data-handle');
        var fixScroll = 0;
        if (handle == 'Bundles') {
          fixScroll = 30;
        }

        if (window.innerWidth >= 768) {
          $("html,body").animate({
            scrollTop: $(targetId).offset().top - ($('#header--main-content').height() + fixedNav + 50 + fixScroll)
          }, 500, "swing");
        } else {
          e.preventDefault();
          console.log('b1');
          window.location.href = targetUrl;
        }

      }
    })

  $('.nav-collection .top-item').click(function(){
    if ($(this).hasClass('no-scroll')) {
      window.location.href = $(this).find('a').attr('href');
    }
    if ($(this).hasClass('active')) {
        //$(".nav-collection .top-item").fadeIn('slow');
      } else {
        $(".nav-collection .top-item").removeClass('active');
        $(this).addClass('active');
        //$(".nav-collection .top-item").hide();
        //$(".nav-collection .top-item.active").show();
        var targetId = $(this).find('a').attr('data-id');
        var targetUrl = $(this).find('a').attr('data-href');

        if (window.innerWidth >= 768) {
          console.log('a2');
          $("html,body").animate({
            scrollTop: $(targetId).offset().top - ($('#header--main-content').height())
          }, 500, "swing");
        } else {
          console.log('b2');
          window.location.href = targetUrl;
        }

      }
    });
}

function movePlaceElementFooter(firstload) {
  var width = window.innerWidth;
  var el = $("#footer-column-footer-center-column1 .linklist.footer-accordion");
  var target = $("#footer-column-footer-center-column2 .html");
  if (width < 767) {
    $(el).insertAfter(target);
  } else {
    if ($("#footer-column-footer-center-column2 .linklist").length > 1){
      var els = $("#footer-column-footer-center-column2 .linklist").first();
      $("#footer-column-footer-center-column1").append(els);
    }
  }
}

function checkingCounter(count){
  setTimeout(function(){
    var w = window.innerWidth;

    if (count < 100) {
      if ($(".mp-instances").length && $(".mp-instances").children().length){
        var top = 90;
        if ($(".mp-position-top-floating").length){
          top = $(".mp-position-top-floating").height();
        } else if ($(".mp-position-top-fixed").length){
          top = $(".mp-position-top-fixed").height();
        }
        $("#primary-mobile-nav .header-main-block").addClass('top-counter');
        $("#primary-mobile-nav .mobile-nav-wrapper").addClass('top-counter');
        if (w < 798){
          $(".cart-window, .cart-window-bg").addClass("top-counter");
        }
      } else {
        checkingCounter(count + 1);
      }
    }
  }, 500);
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

$(".elixir-footer p").off('click').on('click', function(){
  if($(this).hasClass('expanded')) {
    $(".elixir-more-info").removeClass('expanded');
    $(this).removeClass('expanded');
  } else {
    $(".elixir-more-info").addClass('expanded');
    $(this).addClass('expanded');
  }
})

$(".waitlist-form .button-waitlist").off('click').on('click', function(){
  const country_name = getCookie('_shopify_country');
  const currentUrl = window.location.href;
  const email = $(".waitlist-form input[type='email']").val();
  const product = $(".waitlist-form input[type='email']").attr('data-product');
  const productHandle = $(".waitlist-form input[type='email']").attr('data-product-handle');
  const variantID = $(".waitlist-form input[type='email']").attr('data-variant');
  if (validateEmail(email)){
    $(".waitlist-product .error").css('display', 'none');
    if ($("[data-type-form='emarsys']").length > 0){
      emarsysSource = $("[data-type-form-source]").attr("data-type-form-source");
      url = `${window.apiEndpoint}/emarsys_api/meal_registration?email=${email}`;
      $.ajax({
        url: url,
        method: 'POST',
        beforeSend: function(){
          $(".waitlist-form button").text('Submit...');
        },
        complete: function() {
          const thanksTitle = $(".waitlist-product h3").data('title-thanks');
          const thanksDesc = $(".waitlist-product .caption").data("description-thanks");
          $(".waitlist-product h3").text(thanksTitle);
          $(".waitlist-product .caption").text(thanksDesc);
          $(".waitlist-product .sub-caption").hide();
          $(".waitlist-product .waitlist-form").hide();
        }
      })
    } else {
      $.ajax({
        url: "https://skinnymint.us7.list-manage.com/subscribe/post?u=2c7d533501239f3a3a2e25476&amp;id=b05380f9ea",
        cache: false,
        data: {
          "EMAIL": email,
          "COUNTRY": country_name,
          "PRODUCT": product,
          "URL": currentUrl
        },
        dataType: 'jsonp',
        contentType: 'application/json; charset=utf-8',
        beforeSend: function(){
          $(".waitlist-form button").text('Submit...');
          console.log('submitting')
        },
        complete: function(resp) {
          console.log('submited')
          console.log(resp)
          const thanksTitle = $(".waitlist-product h3").data('title-thanks');
          const thanksDesc = $(".waitlist-product .caption").data("description-thanks");
          $(".waitlist-product h3").text(thanksTitle);
          $(".waitlist-product .caption").text(thanksDesc);
          $(".waitlist-product .waitlist-form").hide();
        }
      })
    }

    data = {
      email: email,
      country: getCookie('_shopify_country'),
      brand: 'skinnymint',
      domain: window.location.hostname,
      product: productHandle
    }

    if (variantID) {
      data.variant = variantID;
    }

    $.post(`${window.apiEndpoint}/bluecore/waitlist.json`, data)
  } else {
    $(".waitlist-product .error").css('display', 'block');
  }
})

var updateCartButton = function () {
  var selected = $(".product-subscribe.selected");
  var varId = selected.data('subscribe-variant-id') || selected.find('.subscribe-checkbox').val();
  if (selected.find(".swatch-options").length > 0) {
    varId = selected.find('.sub-box-option.selected').data('variant-id');
  }
  var btn = selected.closest('.add_to_cart').find('.button-cart');
  var text = btn.data('addtocart');
  btn.removeAttr('disabled');

  if (window.preorderVariants.indexOf(`${varId}`) != -1) {
    console.log('is preorder');
    var text = btn.data('preorder');
  } else if (selected.hasClass('oos')) {
    var text = btn.data('soldout');
    btn.attr('disabled', 'disabled');
  }

  btn.text(text);
  if (document.body.dataset.url && varId) {
    window.history.replaceState({ }, '', `${document.body.dataset.url}?variant=${varId}`);
  }
}
updateCartButton();

$(".product-subscribe").off('click').on('click', function(){
      // if ($(this).hasClass('selected')) {
      //   return;
      // }

      $(".product-subscribe").removeClass('selected');
      $(this).addClass('selected');
      $(".product-subscribe .radio-check span").removeClass('checked').addClass('uncheck');
      $(this).find('.radio-check span').removeClass('uncheck').addClass('checked');
      $(this).find("input[type='radio']").prop('checked', true);

      if ($(this).hasClass("subscription-toggle")) {
        $(".recharge-input").each(function(){
          var sub = $(this).attr("data-subscription");
          var name = $(this).attr("data-name");
          $(this).val(sub);
          $(this).attr('name', name);
        });
      } else {
        $(".recharge-input").each(function(){
          $(this).val('');
          $(this).removeAttr('name');
        })
      }

      _this = $(this);

      setTimeout(function(){
        if (_this.find(".swatch-options").length && !_this.find(".swatch-options .selected").length) {
          changeSwatchVariant(_this.find(".swatch-options .sub-box-option:first-child"));
        }
        if (!_this.find(".swatch-options").length) {
          $(".swatch-options .sub-box-option").removeClass("selected");
        }
        radio = $(_this).find("input[type='radio']");
        qty = $(radio).attr('data-qty');
        // $(".variations_button input[name='quantity']").not(".QuantityInput").val(qty);
        updateCartButton();
      }, 200);

      updateCartButton();
    });

$(".sub-box-option").off('click').on('click', function(){
  changeSwatchVariant(this);
});

var qString = window.location.search;
var urlParam = new URLSearchParams(qString);
var urlVariant = urlParam.get('variant');
setTimeout(function() {
  $(".sub-box-option[data-variant-id="+urlVariant+"]").click();
  $(".product-subscribe[data-subscribe-variant-id="+urlVariant+"]").click();
}, 500);

function updateQueryString(key, value, url) {
  if (!url) url = window.location.href;

  let updated = ''
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"), hash;

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) {
      updated = url.replace(re, '$1' + key + "=" + value + '$2$3');
    }
    else {
      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1];
      }
      updated = url;
    }
  }
  else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = hash[0] + separator + key + '=' + value;
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1];
      }
      updated = url;
    }
    else {
      updated = url;
    }
  }

  window.history.replaceState({ path: updated }, '', updated);
}

function changeSwatchVariant(el) {
  $(".sub-box-option").removeClass('selected');
  variant_id = $(el).data('variant-id');
  image = $(el).data('variant-image');
  price = $(el).data('variant-price');
  intprice = $(el).data('variant-price-int');
  intpricecompare = $(el).data('variant-compare-price-int');
  qty = $(el).data('variant-qty');
  compare_price = $(el).data('variant-compare-price');
  parentElement = $(el).parent().closest('.product-subscribe-content.watches');
  if (parentElement) {
    cv = ((intprice)/100).toFixed(2);
    comparev = ((intpricecompare)/100).toFixed(2);
        //formattedP = theme.settings.moneyFormat.replace("\{\{amount\}\}",cv);
        //fix me
        if (window.cart_currency == 'USD') {
          formattedP = 'US$'+cv;
          formattedCP = 'US$'+comparev;
        } else if (window.cart_currency == 'SGD') {
          formattedP = 'SG$'+cv;
          formattedCP = 'SG$'+comparev;
        } else if (window.cart_currency == 'HKD') {
          formattedP = 'HK$'+cv;
          formattedCP = 'HK$'+comparev;
        } else if (window.cart_currency == 'MYR') {
          formattedP = 'RM'+cv;
          formattedCP = 'RM$'+comparev;
        }
        if (comparev == 0) {
          formattedCP = '';
        }
        if (window.use_mcp || window.cart_currency == 'USD') {
          parentElement.find(".variant-price").html(formattedP);
          parentElement.find(".variant-price").attr('data-price', intprice);
          parentElement.find(".variant-compare-price").html(formattedCP);
        } else {
          parentElement.find(".variant-price").html(price);
          parentElement.find(".variant-compare-price").html(compare_price);
        }

        if (!compare_price){
          parentElement.find(".variant-compare-price").parent().addClass('empty');
        } else {
          parentElement.find(".variant-compare-price").parent().removeClass('empty');
        }
        parentElement.find("input[type='radio']").attr('value', variant_id);
        parentElement.find("input[type='radio']").attr('data-qty', qty);
        parentElement.find(".image img.variant-image-src").attr('src', image);
      }
      $(el).addClass('selected');
    }

    function setCorrectDataSwatches() {
      var hasActiveElement = false;
      $(".swatch-options").each(function(){
        firstElement = $(this).find(".sub-box-option:first-child");
        parentElement = $(this).parent().closest('.product-subscribe');
        if (parentElement && !hasActiveElement && parentElement.hasClass('selected')) {
          hasActiveElement = true;
        }
        var qString = window.location.search;
        var urlParam = new URLSearchParams(qString);
        var urlVariant = urlParam.get('variant');
        if (!urlVariant) {
          changeSwatchVariant(firstElement);
        }
      });
      if (!hasActiveElement) {
        $(".sub-box-option.selected").removeClass('selected');
      }
    }
    setCorrectDataSwatches();

    var optCookie = getCookie('optin-popup');
    var uri = window.location.href;

    function loadYtIframe(){
      if ($("#youtube-iframe").length > 0) {
        $(".box-video-images").hide();
        setTimeout(function(){
          src = $("#youtube-iframe").data('src');
          $(".box-player").find("iframe").remove();
          iframe = '<iframe type="text/html" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" width="100%" height="280" data-src="'+src+'" frameborder="0" id="ytplayer" class="lazyload"></iframe>';
          $(iframe).insertAfter("#youtube-iframe");
          $("#youtube-iframe").remove();
          $(".box-video-images").show();
          slickVideo();
        }, 1000);
      }
    }
    loadYtIframe();
    handleVideoPlace(true);
    var resizeTimer;

    if (uri.indexOf('collections/all?collection=') != -1) {
      var url = new URL(uri);
      arrParams = url.search.split("=");
      b = arrParams[arrParams.length - 1];
      targetEl = decodeURI(b);
      setTimeout(function(){
        $(".top-item a span.title:contains('"+targetEl+"')").parent().click();
      }, 500);
    }

    $(window).on('resize', function(e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        handleVideoPlace();
        movePlaceElementFooter();
        fixBannerHeight();
        if (window.innerWidth < 991) {
          $("#pxu_cst").removeClass('fixed');
        }
        if (window.innerWidth > 1300) {
          var cur_width = window.innerWidth * (34.5 / 100);
          $('.rich-banners .slick-track.owl-stage').css('height', cur_width + 'px');
          $(".rich-banners#rich-banners-1550732998020").css('height', cur_width + 'px');
        }
      }, 500);
    });

    if (uri.indexOf('challenge') != -1){
      $("#popup-newsletter").addClass('hide');
      $(".templateProduct .variations_button .add-cart-wrapper").removeClass('shown-on-mobile');
    }else if(uri.indexOf('customer_posted') != -1){
      $("#popup-newsletter").addClass('hide');
      $(".templateProduct .variations_button .add-cart-wrapper").removeClass('shown-on-mobile');
      setCookie('optin-popup', 'true');
    } else {
      if (optCookie == 'true') {
        setTimeout(function(){
          $("#popup-newsletter").addClass('hide');
          $(".templateProduct .variations_button .add-cart-wrapper").removeClass('shown-on-mobile');
        }, 5000);
      }else{
        setTimeout(function(){
          $("#popup-newsletter").removeClass('hide');
        }, 5000);
        // $(".templateProduct .variations_button .add-cart-wrapper").addClass('shown-on-mobile');

        $("#popup-newsletter #popup-close-evt").click(function(){
          $("#popup-newsletter").addClass('hide');
          setCookie('optin-popup', 'true');
          $(".templateProduct .variations_button .add-cart-wrapper").removeClass('shown-on-mobile');
        });
      }
    }

    $("#popup-newsletter #mc-submit").click(function(){
      var email = $(this).find("input[type='email']").val();
      if (email) {
        $("#popup-newsletter").addClass('hide');
        $(".templateProduct .variations_button .add-cart-wrapper").removeClass('shown-on-mobile');
        setCookie('optin-popup', 'true');
      }
    })

    $("#mc-form").on("submit", function(){
      var email = $(this).find("input[type='email']").val();
      if (email) {
        $("#popup-newsletter").addClass('hide');
        $(".templateProduct .variations_button .add-cart-wrapper").removeClass('shown-on-mobile');
        setCookie('optin-popup', 'true');
      }
    });

    $("#create-account").click(function(){
      openRegistrationForm();
    });
    $(".myaccount-dropdown a.dropdown-toggle").click(function(){
     $(".dropdown-menu #popup_customer_login").show();
     $(".dropdown-menu #popup_create_customer").addClass('hide');
   })
    handleClickMyAccountPopup();
    // checkZopim();
    tabHandle();
    handleBadgeReview();
    cartPromote();
    $(".add-cart-wrapper-fixed button").click(function(){
      $(".product-info #product-form .add-to-cart").trigger('click');
    });

    $(".about-us-page .tab-select.mobile, .terms-conditions-page .tab-select.mobile").change(function(){
      var target = $(this).val();
      $(".about-us-page .nav-tabs li a[href='"+target+"'], .terms-conditions-page .nav-tabs li a[href='"+target+"']").click();
    });
    $(".about-us-page .nav-tabs li a, .terms-conditions-page .nav-tabs li a").click(function(){
      var target = $(this).attr('href');
      $(".about-us-page .tab-select.mobile, .terms-conditions-page .tab-select.mobile").val(target);
    });


    handleTopCollection();
    movePlaceElementFooter(true);

    // set prevent default change currency from dropdown
    $(".currency__switcher li a").click(function(e){
      // e.preventDefault();
    });


    $("#header-phantom .megamenu .with-sub-menu").hover(function(){
      $(this).removeClass('active');
      $("#header-menu").find(".with-sub-menu").addClass('active');
    });
    var scrollTimer;
    $(window).scroll(function(){
      var scrollPos = $(document).scrollTop();
      var w = window.innerWidth;

      if (scrollPos > 122) {
        if(!$("#header--main-content").hasClass('fixed')){
          $("#header--main-content").addClass('fixed');
          $("body").trigger("headerChangePosition");
          notice = $(".pattern>#notice-bar-content");
          if (notice.is(':visible')) {
            sticky = $(notice).data('sticky');
            if (sticky) {
              $(notice).find(".block-notice").addClass('fixed');
              $("#header--main-content").css('top', 48);
            }
          }
        }
        if (w > 991) {
          $("#pxu_cst").addClass("fixed");
          sticky = $("#notice-bar-content").data('sticky');
          if (sticky == 'true') {
            $(".pattern>#notice-bar-content").addClass('fixed');
          }
        }
      }else{
        if (scrollPos < 50) {
          if($("#header--main-content").hasClass('fixed')) {
            $("#header--main-content").removeClass('fixed');
            $("body").trigger("headerChangePosition");
          }
          if (w > 991) {
            $("#pxu_cst").removeClass("fixed");
          }
          $(".pattern>#notice-bar-content").removeClass('fixed');
          notice = $(".pattern>#notice-bar-content");
          if (notice) {
            $(notice).find(".block-notice").removeClass('fixed');
            $("#header--main-content").css('top', 0);
          }
        }
      }
    });
    if (window.innerWidth > 1300) {
     var cur_width = window.innerWidth * (34.5 / 100);
     $('.rich-banners .slick-track.owl-stage').css('height', cur_width + 'px');
     $(".rich-banners#rich-banners-1550732998020").css('height', cur_width + 'px');
   }

   $(document).on('click', '#input_accordion > li > div', function () {
    $('#input_accordion .active').not(this).removeClass('active').next().hide(300);
    $(this).toggleClass('active');

    if (false == $(this).next().is(':visible')) {
      $('#input_accordion > ul').slideUp(300);
      $(document).find('#input_accordion .sign').text('-');
    } else {
      $(document).find('#input_accordion .sign').text('+');
    }

    $(this).next().slideToggle(300);
  });
 });


$(function(){
  $(document).ready(function(){
    if (screen.width < 768){
      h = $(".header-main-block").height();
      var a = $('.close-announcement-nav').outerHeight();
      if (sessionStorage.getItem("hideAnnouncement") == 'hide') {
        h = (h - a);
      }
      if (!$('body').hasClass('module-mix-and-match')  && !$('body').hasClass('sm-lp')) {
        $('body').attr('style', 'padding-top:'+ h +'px !important;');
      }

    }
    if (screen.width > 768){
      main_product_section_scroll();
    }
    slickSpotlight();
    slickBlog();
    nutriBoostSlider();
    slickStep();

    $('.search-icon-btn').on('click', function(){
      // $('.search-form-dt').toggleClass('hide');
      //$('.search-form-dt').toggleClass('hide');
      //$('.header-search-container').toggleClass('hide');
      $('.full-width-search-container').toggleClass('hide');
    });
    $(document).click(function(e){
      if ($('.full-width-search-container').hasClass('hide')) {
  
      } else {
        if($(e.target).closest('.full-width-search-container .result-row').length != 0) return true;
       if($(e.target).closest('.full-width-search-container').length != 0) return false;
       if($(e.target).closest('.search-icon-btn').length != 0) return false;
       $('.full-width-search-container').toggleClass('hide');
      }
    });
    $('.mobile-tabs-navi .selecter').on('click', function(){
      $('.mobile-tabs-navi .list').slideToggle('fast');
    });

    $('.mobile-tabs-navi .custom-option').on('click', function(){
      var txt = $(this).html();
      $('.mobile-tabs-navi .list').removeClass('open');
      $('.mobile-tabs-navi .selecter').html(txt);
      var catFilter = $(this).attr('data-val');
      $('.review-all-items .items').removeClass('hide-item');
      if (catFilter == 'All') {
        $('.review-all-items .items').removeClass('hide-item');
      } else {
        $('.review-all-items .items').not('[data-tab*="'+catFilter+'"]').addClass('hide-item')
      }
      $('.tab button[data-filter="'+catFilter+'"]').trigger('click');
      console.log($('.tab button[data-filter="'+catFilter+'"]'));
      $('.chart-for-slider').slick('setPosition', 0);
      $('.mobile-tabs-navi .list').slideToggle('fast');
    });
    announcementBarClose();
    if (window.use_fake_counter_1) {
      var cartCounter = $('.mycart-counter').attr('data-fake-counter');
        // $('.total_count_ajax').html(cartCounter);
        // $('.mycart-counter').html(cartCounter);

      }
      if (sessionStorage.getItem('currencyActive') && sessionStorage.getItem('currencyActive') != Shopify.currency.active) {
        $('#mcp_change_currency').val(sessionStorage.getItem('currencyActive'));
        $('#currency_form').submit();
      }
      sessionStorage.setItem('currencyRate', Shopify.currency.rate);

      $('.about-us-page #tabs li a').on('click', function(e){
        e.preventDefault();
        var target = $(this).attr('href');
        $('.about-us-page #tabs li').removeClass('active');
        $('.about-us-page .tab-pane').removeClass('active');
        $(target).addClass('active');
        $(this).parent().addClass('active');
      });


      //review page default
      if (document.getElementById("defaultOpen")) {
        document.getElementById("defaultOpen").click();
        resultSliderslick();
      }

    });

  var initTipScroll,tooltip = false;
  $(".simple-tooltip").off('click').on('click', function(){
    if ($('.simple-tooltip-show').length) {
      closeTooltip();
      return;
    }
    message = $(this).data('message');
    html = "<div class='simple-tooltip-show' style='text-align: right;position: absolute; z-index: 1;min-width:300px;max-width: 320px;'><a href='javascript:void(0);' onclick='closeTooltip()' class='tooltip-close'><i class='fa fa-close'></i></a><p style='margin-top: 3px;text-align:left;padding: 10px;font-size: 11px;font-weight: normal;background: #fff;border: 1px solid #ff6ea9;border-radius: 5px;'>"+message+"<span class='arrow'></span></p></div>";
    $('body').append(html);
    $("#header--main-content").css({zIndex: 10, background: '#fff'});
    tooltipPosition(this);
    if (!initTipScroll){
      $("body,#summary-scrollable").on("scroll", function(){
        clearTimeout(tooltip);
        tooltip = setTimeout(function(){tooltipPosition($(".simple-tooltip"))}, 500);
      });
      initTipScroll = true;
    }
  })

  tooltipPosition = function(el) {
    offset = $(el).offset();
    if (offset == undefined) {
      return;
    }
    w = $(".simple-tooltip-show").width() / 2;
    h = $(".simple-tooltip-show").height();
    wLeft = offset.left - w;
    w0 = w;
    if (window.innerWidth < 450) {
      wLeft = (window.innerWidth / 2) - w;
    }
    $(".simple-tooltip-show").css({top: offset.top - h, left: wLeft});
    ofs = $(".simple-tooltip-show").offset();
    if (ofs) {
      lf = offset.left - ofs.left;
      $(".simple-tooltip-show span.arrow, .simple-tooltip-show span.arrow").css({left: lf - 3});
    }
  }

  closeTooltip = function(){
    $(".simple-tooltip-show").remove();
  }

  $(".video-img-preview").click(function(){
    box = $(this).parent();
    $(this).hide();
    htmlPlayer = box.find("#video-player");
    if (htmlPlayer.length) {
      $("#video-player").play();
    } else {
      videoSrc = $("#product-ytplayer").attr('src');
      videoSrc = videoSrc + "?autoplay=1";
      $("#product-ytplayer").attr('src', videoSrc);
    }
  });

  $(".expand-another-ingredients").click(function(){
    parentElement = $(this).parent()
    parentElement.toggleClass('expanded');

    if (parentElement.hasClass('expanded')) {
      $(this).find('i').removeClass('fa-plus').addClass("fa-minus");
      $(this).find('.plus').addClass('minus');
    } else {
      $(this).find('i').removeClass('fa-minus').addClass("fa-plus");
      $(this).find('.plus').removeClass('minus');
    }
  });

  if ($(".has-subscriptions").length == 0) {
    setTimeout(function(){
      // $(".variations_button .product-subscribe:first").click();
      var qString = window.location.search;
      var urlParam = new URLSearchParams(qString);
      var urlVariant = urlParam.get('variant');

      if (!urlVariant) {
        if ($(".product-subscribe.besties-selected").length > 0) {
          $(".product-subscribe.besties-selected").trigger('click')
        } else {
          $(".variations_button .product-subscribe:first").click();
        }
      }

    }, 1000);
  }
});

function forceFullWidthBlocks() {
  $(".product-blocks .full-width").each(function(){
    $(this).css({left: 0, width: "100%"});
    w = window.innerWidth;
    offset = $(this).offset();
    left = w - $(this).width();
    left = left / 2;
    fullwidth = w;
    $(this).css({left: -left, width: fullwidth});
  });
}

var resizeTimer;
$(window).on('resize', function(e) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    forceFullWidthBlocks();
  }, 250);
});
var viewed = false;

var isInViewport = function (elem) {
  var bounding = elem.getBoundingClientRect();
  hscreen = (window.innerHeight || document.documentElement.clientHeight) + 100;
  wscreen = (window.innerWidth || document.documentElement.clientWidth) + 100;
  return (
    bounding.top >= -100 &&
    bounding.left >= -100 &&
    bounding.bottom <= hscreen &&
    bounding.right <= wscreen
    );
};

$(".video-section").each(function(){
  if (this.nodeName == 'VIDEO') {
    src = $(".video-section source").data('src');
    $(this).find('source').attr('src', src);
    this.muted = true;
    $(this).trigger('load');
  } else {
    src = $(this).attr('data-src');
    $(this).attr('src', src);
  }
  _this = this;
  if (isInViewport(_this) && !viewed) {
    viewed = true;
    setTimeout(function(){
      _this.play();
    }, 600);
  }

  window.addEventListener('scroll', function (event) {
    if (isInViewport(_this) && !viewed) {
      viewed = true;
      setTimeout(function(){
        _this.play();
      }, 600);
    }
  }, false);
});
if ($(".current-currency-flag").length) {
  setTimeout(function(){
    $(".current-currency-flag").addClass("lazyload");
  },1000)
}
handleChangeCurrency();
handleCustomSelect();
slickSpotlight();
slickBlog();
nutriBoostSlider();
slickStep();
setTimeout(function(){
  if (sessionStorage.getItem("hideAnnouncement") == 'hide') {
    $('.close-announcement-nav').addClass('hide');
    if (window.innerWidth <= 768) {
      var padding = 81 - h;
      var elements = document.getElementsByTagName( 'body' );
      var element = elements[ 0 ];
      if ( document.all ) {
        element.style.setAttribute('cssText', 'padding-top: '+padding+'px !important');
      } else {
        element.setAttribute('style', 'padding-top: 50px !important');
      }
    }
  }
}, 750);


function handleChangeCurrency() {
  setTimeout(function(){
    $("[data-for-code]").each(function(){
      code = $(this).data("for-code");
      $(this).attr('data-code', code);
    });

    if (!window.enable_mcp) {
      $(".currency__switcher li").click(function(){
        var geo = $(this).attr('data-geo');
          /*
          if (geo == window.us_store_name) {
            window.location.href = window.us_store_link + "?force=true";
          } else if(geo == window.sg_store_name) {
            window.location.href = window.sg_store_link + "?force=true";
          } else if(geo == window.rw_store_name) {
            window.location.href = window.row_store_link + "?force=true";
          } else if (geo == window.au_store_name) {
            window.location.href = window.au_store_link + "?force=true";
          } else if (geo == window.ca_store_name) {
            window.location.href = window.ca_store_link + "?force=true";
          } else if (geo == window.uk_store_name) {
            window.location.href = window.uk_store_link + "?force=true";
          }
          */
        });
    } else {
        //$('#change_currency_val').val($(this).attr('data-code'));
        //$('#currency_form').submit();
        //return false;
      }

    }, 2000);
  if ($('#mcp_change_currency').length > 0) {
    $('.currency__switcher-new li').click(function(){
      var dataCode = $(this).attr('data-code');
      sessionStorage.setItem('currencyActive', dataCode);
      $('#mcp_change_currency').val(dataCode);
      $('#currency_form').submit();
    });
  }
}

function handleCustomSelect(){
  setTimeout(function() {
    if ($('#quiz_select').length > 0) {
      console.log('quiz')
      var x, i, j, selElmnt, a, b, c;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName("custom-select");
      for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML + '<img data-src="'+$(x).attr('data-src')+'" class="drop down lazyload">';
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < selElmnt.length; j++) {
          /*for each option in the original select element,
          create a new DIV that will act as an option item:*/
          c = document.createElement("DIV");
          c.setAttribute('data-pos', j);
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.addEventListener("click", function(e) {
              /*when an item is clicked, update the original select box,
              and the selected item:*/
              var y, i, k, s, h;
              s = this.parentNode.parentNode.getElementsByTagName("select")[0];
              h = this.parentNode.previousSibling;
              for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                  s.selectedIndex = i;
                  h.innerHTML = this.innerHTML + '<img data-src="'+$(x).attr('data-src')+'" class="drop down lazyload">';
                  y = this.parentNode.getElementsByClassName("same-as-selected");
                  for (k = 0; k < y.length; k++) {
                    y[k].removeAttribute("class");
                  }
                  this.setAttribute("class", "same-as-selected");

                  handleCustomSelectListener($('#quiz_select').val());
                  break;
                }
              }
              h.click();
              if (window.innerWidth >= 768) {
                $('.select-selected').removeAttr('style');
              }
            });
          b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function(e) {
          /*when the select box is clicked, close any other select boxes,
          and open/close the current select box:*/
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
          $('.custom-select').toggleClass('active');
          var pos = $('.select-items div.same-as-selected').attr('data-pos');
          if (parseInt(pos) > 1) {
            $('.select-items div[data-pos="'+(parseInt(pos) - 1)+'"]').css({'border-bottom': '1px solid transparent'});
          }
          if (parseInt(pos) == 1) {
            $('.select-selected.select-arrow-active').css({'border-bottom': '1px solid transparent'});
          }
        });
      }
      function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x, y, i, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        for (i = 0; i < y.length; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i)
          } else {
            y[i].classList.remove("select-arrow-active");
            $('.custom-select').removeClass('active');
            if (window.innerWidth >= 768) {
              $('.select-selected').removeAttr('style');
            }

          }
        }
        for (i = 0; i < x.length; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
            $('.select-selected').removeAttr('style');
          }
          if (window.innerWidth >= 768) {
            $('.select-selected').removeAttr('style');
          }
        }
      }
      /*if the user clicks anywhere outside the select box,
      then close all select boxes:*/
      document.addEventListener("click", closeAllSelect);

      function handleCustomSelectListener(val){
        $('.quiz-banner-result').removeClass('quiz-result-padding');
        $('.quiz-banner-result .item').addClass('hide');
        $('.quiz-banner-result .url-opt').addClass('hide');
        if (val != '') {
          $('.quiz-banner-result').addClass('quiz-result-padding');
          $('.hp-quiz-container img.banner').removeClass('hide');
          $('.hp-quiz-container img.banner').addClass('blur');
          $('.hp-quiz-container .loader').removeClass('hide');
          setTimeout(function(){
            $('.hp-quiz-container img.banner').addClass('hide');
            $('.hp-quiz-container .loader').addClass('hide');
            $('.quiz-banner-result .'+val).removeClass('hide');
          }, 1500);
        }
      }

      if (window.innerWidth >= 768) {
        $('.select-items > div').hover(function(){
          $(this).prev().css({'border-bottom': '1px solid transparent'});
          if ($(this).attr('data-pos') == '1') {
            $('.select-selected.select-arrow-active').css({'border-bottom': '1px solid transparent'});
          }
        }, function(){
          $(this).prev().css({'border-bottom': '1px solid #FBDCE7'});
          if ($(this).attr('data-pos') == '1') {
            $('.select-selected.select-arrow-active').css({'border-bottom': '1px solid #FBDCE7'});
          }
        });
      }

    }
  }, 500)

}

function announcementBarClose(){
  $('.close-announcement-nav svg').on('click', function(){
    $('.close-announcement-nav').hide('fast');
    sessionStorage.setItem("hideAnnouncement", 'hide');
    if (window.innerWidth <= 768) {
      var h = $('.close-announcement-nav').outerHeight();
      var padding = 81 - h;
      var elements = document.getElementsByTagName( 'body' );
      var element = elements[ 0 ];
      if ( document.all ) {
        element.style.setAttribute('cssText', 'padding-top: '+padding+'px !important');
      } else {
        element.setAttribute('style', 'padding-top: '+padding+'px !important');
      }
    }
  });

  if (sessionStorage.getItem("hideAnnouncement") == 'hide') {
    var h = $('.close-announcement-nav').outerHeight();
    $('.close-announcement-nav').addClass('hide');
    if (window.innerWidth <= 768) {
      var padding = 81 - h;
      var elements = document.getElementsByTagName( 'body' );
      var element = elements[ 0 ];
      if ( document.all ) {
        element.style.setAttribute('cssText', 'padding-top: '+padding+'px !important');
      } else {
        element.setAttribute('style', 'padding-top: '+padding+'px !important');
      }
    }
  }
}

function slickSpotlight(){
  agent_ = navigator.userAgent;
  if (agent_.toLowerCase().indexOf("instagram") != -1) {
    if ($('.spotlight-slider').length > 0) {
      $('.spotlight-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '45px',
        arrows: false
      });
    }
  } else {
    if ($('.spotlight-slider').length > 0) {
      $('.spotlight-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 13,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '45px',
            arrows: false
          }
        }]
      });
    }
  }
}

function resultSliderslick(){
  $('.chart-for-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0px',
        infinite: false,
        arrows: false,
        dots: true,
        prevArrow: '<div class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="22.828" viewBox="0 0 12.414 22.828"><defs><style>.a{fill:none;stroke:#3d3d3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><path class="a" d="M593.281,864.878l10,10-10,10" transform="translate(604.281 886.292) rotate(180)"/></svg></div>',
        nextArrow: '<div class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="22.828" viewBox="0 0 12.414 22.828"><defs><style>.a{fill:none;stroke:#3d3d3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><path class="a" d="M593.281,864.878l10,10-10,10" transform="translate(-591.867 -863.464)"/></svg></div>'
      }
    }]
  });
}

function nutriBoostSlider(){
  var interval = setInterval(function(){
    if ($('.nutriboost-customer').find('.append').length <= 0) {
      var txt = $('.caption-bottom').text();
      $('.nutriboost-customer .caption-bottom').show().css('marginTop', 10);
      clearInterval(interval);
    }
  });

  if ($('.nutri-step-slider').length > 0) {
    $('.nutri-step-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '15px',
          infinite: false,
          arrows: true,
          dots: true,
          prevArrow: '<div class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="22.828" viewBox="0 0 12.414 22.828"><defs><style>.a{fill:none;stroke:#3d3d3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><path class="a" d="M593.281,864.878l10,10-10,10" transform="translate(604.281 886.292) rotate(180)"/></svg></div>',
          nextArrow: '<div class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="22.828" viewBox="0 0 12.414 22.828"><defs><style>.a{fill:none;stroke:#3d3d3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><path class="a" d="M593.281,864.878l10,10-10,10" transform="translate(-591.867 -863.464)"/></svg></div>'
        }
      }]
    });

    if (window.template === 'product.nutri-boost-bundle') {
      $('#tabs li a').on('click', function(){
        var target = $(this).attr('href');
        setTimeout(function(){
          if (window.innerWidth <= 768) {
            $('.tab-column-two .nutriboost-step.nutriboost-mobile-step').show();
            $('.nutriboost-step .slick-dots .slick-active').trigger('click');
          }
        }, 50);
      });

      $('#tabs li a').on('click', function(){
        var target = $(this).attr('href');
        if (window.innerWidth <= 768) {
          $('.tab-column-two .nutriboost-step.nutriboost-mobile-step .nutri-step-slider').hide();
          setTimeout(function(){
            $('.nutriboost-step .slick-dots .slick-active').trigger('click');
            $('.tab-column-two .nutriboost-step.nutriboost-mobile-step .nutri-step-slider').fadeIn('slow');
          }, 500);
        }
      });
    } else if (window.template === 'product.super-cleanse-bundle') {
      $('#tabs li a').on('click', function(e){
        e.preventDefault();
        var tabs = $(this).closest('#tabs');
        if (window.innerWidth <= 500 && tabs.hasClass('superfood-tabs')) {
          const left = $(this).offset().left;
          const right = left + $(this).outerWidth();
          const con = tabs.parent();
          const conW = con.width();
          if (right > conW) {
            con.animate({ scrollLeft: right - conW + 40 }, 200);
          } else if (left < 0) {
            con.animate({ scrollLeft: 0 }, 200);
          }
        }
      });
    }
  }
}

function slickStep() {
  if ($('.product-step-slider').length > 0) {
    $('.product-step-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      mobilefirst: true,
      responsive: [{
        breakpoint: 9998,
        settings: "unslick"
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: true,
          prevArrow: '<div class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="22.828" viewBox="0 0 12.414 22.828"><defs><style>.a{fill:none;stroke:#3d3d3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><path class="a" d="M593.281,864.878l10,10-10,10" transform="translate(604.281 886.292) rotate(180)"/></svg></div>',
          nextArrow: '<div class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="22.828" viewBox="0 0 12.414 22.828"><defs><style>.a{fill:none;stroke:#3d3d3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><path class="a" d="M593.281,864.878l10,10-10,10" transform="translate(-591.867 -863.464)"/></svg></div>'
        }
      }]
    });

		$('.product-step-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			let customText = $('.product-step-slider .step-item[data-slick-index="'+nextSlide+'"]').data('custom-title');
			if (customText) {
				$('#step-slider__heading').text(customText);
			}
		});
  }
}

function main_product_section_scroll() {
  var fixedDiv = document.getElementById('fake-scroller'),
  scrollableDiv = document.getElementById('summary-scrollable');
  if (fixedDiv) {

    fixedDiv.addEventListener('mousewheel', function (e) {
      var temp = scrollableDiv.scrollTop
      scrollableDiv.scrollTop += e.deltaY;
      if (scrollableDiv.scrollTop > 0 && scrollableDiv.scrollTop > temp)  {
        e.preventDefault()
      }
    });
  }

}

window.onscroll = function() {checkOffsetSidebar()};
var header = document.getElementById("sidebarSticky");

function checkOffsetSidebar() {
  var prevPos = $(document).scrollTop();
  if (header) {
    var a=$(document).scrollTop()+window.innerHeight;
    var b=$('section.footer').offset().top;
    if (window.pageYOffset > 300 && window.pageYOffset < b) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }

    if (a<b) {
      $('#sidebarSticky').css('bottom', 'auto').css('top', '100px');
    } else {
      $('#sidebarSticky').css('bottom', (10+(a-b))+'px').css('top', 'auto');
    }
  }

}

var prevScrollpos = window.pageYOffset;
var treshold;
var tops;

var collNav;
var collNavTreshold = -165.4;

window.onscroll = $.throttle(15, function(){
  if ($('.gdpr-modal:visible').length > 0) {
    tops = $('.gdpr-modal').height;
    treshold = $('.gdpr-modal').height;
    collNav = $('.gdpr-modal').height() + 80;
  } else if ($('#notice-bar-content').length > 0) {
    tops = 0;
    treshold = -69;
    collNav = 80;
  } else {
    tops = 0;
    treshold = -87;
    collNav = 80;
  }

  var currentScrollPos = window.pageYOffset;
  var templateColection = $('body.templateCollection').length
  if (templateColection == 0) {
    if (prevScrollpos > currentScrollPos || window.pageYOffset < 150) {
      document.getElementById("primary-mobile-nav").style.top = tops;
      $('#primary-mobile-nav .header-main-block').css({'top': tops});
      $('#coll_nav_fixed').css({'top': collNav});
    } else {
      document.getElementById("primary-mobile-nav").style.top = treshold+"px";
      $('#primary-mobile-nav .header-main-block').css({'top': treshold});
      $('#coll_nav_fixed').css({'top': collNavTreshold});
    }
    prevScrollpos = currentScrollPos;
  }

});

// Instagram Browser Script
isInstagramBrowser = function() {
  agent = navigator.userAgent;
  return agent.toLowerCase().indexOf("instagram") != -1;
}

isAndroid = function() {
  agent = navigator.userAgent;
  return agent.toLowerCase().indexOf("android") != -1;
}

instagramBrowserHandle = function() {
  console.log('is IG')
  var runCheck;
  var diffHeight = window.innerHeight > 700 ? 60 : 44; //default
  if (!isInstagramBrowser() || isAndroid()) {
    return;
  }

  if (isInstagramBrowser()) {
    $("body,html").addClass("instagram-browser");
    document.body.scrollTop = -100;
    window.scrollTop = -100;


    var prevScrollpos = window.pageYOffset;
    var treshold;
    var tops;

    var collNav;
    var collNavTreshold = -165.4;

    window.onscroll = $.throttle(15, function(){
      var currentScrollPos = window.pageYOffset;
      if ($('.gdpr-modal:visible').length > 0) {
        tops = $('.gdpr-modal').height;
        treshold = $('.gdpr-modal').height;
        collNav = $('.gdpr-modal').height() + 80;
      } else {
        tops = 42;
        treshold = -87;
        collNav = 80;
        if (currentScrollPos < 5) {
          tops = 0;
          $('.mobile-nav-wrapper').addClass('tops')
        } else {
          $('.mobile-nav-wrapper').removeClass('tops')
        }
      }


      if (prevScrollpos > currentScrollPos || window.pageYOffset < 150) {
        console.log(currentScrollPos)

        document.getElementById("primary-mobile-nav").style.top = tops;
        $('#primary-mobile-nav .header-main-block').css({'top': tops});
        $('#coll_nav_fixed').css({'top': collNav});
      } else {
        document.getElementById("primary-mobile-nav").style.top = treshold+"px";
        $('#primary-mobile-nav .header-main-block').css({'top': treshold});
        $('#coll_nav_fixed').css({'top': collNavTreshold});
      }
      prevScrollpos = currentScrollPos;

    });
    $("body .close-cart").off('click').on("click", function(y) {
      $(".cart-window-bg").toggleClass("window-hide");
      setTimeout(function() {
        if (!$('html.instagram-browser .cart-window-bg').hasClass('window-hide')) {
          $('html,body').addClass('ig-noscroll')
        } else {
          $('html,body').removeClass('ig-noscroll')
        }
      }, 500)
    })

  }
}
// instagramBrowserHandle()

function checkUrgency(){
  if (window.ab_test_front == 'true') {
    if (document.body.classList.contains('opt-fomo')) {
      $(document).find('#cart-urgency').addClass('hide');
    }
  }
}

// Instagram Browser Script
isInstagramBrowser = function() {
  agent = navigator.userAgent;
  return agent.toLowerCase().indexOf("instagram") != -1;
}

isAndroid = function() {
  agent = navigator.userAgent;
  return agent.toLowerCase().indexOf("android") != -1;
}

instagramBrowserHandle = function() {
  console.log('is IG')
  var runCheck;
  var diffHeight = window.innerHeight > 700 ? 60 : 44; //default
  if (!isInstagramBrowser() || isAndroid()) {
    return;
  }

  if (isInstagramBrowser()) {
    $("body,html").addClass("instagram-browser");
    $("body .close-cart").off('click').on("click", function(y) {
      $(".cart-window-bg").toggleClass("window-hide");
      setTimeout(function() {
        if (!$('html.instagram-browser .cart-window-bg').hasClass('window-hide')) {
          $('html,body').addClass('drawer-opened')
        } else {
          $('html,body').removeClass('drawer-opened')
        }
      }, 500)
    })
    document.body.scrollTop = -100;
    window.scrollTop = -100;

    // $("body").append("<span id='debuger' style='word-break:break-all;max-width:375px;top:50%;position:fixed;z-index:999999;padding:20px;background:#fff;'></span>")
    // $("#debuger").text(navigator.userAgent);


    var prevScrollpos = window.pageYOffset;
    var treshold;
    var tops;

    var collNav;
    var collNavTreshold = -165.4;
    var pos = $(".instagram-browser-fixs").scrollTop();
    $('body').on('drawerOpen.CartDrawer', function() {

    })
    window.onscroll = $.throttle(15, function(){
      var currentScrollPos = window.pageYOffset;
      if ($('.gdpr-modal:visible').length > 0) {
        tops = $('.gdpr-modal').height;
        treshold = $('.gdpr-modal').height;
        collNav = $('.gdpr-modal').height() + 80;
      } else {
        tops = 42;
        treshold = -87;
        collNav = 80;
        if (currentScrollPos < 5) {
          tops = 0;
          $('.mobile-nav-wrapper').addClass('tops')
        } else {
          $('.mobile-nav-wrapper').removeClass('tops')
        }
      }
      var htm = $(".instagram-browser").scrollTop();
      var htmp = $(".instagram-browser").parent().scrollTop();
      var body = $(".instagram-browser body").scrollTop();
      var isDrawerOpen = $('.instagram-browser').hasClass('drawer-opened')
      vcs = document.documentElement.clientHeight;
      vis = window.innerHeight;
      vid = window.outerHeight;

      if (htm > 0 && isDrawerOpen) {
        $(".instagram-browser").scrollTop(-50)
      }

      var isHide = false
      if (vcs != vis) {
        $('html').removeClass('browser-hide-bar');
        isHide = false
      } else {
        $('html').addClass('browser-hide-bar');
        isHide = true
      }
      scrollt = ''
      if (htm > pos) {
        $('html').removeClass('browser-bar-up');
        scrollt = 'up'
      } else {
        $('html').addClass('browser-bar-up');
        scrollt = 'down'
      }
      pos = htm
      if (prevScrollpos > currentScrollPos || window.pageYOffset < 150) {

        document.getElementById("primary-mobile-nav").style.top = tops;
        $('#primary-mobile-nav .header-main-block').css({'top': tops});
        $('#coll_nav_fixed').css({'top': collNav});
      } else {
        document.getElementById("primary-mobile-nav").style.top = treshold+"px";
        $('#primary-mobile-nav .header-main-block').css({'top': treshold});
        $('#coll_nav_fixed').css({'top': collNavTreshold});
      }
      prevScrollpos = currentScrollPos;
      // $("#debuger").text('html:'+htm +' body:'+body +'<br>'+ isHide + '__ '+ vcs+'-'+scrollt+'-'+vis);
    });
    $("body .close-cart").off('click').on("click", function(y) {
      $(".cart-window-bg").toggleClass("window-hide");
      setTimeout(function() {
        if (!$('html.instagram-browser .cart-window-bg').hasClass('window-hide')) {
          $('html,body').addClass('ig-noscroll')
        } else {
          $('html,body').removeClass('ig-noscroll')
        }
      }, 500)
    })

  }
}
// instagramBrowserHandle()

$(document).on('click', '#cart_block', function(){
  checkUrgency();
});


function openTabs(evt, divName, bannerName, elem) {
  // Declare all variables
  var i, tabcontent, tablinks;
  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(divName).style.display = "block";
  document.getElementById(bannerName).style.display = "block";
  if (evt.currentTarget) {
    evt.currentTarget.className += " active";
  }

  if (bannerName == 'banner1') {
    $('.banner-tabs').addClass('with-img');
    $('.banner-tabs .img-banner-1-mobile').removeClass('hideimg');
  } else {
    $('.banner-tabs').removeClass('with-img');
    $('.banner-tabs .img-banner-1-mobile').addClass('hideimg');
  }
  setTimeout(function(){
    $('.chart-for-slider').slick('refresh');
  }, 100);
  var catFilter = $(elem).attr('data-filter');
  $('.review-all-items .items').removeClass('hide-item');
  if (catFilter == 'All') {
    $('.review-all-items .items').removeClass('hide-item');
  } else {
    $('.review-all-items .items').not('[data-tab*="'+catFilter+'"]').addClass('hide-item')
  }
}

function openReviewModal(evt){
  var content = $(evt).closest('.content');
  var txtFull = content.find('.txt-full').html();
  var name = content.find('h3').html();
  var img = content.parent().find('img').attr('data-src');
  var pimg = content.find('.prod').attr('data-p-img');
  var targetUrl = content.find('.prod a').attr('href');
  txtFull += '<h3>'+name+'</h3>';
  $('.review-overlay .txt-content').html(txtFull);
  $('.review-overlay').removeClass('review-overlay-hidden');
  $('.review-overlay .img-content img').attr('src', img);
  $('.review-overlay .img-content img').attr('src', img);
  $('.review-overlay .prd-content img').attr('src', pimg);
  $('.review-overlay .prd-content a').attr('href', targetUrl);

  content.find('.txt').toggleClass('hiddentxt', 600);
  content.find('.txt-full').toggleClass('hiddentxt', 600);
  content.find('.open-modal').toggleClass('less', 600);
  content.find('.mobile-product-box').toggleClass('toggleHide', 600);
}

function closeReviewModal(){
  $('.review-overlay').addClass('review-overlay-hidden');
}


//waitlist part
window.validateEmail = function(t) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(t).toLowerCase())
}
window.validatePhone = (phone) => {
  return /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(phone);
}
$('#product-launch-waitlist-form .checkbox').click(function () {
	if ($(this).hasClass('checked')) {
		$(this).removeClass('checked');
	} else {
		$(this).addClass('checked');
	}
});

$('#product-launch-waitlist-form .country-select-select').on('change', function () {
	const code = $(this).find(':selected').attr('data-code');
	$('#product-launch-waitlist-form .country-select-text').text(`+${code}`);
});

const showSuccess = function () {
	$('#product-launch-waitlist-form').hide();
  $('#product-launch-waitlist-success').show();
  $('.new-waitlist-wrapper .privacy').hide();
};

const subscribeBluecoreWaitlist = function(email, productHandle, event, phone){
  data = {
    email: email,
    country: getCookie('_shopify_country'),
    brand: 'skinnymint',
    domain: window.location.hostname,
    product: productHandle,
    reg_source: event,
    phone: phone ? phone : ''
  }

  $.post(`${window.apiEndpoint}/bluecore/waitlist.json`, data)
}

const submitPhone = function (country, phone, formId) {
	$.ajax({
		url: 'https://api.smsbump.com/v2/formsPublic/subscribe',
		method: 'POST',
		cache: false,
		data: JSON.stringify({
			country,
			phone,
			email: '',
			form_id: formId,
		}),
		contentType: 'application/json; charset=utf-8',
		headers: { 'X-SMSBump-Platform': 'shopify' },
		success(res) {
			if (res.message) {
				$('#product-launch-waitlist-form .phone-error').text(res.message).show();
			} else {
				showSuccess();
			}
		},
	});
};

const fbTrack = function(event) {
  if (typeof(fbq) == 'function'){
    if (window.location.pathname.indexOf('detox-cherry-bomb') != -1) {
      fbq('track', 'CherryBombWaitlist');
    } else if (event && event != '') {
      fbq('track', event);
    }
  } else {
    setTimeout(fbTrack, 1000);
  }
}

$('#product-launch-waitlist-form').on('submit', function (e) {
  e.preventDefault();
  const el = $(this);
  const email = el.find('.email').val() || '';
  const country = el.find('.country-select-select').val() || '';
  let phoneNum = el.find('.phone').val() || '';

  const tocAgree = el.find('.toc').hasClass('checked');
  const emailValid = email != '' && window.validateEmail(email);
  const countryValid = country != '';
  const phoneValid = phoneNum != '' && window.validatePhone(phoneNum);
  const validForm = tocAgree && (emailValid || (countryValid && phoneValid));
  el.find('.input-error').hide();

  if (!emailValid && !phoneValid && !countryValid) { el.find('.email-error').show(); }
  if (!emailValid && !phoneValid) { el.find('.phone-error').text('Please enter a valid phone number').show(); }
  if (!emailValid && phoneValid && !countryValid) { el.find('.phone-error').text('Please enter a country').show(); }
  if (!tocAgree) { el.find('.toc-error').show(); }
  if (!validForm) { return; }

  const event = el.attr('data-fbq') || '';
  if (emailValid || phoneValid) {
    const productHandle = el.attr('data-product-handle') || '';
    if (countryValid && phoneValid) {
      if (phoneNum.charAt(0) == '0'){
        phoneNum = phoneNum.substring(1);
      }
      const countryCode = $(".country-select-select option[value='"+country+"']").attr('data-code');
      phoneNum = "+" + countryCode + phoneNum;
    }
    klaviyo_call_Waitlist(email,phoneNum);
    subscribeBluecoreWaitlist(email, productHandle, event, phoneNum);
    showSuccess();
  }

  if (countryValid && phoneValid) {
    const smsBumpId = el.attr('data-bid');
    if (smsBumpId !== '') {
     submitPhone(country, phoneNum, parseInt(smsBumpId));
    }
  }
 fbTrack(event);
});


var klaviyo_call_Waitlist = function(Email,phoneNumber){
  const options = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      "store": "au",
      "email": Email,
      "phone": phoneNumber,
      "waitlist": 1
    })
  };
    
  fetch('https://skinnymint-php.herokuapp.com/', options)
  .then(response => response.json())
  .then(response => console.log(response))
  .catch(err => console.log(err));
}

$('#click-to-copy').on('click', function () {
  const inputId = $(this).attr('data-input-id');
  document.getElementById(inputId).select();
  document.execCommand("copy");
  $(this).find('span span').text('COPIED');
});

$(".product-review-wrapper-type-two .more-reviews").on('click',function() {
  console.log('test')
  var S = $("#shopify-section-dbc-judgeme").offset().top;
  $("html,body").animate({
    scrollTop: S
  }, 500, "swing");
})
function slickBlog() {
  $('.homepage-blog-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: !0,
    infinite: !0,
    easing: "linear",
    arrow: true,
    dots: false,
    prevArrow: "<span class=\"slick-arrow-custom slick-prev-arrow\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.182\" height=\"18.121\"><path d=\"M10.121 1.061l-8 8 8 8\" fill=\"none\" stroke=\"#ff6ea9\" stroke-width=\"3\"/></svg></span>",
    nextArrow: "<span class=\"slick-arrow-custom slick-next-arrow\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.182\" height=\"18.121\"><path d=\"M1.061 1.061l8 8-8 8\" fill=\"none\" stroke=\"#ff6ea9\" stroke-width=\"3\"/></svg></span>",
    responsive: [{
      breakpoint: 1199,
      settings: {
        centerMode: !0,
        slidesToShow: 2,
      },
    }, {
      breakpoint: 992,
      settings: {
        centerMode: !0,
        centerPadding: "80px",
        slidesToShow: 2,
      },
    }, {
      breakpoint: 649,
      settings: {
        centerMode: !0,
        centerPadding: "80px",
        slidesToShow: 1,
      },
    }, {
      breakpoint: 401,
      settings: {
        centerMode: !0,
        centerPadding: "30px",
        slidesToShow: 1,
      },
    }],
  });
}

function clearVideoCarousel() {
	$('#videoModal').find('source').attr('src', '');
	$('#videoModal').find('video').get(0).load();
	$('#videoModal').find('video').get(0).pause();
}

if ($('.featured-image__has-video').length > 0) {
	let $videoSrc;

	clearVideoCarousel();

	$('.featured-image__has-video').on('click', function(){
		$videoSrc = $(this).data('src');
		$('#videoModal').find('video').find('source').attr('src', $videoSrc);
		$('#videoModal').show();
		$('#videoModal').find('video').show();
		$('#videoModal').find('video').get(0).load();
		$('#videoModal').find('video').get(0).play();
	});

	// When the user clicks anywhere outside of the modal, close it
	$('body').on('click', function(event){
		if ($(event.target).attr('id') === 'videoModal') {
			$('#videoModal').hide();
			clearVideoCarousel();
		}
	});

	$('#videoModalclose').on('click', function(){
		$('#videoModal').hide();
		clearVideoCarousel();
	});
}

$('.btn-upsell__article').on('click', function () {
  if (typeof (ga) === 'function') {
    window.ga('send', 'event', {
      eventCategory: 'Upsell',
      eventAction: 'blog_upsell',
      eventLabel: 'Blog Upsell',
    });
  }
});

$('form[id="popup_create_customer"]').on('submit', function () {
  if (window.mixpanel) {
    window.mixpanel.track('Sign Up', {
      'page': window.location.href,
    });
  }
});

$('form[id="popup_customer_login"]').on('submit', function () {
  if (window.mixpanel) {
    window.mixpanel.track('Log In', {
      'page': window.location.href,
    });
  }
});

window.themeSettings = window.themeSettings || {};
window.themeSettings.tier_discount = '{"data":[{"value_type":"amount","store":"us","tier":[{"treshold":120,"val":20},{"treshold":80,"val":10},{"treshold":50,"val":5}]},{"value_type":"amount","store":"au","tier":[{"treshold":120,"val":20},{"treshold":80,"val":10},{"treshold":50,"val":5}]},{"value_type":"amount","store":"sg","tier":[{"treshold":120,"val":20},{"treshold":80,"val":10},{"treshold":50,"val":5}]},{"value_type":"amount","store":"ca","tier":[{"treshold":120,"val":20},{"treshold":80,"val":10},{"treshold":50,"val":5}]},{"store":"dev","value_type":"amount","tier":[{"treshold":120,"val":20},{"treshold":80,"val":10},{"treshold":50,"val":5}]}]}';
window.themeSettings.tier_auto_applied = 'false' == 'true';
window.themeSettings.bogo_saving = false;
window.themeSettings.cart_drawer_badge = '28-day-ultimate-teatox';
window.themeSettings.cart_afterpay = 'true' == 'true';
window.themeSettings.cart_footer_afterpay = 'true' == 'true';
window.themeSettings.excludeProductsDiscountBar = 'BB0000022010,BB0000042040,BB0000032040';
window.themeSettings.notice_bar = false;
window.themeSettings.exit_intent = false;
window.themeSettings.exit_intent_timer = ";"
window.themeSettings.discount_cap = false;
window.themeSettings.tiered_discount_qty = false;

const activeItems = {
  add: {
    items: []
  },
  change: {
    items: []
  }
}

const DISCOUNT_CODES_WITH_CAP = [
	{code: 'SMSS1', percent: -100, discount_cap: 30000}
]

const manual_gwp = "false".trim() == "true";
const manual_gwp_auto_index = parseInt("0");
const manual_gwp_opt = {
  min_spend: parseFloat("100") * 100,
  title: "Select your free gift",
  max_item: 1,
  title_error: "Please choose X products or opt out by ticking the checkbox above"
}


let manual_gwp_items = [];
$.get({url: "https://"+window.location.hostname+"?view=get-gwp"}).done(function(r){
  manual_gwp_items = JSON.parse(r);
})


var settings;
var regularProducts = [];
var discountProducts = [];
var mixProducts = [];

const smCart = {
  init: function() {
    $(".QuantityInput[name='quantity']").val(1)
    this.dataProducts()
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      moneyFormat        : '$\{\{amount\}\}',
      rate               : Shopify.currency.rate,
      shop_currency      : Shopify.currency.active
    };
    var urgency = {
      urgencyTitle: '',
      urgencyText: 'Checkout within  %timers% babe. <strong> Stock is low!</strong>',
      urgencyBg: '#ffe2ee',
      urgencyBorder: '#ffe2ee',
      urgencyMinutes: '10',
      urgencyFontColor: '#333333',
      replaceText: 'Maximise your results today. Checkout now!'
    }

    smCampaign.autoAdd.map(function(item, index) {
      item.sm_campaign_auto_add_free_item = parseInt(item.sm_campaign_auto_add_free_item)
      if (item.sm_campaign_auto_add_valid_with != '') {
        item.sm_campaign_auto_add_valid_with = item.sm_campaign_auto_add_valid_with.split(',').map(function(i) {
          return parseInt(i, 10);
        })
      }
      return item.sm_campaign_auto_add_enabled && item.sm_campaign_auto_add_free_item != ''
    })
    smCampaign.autoAdd = smCampaign.autoAdd.filter(function(item, index) { return item.sm_campaign_auto_add_enabled && item.sm_campaign_auto_add_free_item != '' })
    smCampaign.bogo.map(function(item, index) {
      if (item.sm_campaign_auto_add_valid_with != '') {
        item.sm_campaign_bogo_hero = item.sm_campaign_bogo_hero.split(',').map(function(i) {
          return parseInt(i, 10);
        })
      }
      return item.sm_campaign_bogo_enabled && item.sm_campaign_bogo_hero != ''
    })
    smCampaign.bogo = smCampaign.bogo.filter(function(item, index) { return item.sm_campaign_bogo_enabled && item.sm_campaign_bogo_hero != '' })
    smDiscount.autoAdd = smDiscount.autoAdd.filter(function(item, index) {return item.free != '' && item.code != '' && item.enabled})
    smDiscount.bogo = smDiscount.bogo.filter(function(item, index) {return item.free != '' && item.code != '' && item.enabled})

    this.addToCartListener()
    this.removeCartListener()
    this.qtyCartListener()
    this.freeInputQtyListener()

    var gCart = this.getCart()
    var _this = this
    gCart.done(function(cart){
      checkProductData = () => {
        if (mixProducts.length){
          smCart.checkCampaign();
        } else {
          // pebiantara comment
          // wait for half seconds to check again mixproducts data
          // running check campaign meanwhile mixproducts empty caused bogo item deleted when refresh page
          // sometime this code executed when data still empty
          setTimeout(checkProductData, 500);
        }
      }
      checkProductData();
    })

    // cart drawer trigger
    $("body .cart-block-click").off('click').on("click", function(y) {
      if (!$(y.target).closest('.cart-notification').length) {
        y.preventDefault()
        smCart.buildCart()
        $(".cart-window-bg").toggleClass("window-hide")
        setTimeout(function() {
          if (!$('html.instagram-browser .cart-window-bg').hasClass('window-hide')) {
            $('html,body').addClass('ig-noscroll')
          } else {
            $('html,body').removeClass('ig-noscroll')
          }
        }, 500)
        $('body').css({'overflow': 'hidden'});
      }
    });

    $('body .close-cart')
          .off('click')
          .on('click', function (y) {
            y.preventDefault(), $('.cart-window-bg').addClass('window-hide');
            $('html,body').removeClass('drawer-opened');
            $('body').css({'overflow': 'initial'});
          });

    $(".cart-window-bg").on('click', function() {
      $(".cart-window-bg").addClass("window-hide");
      $('body').css({'overflow': 'initial'});
    })

    $(".img-bubble-close").on('click', function() {
      $('.cart-notification').slideUp('fast');
    })

    $('.cn-open-drawer').on('click', function() {
      smCart.buildCart();
      if (window.innerWidth > 768) {
        $('#cart_block').click();
      } else {
        $(".cart-window-bg").toggleClass("window-hide");
      }
    })

    $('.quantityBox .plus').on('click', function() {
      var $qty = $(this).parents('.quantityBox').find(".QuantityInput");
      var currentVal = parseInt($qty.val(), 10);
      if (1 <= currentVal) {
        $(this).parents('.quantityBox').find('.minus').removeClass('disabled');
      }
      if (!isNaN(currentVal)) { $qty.val(currentVal + 1);}
    });
    $('.quantityBox .minus').on('click', function() {
      var $qty = $(this).parents('.quantityBox').find(".QuantityInput");
      var currentVal = parseInt($qty.val(), 10);
      if (currentVal <= 2) {
        $(this).parents('.quantityBox').find('.plus').addClass('disabled');
      }

      if (!isNaN(currentVal) && currentVal > 1) {$qty.val(currentVal - 1);}
    });

    $('.cart-upsell-carousel--content').on('reInit', function(event, slick, direction){
      $('.cart-upsell-carousel--content').show();
    });
  },
  getCart: function() {
    return $.getJSON('/cart.js')
  },
  addToCartListener: function() {
    var _this1 = this
    $(document).on("click", ".add-to-cart:not(.disabled)", function(evt) {
      evt.preventDefault()
      const handle = $(this).data('handle');
      const location = $(this).data('location');
      if (typeof (ga) === 'function') {
        window.ga('send', 'event', {
          eventCategory: 'Add To Cart',
          eventAction: location,
          eventLabel: handle
        });
      }

      smCart.loading(true)
      var y = $(this),
          T = y.closest("form"),
          txt = "";

      _this1._addCart(T.serialize(), false, function() {
        console.log('fu3')
        y.hasClass("btooltip") ? y.addClass("loading") : y.button("loading") && $("#filter-addtocart span").text(y.attr("data-loading-text")) && $("#filter-addtocart").addClass("active")
      }, function(resp) {
        console.log('fu2')
        y.hasClass("btooltip") ? y.removeClass("loading") : y.button("reset") && $("#filter-addtocart").removeClass("active");
        console.log(window.mixpanel)
        if (window.mixpanel) {
           console.log('fu22')
          const price = resp.price || 0;
          window.mixpanel.track('Add to Cart', {
            'page': window.location.href,
            'section': location,
            'product-name': handle,
            'product-price': Shopify.formatMoney(price, settings.moneyFormat),
            'has-discount': resp.discounts.length > 1 ? true : false,
            'currency': settings.shop_currency
           });
        }
        if(discountSession.getItem('currentDiscount')) {
          console.log('fu223')
          // console.log('check code check campaign 2')
          setTimeout(function() {
            // console.log('check campaign1 timeout')
            smCart.checkCode(discountSession.getItem('currentDiscount'), function(resp) {
              // console.log('check campaign1 after update', resp)
              var respCode = resp;
              discountSession.setItem('discountData', JSON.stringify(respCode));
              setTimeout(function() {
                smCart.checkCampaign();
              }, 500)
            });
          }, 500);
        } else {
          smCart.checkCampaign();
        }
        setTimeout(function() {
          if(window.shopping_cart_type === 'sidebar'){
            console.log('fu2233')
              $('.cart-window-bg').toggleClass('window-hide');
              $('html,body').addClass('drawer-opened');
          } else if(window.shopping_cart_type === 'ajax_popup') {
            console.log('fu2233')
            if (window.innerWidth <= 768) {
              console.log('fu22222')
              setTimeout(function(){
                console.log('fu22111')
                drawerOpen = $('.window-hide');
                if (drawerOpen.length > 0) {
                  $('.cart-notification').slideDown('fast', function () {
                    setTimeout(function () {
                      $('.cart-notification').slideUp('fast');
                    }, 5000);
                  });
                }
    
              },500);
            } else {
              console.log('fu22xx')
              // $(".cart-window-bg").toggleClass("window-hide")
              setTimeout(function(){
                console.log('fu2211')
                drawerOpen = $('.window-hide');
                if (drawerOpen.length > 0) {
                  console.log('fu221221')
                  $('.cart-notification').slideDown('fast', function () {
                    setTimeout(function () {
                      $('.cart-notification').slideUp('fast');
                    }, 5000);
                  });
                }
    
              },500);
            }          
          } 
          if (!$('html.instagram-browser .cart-window-bg').hasClass('window-hide')) {
            $('html,body').addClass('drawer-opened')
            if ($('html').hasClass('instagram-browser')) {
              $('html').removeClass('browser-hide-bar');
              $(".instagram-browser").scrollTop(-50);
            }
          } else {
            $('html,body').removeClass('drawer-opened')
          }
        }, 500)
      
        
        if (window.innerWidth <= 768) {
          console.log('fu22innerWidth')
          setTimeout(function(){
            console.log('fu22innerWidth3')
            drawerOpen = $('.window-hide');
            if (drawerOpen.length > 0) {
              console.log('fu22innerWidth1')
              $('.cart-notification').slideDown('fast', function () {
                setTimeout(function () {
                  $('.cart-notification').slideUp('fast');
                }, 5000);
              });
            }

          },500);
        } else {
          // $(".cart-window-bg").toggleClass("window-hide")
          setTimeout(function(){
            drawerOpen = $('.window-hide');
            if (drawerOpen.length > 0) {
              $('.cart-notification').slideDown('fast', function () {
                setTimeout(function () {
                  $('.cart-notification').slideUp('fast');
                }, 5000);
              });
            }

          },500);
        }

        setTimeout(function() {
          if (!$('html.instagram-browser .cart-window-bg').hasClass('window-hide')) {
            $('html,body').addClass('drawer-opened')
            if ($('html').hasClass('instagram-browser')) {
              $('html').removeClass('browser-hide-bar');
              $(".instagram-browser").scrollTop(-50);
            }
          } else {
            $('html,body').removeClass('drawer-opened')
          }
        }, 500)
      }, function() {
        console.log('fu')
      }, function() {
        smCart.loading(false)
      })
    })
  },
  removeCartListener: function(line) {
    var _this = this
    $("body").on("click", ".cart-item a.remove-cart", function(evt) {
      evt.preventDefault()
      var S = $(this),
          T = S.attr("data-id"),
          L = S.attr("data-line");
      $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&line=" + L,
          dataType: "json",
          beforeSend: function() {
            smCart.loading(true)
          },
          success: function(cart) {
            // console.log('remove success');
            if(discountSession.getItem('currentDiscount')) {
              // console.log('check code check campaign 2')
              setTimeout(function() {
                // console.log('check campaign1 timeout')
                smCart.checkCode(discountSession.getItem('currentDiscount'), function(resp) {
                  // console.log('check campaign1 after update', resp)
                  var respCode = resp;
                  discountSession.setItem('discountData', JSON.stringify(respCode));
                  setTimeout(function() {
                    smCart.checkCampaign();
                  }, 500)
                });
              }, 500);
            } else {
              smCart.checkCampaign();
            }
          },
          error: function(I, A) {
            console.log('remove error')
          }
      })
    })
  },
  updateItemQuantity: function(newval, line) {
    var _this1 = this;
    var stringline = "quantity=" + newval + "&line=" + line;
    _this1._changeCartByLine(stringline, function() {
    }, function(cart) {
      // console.log('qty update')
      if(discountSession.getItem('currentDiscount')) {
        // console.log('check code check campaign 2')
        setTimeout(function() {
          // console.log('check campaign1 timeout')
          smCart.checkCode(discountSession.getItem('currentDiscount'), function(resp) {
            // console.log('check campaign1 after update', resp)
            var respCode = resp;
            discountSession.setItem('discountData', JSON.stringify(respCode));
            setTimeout(function() {
              smCart.checkCampaign();
            }, 500)
          });
        }, 500);
      } else {
        smCart.checkCampaign();
      }
    },
    function(resp) {},
    function(resp) {});
  },
  freeInputQtyListener: function() {
    var _this1 = this;
    $('body').on('focus', '#cart_info .update-product', function(){
      $(this).select();
    });
    $('body').on('keyup', '#cart_info .update-product', function(evt){
      var qty = $(this).val();
      var line = $(this).attr('data-line');
      if (evt.key == 'Enter' || evt.key == 13) {
        $('.update-product').blur();
      }
    });
    $('body').on('blur', '#cart_info .update-product', function(evt){
      var qty = $(this).val();
      var line = $(this).attr('data-line');
      _this1.updateItemQuantity(qty, line);
    })
  },
  qtyCartListener: function() {
    var _this1 = this
    $("body").on("click", ".qty-btn.cart-plus", function(evt) {
      var S = $(this).data("id")
      var newval = parseInt($(S).val()) + 1
      var line = $(S).attr("data-line")
      $(S).val(newval)
      var stringline = "quantity=" + newval + "&line=" + line
      _this1._changeCartByLine(stringline, function() {

      }, function(cart) {
        if(discountSession.getItem('currentDiscount')) {
          // console.log('check code check campaign 2')
          setTimeout(function() {
            // console.log('check campaign1 timeout')
            smCart.checkCode(discountSession.getItem('currentDiscount'), function(resp) {
              // console.log('check campaign1 after update', resp)
              var respCode = resp;
              discountSession.setItem('discountData', JSON.stringify(respCode));
              setTimeout(function() {
                smCart.checkCampaign();
              }, 500)
            });
          }, 500);
        } else {
          smCart.checkCampaign();
        }
      },
      function(resp) {},
      function(resp) {});



    })

    $("body").on("click", ".qty-btn.cart-minus", function(evt) {
      var S = $(this).data("id")
      var newval = parseInt($(S).val()) - 1
      var line = $(S).attr("data-line")
      $(S).val(newval)
      var stringline = "quantity=" + newval + "&line=" + line
      _this1._changeCartByLine(stringline, function() {

      }, function(cart) {
        if(discountSession.getItem('currentDiscount')) {
          setTimeout(function() {
            smCart.checkCode(discountSession.getItem('currentDiscount'), function(resp) {
              var respCode = resp;
              discountSession.setItem('discountData', JSON.stringify(respCode));
              setTimeout(function() {
                smCart.checkCampaign();
              }, 500)
            });
          }, 500);
        } else {
          smCart.checkCampaign();
        }
      },
      function(resp) {},
      function(resp) {

      })
    })
  },
  cartUpsellListener: function(var_id, obj, replaceID, property1 = null) {
    $(".cart-window").scrollTop(0);
    var btnActive = true
    var data = {
      id: parseInt(var_id),
      quantity: 1,
      properties: {
        _product_upsell: true
      }
    }

    if (property1) {
      if (property1 != 'pdp_upsell') {
        data.properties._upsell_only = true
      } else {
        if ($(obj).find('span').hasClass('desktop')) {
          $(obj).find('span.desktop').text('Adding..')
        }
      }
    }

    if ($(obj).hasClass('upsell-added')) {
      btnActive = false
      $(obj).removeClass('upsell-added')
      if ($(obj).find('span').hasClass('desktop')) {
        $(obj).html("<span class='desktop pdp-upsell-cta__label'>Add</span><span class='mobile pdp-upsell-cta__label'></span>")
      }
    }

    if (btnActive) {
      const handle = $(obj).data('handle');
      const location = $(obj).data('location');
      smCart._addCart(data, false, function(resp) {
        // console.log('upsell add');
        if (typeof (ga) === 'function') {
          if (property1 == 'pdp_upsell') {
            var evtLabel = 'PDP Upsell';
          } else if (property1 == 'cart_upsell') {
            var evtLabel = 'Cart Upsell';
          }

          window.ga('send', 'event', {
            eventCategory: 'Upsell',
            eventAction: property1,
            eventLabel: evtLabel,
          });


          window.ga('send', 'event', {
            eventCategory: 'Add To Cart',
            eventAction: location,
            eventLabel: handle
          });
        }
      }, function(resp) {
        if (window.mixpanel) {
          // console.log(resp);
          window.mixpanel.track('Upsell', {
            'section': location,
            'page': window.location.href,
            'product-name': resp.handle || '',
            'product-price': Shopify.formatMoney(resp.price, settings.moneyFormat) || 0,
            'currency': settings.shop_currency
          });
        }
        smCart.checkCampaign();
      }, function() {
        setTimeout(function(){
          if (replaceID) {
            $('.remove-cart[data-id="'+parseInt(replaceID)+'"]').click();
          }
        }, 3000);
        if (property1 && property1 == 'pdp_upsell') {
          if ($(obj).find('span').hasClass('desktop')) {
            $(obj).find('span.desktop').text('Added')
          }
          $(obj).addClass('upsell-added')
          $('.cart-notification').slideDown('fast', function () {
            setTimeout(function () {
              $('.cart-notification').slideUp('fast');
            }, 5000);
          });
        }
      }, function() {
        if ($(obj).find('span').hasClass('desktop')) {
          $(obj).html("<span class='desktop pdp-upsell-cta__label'>Add</span><span class='mobile pdp-upsell-cta__label'></span>")
        }
        console.log('upsell add error')
      })
    } else {
      var data = {
        id: var_id,
        quantity: 0
      }
      smCart._changeCart(data, function() {
        // before send
      }, function(resp) {
        smCart.checkCampaign();
      },
      function(resp) {},
      function(resp) {})
    }
  },
  _addCart: function(data, go_checkout = false, beforeSend, success, complete, error) {
    var _this = this
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: data,
      beforeSend: function(resp){
        console.log('beforeSend')
        smCart.loading(true)
        beforeSend(resp)
      },
      success: function(resp){
        console.log('success')
        success(resp)
    },error: function(resp){
        console.log('error')
        smCart.loading(false)
        // add item line by line in case multiple items add to cart failed
        function itemByLine(index) {
          smCart.loading(true)
          if (data.items && data.items.length > 0) {
            items = data.items
            item = items[index];
            if (item) {
              $.ajax({type: "POST", url: "/cart/add.js", dataType: "json", data: item, complete: function() {
                itemByLine(index+1)
              }});
            } else {
              if (!go_checkout) {
                smCart.buildCart()
              } else {
                smCart.setManualGWP();
                //$("#update-cart, #recharge-checkout").click();
              }
            }
          } else {
            smCart.loading(false)
            smCart.removePromoCode()
          }

        }
        itemByLine(0);
      }
    })
  },
  _changeCartByLine: function(stringline, beforeSend, success, complete, error) {

    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      dataType: 'json',
      data: stringline,
      beforeSend: function(resp){
        smCart.loading(true)
        beforeSend(resp)
      },
      success: function(resp){
        success(resp)
      },
      complete: function(resp){
        complete(resp)
      },
      error: function(resp){
        smCart.loading(false)
        error(resp)
      }
    })
  },
  _changeCart: function(data, beforeSend, success, complete, error) {
    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      dataType: 'json',
      data: data,
      beforeSend: function(resp){
        smCart.loading(true)
        beforeSend(resp)
      },
      success: function(resp){
        success(resp)
      },
      complete: function(resp){
        complete(resp)
      },
      error: function(resp){
        smCart.loading(false)
        error(resp)
      }
    })
  },
  changeCart: function(data) {

  },
  updateQty: function(data) {

  },
  autoAddDiscount: function(cart, pcode, discount_data) {
    var pcode = pcode || ''
    var freeOnCart = cart.items.filter(function(item, index) {
      return item.properties && (item.properties._discount_code || item.properties._discount_code == '')
    })
    var discountData = JSON.parse(discount_data) || {}
    var var_id = null
    var codeOnCookie = null
    var bogoToAdd = []
    var bogoToChange = []
    if (discountData && discountData.data) {
      if (discountData.data.package_items && discountData.data.package_items.length > 0) {
        var pairs = discountData.data.package_items
        pairs.forEach(function(item, i) {
          var itemSplitted = item.split(':')
          var isOnCart = freeOnCart.find(function(item, i) {
            return item.id == parseInt(itemSplitted[0])
          })
          if (!isOnCart) {
            var item = {
              id: parseInt(itemSplitted[0]),
              quantity: itemSplitted[1],
              properties: {
                _discount_code: pcode,
                _bogo_package_bycode: 'yes'
              }
            }
            bogoToAdd.push(item)
          } else {
            var heroinCart = cart.items.find(function(item, i) {
              return item.id == parseInt(itemSplitted[2])
            })
            var qty = itemSplitted[1]
            if (heroinCart) {
              qty = heroinCart.quantity
            }
            var item = {
              id: parseInt(itemSplitted[0]),
              quantity: qty,
              properties: {
                _discount_code: pcode,
                _bogo_package_bycode: 'yes'
              }
            }
            bogoToChange.push(item)
          }
        })
      } else {
        var_id = discountData.data.variant_id || null;
        codeOnCookie = discountData.data.price_rule.title;
        if (discountData.data.can_apply && discountData.data.is_bogo) {
          var_id = discountData.data.price_rule.entitled_variant_ids[0] || null;
        }
      }
    }
    if (bogoToAdd.length > 0 && pcode != '') {
      bogoToAdd.forEach(function(item, i) {
        activeItems.add.items.push(item)
      })
    } else if (var_id && pcode != '') {
      var buysVarId = discountData.data.price_rule.prerequisite_variant_ids
      var buysProdId = discountData.data.price_rule.prerequisite_product_ids
      var buyOnCart = cart.items.filter(function(item, index) {
        return (buysVarId && buysVarId.indexOf(item.id) != -1 && var_id != item.id) || (buysProdId && buysProdId.indexOf(item.product_id) != -1 && var_id != item.id) || discountData.data.price_rule.target_selection == 'all'
      })

      if (freeOnCart.length == 0 && pcode.toLowerCase() == codeOnCookie.toLowerCase()) {
        var data = {
          id: var_id,
          quantity: 1,
          properties: {
            _discount_code: pcode
          }
        }
        activeItems.add.items.push(data)
      } else if (freeOnCart.length > 0 && buyOnCart == 0) {
        data = {
          id: freeOnCart[0].id,
          quantity: 0
        }
        activeItems.change.items.push(data)
        discountSession.removeItem('currentDiscount')
        discountSession.removeItem('discountData')
      }

      smCart.checkCode(pcode, function(resp) {
        if (!resp.data.can_apply && !resp.data.variant_id) {
          $('#promo-code-cta').text('Apply')
          smCart.removePromoCode();
        }
      })
    } else {
      if (bogoToChange.length > 0) {
        bogoToChange.forEach(function(item, i) {
          activeItems.change.items.push(item)
        })
      }
      if (freeOnCart.length > 0) {
        freeOnCart.forEach(function(item ,i) {
          var inActiveChange = activeItems.change.items.find((changeItem, i) => changeItem.id == item.id)
          if (!inActiveChange) {
            var data = {
              id: item.id,
              quantity: 0
            }
            activeItems.change.items.push(data)
          }
        })
      }
    }
  },
  bogoDiscount: function(index, discount_settings, cart, pcode) {
    var pcode = pcode || ''
    var freeOnCart = cart.items.filter(function(item, index) {
      return discount_settings.free == item.variant_id
    })
    var heroOnCart = cart.items.filter(function(item, index) {
      return discount_settings.hero == item.variant_id
    })
    var bogoQty = 1
    if (discount_settings.code.toLowerCase() === pcode.toLowerCase() && heroOnCart.length > 0) {
      if (discount_settings.qty_free_as_buy) {
        bogoQty = heroOnCart[0].quantity
      }
      if (freeOnCart.length == 0) {
        var data = {
          id: discount_settings.free,
          quantity: bogoQty,
          properties: {
            _discount_code: pcode
          }
        }
        activeItems.add.items.push(data)
      } else {
        data = {
          id: freeOnCart[0].id,
          quantity: bogoQty
        }
        activeItems.change.items.push(data)
      }
    } else {
      if (freeOnCart.length > 0) {
        if (freeOnCart[0].id == parseInt(discount_settings.free)) {
          data = {
            id: freeOnCart[0].id,
            quantity: 0
          }
          activeItems.change.items.push(data)
        }
      }
    }
  },
  autoAddCampaign: function(campaign_number, campaign_settings, cart) {
    var minCart = campaign_settings.sm_campaign_auto_add_min;
    if (minCart > 0) {
      var rate = settings.rate
      if (theme.shop_currency != settings.shop_currency) {
          minCart = ((minCart * rate).toFixed(2))
      }
      minCart = minCart * 100
    }

    var validItems = cart.items.filter(function(item, index) {
      return campaign_settings.sm_campaign_auto_add_valid_with.indexOf(item.variant_id) != -1 || campaign_settings.sm_campaign_auto_add_valid_with == ''
    });

    var freeOnCart = cart.items.filter(function(item, index) {
      return campaign_settings.sm_campaign_auto_add_free_item == item.variant_id
    });

    var freeOnCartNotValid = cart.items.filter(function(item, index) {
      if(item.properties && item.properties._product_campaign ){
        return item.properties._product_campaign == '1' && item.variant_id != campaign_settings.sm_campaign_auto_add_free_item;        
      }
    });

    if (freeOnCartNotValid.length) {
      $(freeOnCartNotValid).each(function(index, item){
        var d = {id: item.key, quantity: 0};
        activeItems.change.items.push(d);
      });
    }

    if (campaign_settings.sm_campaign_auto_add_enabled) {
      if (validItems.length && minCart < cart.total_price) {
        if (freeOnCart.length == 0) {
          var data = {
            id: campaign_settings.sm_campaign_auto_add_free_item,
            quantity: campaign_settings.sm_campaign_auto_add_qty,
            properties: {
              '_product_discount': 'true',
              '_product_campaign': '1',
              '_campaign_type': 'auto_gwp',
              '_campaign_text': campaign_settings.sm_campaign_text
            }
          }
          activeItems.add.items.push(data)
        }
      } else {
        if (freeOnCart.length > 0) {
          data = {
            id: freeOnCart[0].id,
            quantity: 0
          }
          activeItems.change.items.push(data)
        }
      }
    } else {
      var productDiscounts = cart.items.filter(function(item, index) {
        return item.properties._product_discount == 'true' && item.properties._campaign_type == 'auto_gwp';
      });

      $(productDiscounts).each(function(index, item){
        var d = {id: item.key, quantity: 0};
        activeItems.change.items.push(d);
      });
    }
  },
  bogoCampaign: function(campaign_number, campaign_settings, cart) {
    var minCart = 0
    var validItems = cart.items.filter(function(item, index) {
      return campaign_settings.sm_campaign_bogo_hero.indexOf(item.variant_id) != -1 || campaign_settings.sm_campaign_bogo_hero.indexOf(parseInt((item.properties && item.properties.original_variant_id) || '0')) != -1
    })
    var bogoItemIds = []
    validItems.map(function(item, i) {
      mixProducts.forEach(function(x, v) {
        x.regular.variants.forEach(function(y, z) {
          if (y.id == item.id || y.id == parseInt((item.properties && item.properties.original_variant_id) || '0')) {
            if (x.discount) {
              bogoItemIds.push(x.discount.variants[z].id)
              item.hiddenBogoItem = x.discount.variants[z].id
            } else {
              console.log('bogo product not found')
            }
          }
        })
      })
    })

    var bogoOnCart = cart.items.filter(function(item, index) {
      return item.properties && item.properties['_campaign_type'] == 'bogo'
    })
    var bogoOnCartIds = bogoOnCart.map(function(item, index) { return item.id })

    if (validItems.length &&  minCart < cart.total_price) {
      validItems.forEach(function(item, index) {
        if (bogoOnCartIds.indexOf(item.hiddenBogoItem) == -1) {
          if (item.hiddenBogoItem) {
            var data = {
              id: item.hiddenBogoItem,
              quantity: item.quantity,
              properties: {
                '_product_discount': 'true',
                '_product_campaign': '3',
                '_campaign_type': 'bogo',
                '_campaign_text': campaign_settings.sm_campaign_text
              }
            }
            activeItems.add.items.push(data)
          }
        }
      })
    }

    if (bogoOnCart.length > 0) {
      var heroOnCart = validItems.map(function(item, index) { return item.hiddenBogoItem })

      bogoOnCart.forEach(function(item, index) {
        if (heroOnCart.indexOf(item.id) == -1) {
          var data = {
            id: item.variant_id,
            quantity: 0
          }
          activeItems.change.items.push(data)
        } else {
          var _item = validItems.find(function(valid, i) {
            return valid.hiddenBogoItem == item.variant_id
          })
          if (_item) {
            var data = {
              id: item.variant_id,
              quantity: _item.quantity
            }
            activeItems.change.items.push(data)
          }
        }
      })
    }
  },
  checkCampaign: function(go_checkout = false, callback) {
    console.log('checkCampaign1')
    if (go_checkout) {
      $("#fake-checkout").html("Processing...")
    }

    if(discountSession.getItem('currentDiscount')) {
      smCart.checkCode(discountSession.getItem('currentDiscount'), function(resp) {
        var respCode = resp;
        discountSession.setItem('discountData', JSON.stringify(respCode));
        if (!resp.data.can_apply && !resp.data.variant_id) {
          $('#promo-code-cta').text('Apply')
          smCart.removePromoCode();
        }
      });
    }
    console.log('checkCampaign2')
    var _this = this
    var gCart = this.getCart()
    gCart.done(function(cart) {
      console.log('checkCampaign3')
      smCart.buildCart(cart)
      activeItems.add.items = []
      activeItems.change.items = []
      if (smCampaign.autoAdd.length > 0) {
        smCampaign.autoAdd.forEach(function(item, index) {
          smCart.autoAddCampaign(index, item, cart)
        })
      }

      if (smCampaign.bogo.length > 0) {
        smCampaign.bogo.forEach(function(item, index) {
          smCart.bogoCampaign(index, item, cart)
        })
      }

      let listBlockedProductsStatus = 'false' == 'true';
      let whitelistCodes = 'mystery,hello,sorry10,vipbogo,gogetit5,getnow10,get15off,epkv684,cx7pg785,smpy10,get25,get35';
      if (listBlockedProductsStatus) {
        let listBlockedProducts = '';
        let blockedItems = cart.items.filter(function(i,v){return listBlockedProducts.includes(i.id)})
        if(discountSession.getItem('currentDiscount')) {
          // check start
          if(!whitelistCodes.includes(discountSession.getItem('currentDiscount').toLowerCase()) && blockedItems.length != 0) {
            // console.log('check white list =>', discountSession.getItem('currentDiscount'));
            discountSession.removeItem('currentDiscount')
            discountSession.removeItem('discountData')
          }
        }
      }

      var discountData = null
      if (discountSession.getItem('discountData') && discountSession.getItem('discountData') != '' && discountSession.getItem('discountData') != null) {
        discountData = discountSession.getItem('discountData')
      }
      smCart.autoAddDiscount(cart, discountSession.getItem('currentDiscount'), discountData);

      var upsell_only_items = cart.items.filter(function(item, index) {
        return item.properties && item.properties._upsell_only
      })

      var upsell_only_total = 0
      upsell_only_items.forEach(function(item, index) {
        upsell_only_total = upsell_only_total + item.line_price
      })

      if (upsell_only_total == cart.items_subtotal_price) {
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function(){
            smCart.buildCart(cart)
          },
          dataType: 'json'
        });
      } else if (activeItems.add.items.length > 0) {
        _this._addCart(activeItems.add, go_checkout,
          function(resp) {
            console.log('resp');
            smCart.buildCart(cart)
          },
          function(resp) {
            console.log('resp2');
            if (activeItems.change.items.length > 0) {
              activeItems.change.items.forEach(function(item, index) {
                setTimeout(function() {
                  _this._changeCart(item, function() {
                    // before send
                  }, function(resp) {
                    // console.log('change succcess '+index)
                    if (typeof callback === 'function') {
                      callback();
                    } else if (go_checkout) {
                      smCart.setManualGWP(cart);
                      //$("#update-cart, #recharge-checkout").click();
                    } else {
                      smCart.buildCart(cart)
                    }
                  },
                  function(resp) {},
                  function(resp) {})
                }, 500)
              })
            } else {
              if (typeof callback === 'function') {
                callback();
              } else {
                smCart.buildCart(cart)
              }
            }
          },
          function(resp) {},
          function(resp) {}
        )
      } else {
        if (activeItems.change.items.length > 0) {
          activeItems.change.items.forEach(function(item, i) {
            setTimeout(function() {
              _this._changeCart(item, function() {

              }, function(cart) {
                // console.log('change succcess')
                if (typeof callback === 'function') {
                  callback();
                } else if (go_checkout) {
                  smCart.setManualGWP(cart);
                  //$("#update-cart, #recharge-checkout").click();
                } else {
                  smCart.buildCart(cart)
                }
              },
              function(resp) {},
              function(resp) {})
            }, 1200*i)
          })
        } else {
          if (typeof callback === 'function') {
            callback();
          } else if (go_checkout) {
            smCart.setManualGWP(cart);
            //$("#update-cart, #recharge-checkout").click();
          } else {
            smCart.buildCart(cart)
          }
        }
      }
      console.log('checkCampaign4')
    })
  },
  discountBar: function (cart) {
    let discountBar = 'false' == 'true';
    let withDiscount = 'false' == 'true';
    let excludeProducts = window.themeSettings.excludeProductsDiscountBar;
    let discountBarLimit = 0;
    let discountBarRemaining = 0;
    let discountBarGift = '';
    let discountBarFull = false;
    let discountBarProgress = 0;
    const threshold = [{
      limit: parseInt('10000'),
      gift: 'free product',
    }, {
      limit: parseInt('0'),
      gift: '',
    }, {
      limit: parseInt('0'),
      gift: '',
    }, {
      limit: parseInt('0'),
      gift: '',
    }];

    let totalPrice = withDiscount ? cart.total_price : cart.original_total_price;
    if (excludeProducts != '') {
      $.each(cart.items, function(index, item) {
        if (excludeProducts.includes(item.sku) && item.sku != '') {
          totalPrice = totalPrice - item.original_line_price
        }
      })
    }

    for (let i = 0; i < threshold.length; i += 1) {
      const t = threshold[i];
      if (t.limit === 0) { break; }
      else {
        discountBarLimit = t.limit;
        discountBarGift = t.gift;
        discountBarRemaining = t.limit - totalPrice;
        if (discountBarRemaining <= 0) {
          discountBarProgress = 100;
          discountBarFull = true;
        } else {
          discountBarProgress = 100 - (discountBarRemaining / t.limit * 100);
          discountBarFull = false;
          break;
        }
      }
    }

    if (discountBarLimit === 0) { discountBar = false; }

    return {
      discountBar,
      discountBarLimit: Shopify.formatMoney(discountBarLimit),
      discountBarRemaining: Shopify.formatMoney(discountBarRemaining),
      discountBarGift,
      discountBarFull,
      discountBarProgress,
    };
  },
  shippingBar: function (cart) {
    let freeShippingBar = false;
    let freeShippingBarLimit = 0
    let freeShippingBarRemaining = 0;
    let freeShippingBarProggress = 0;
    let freeShippingBarFull = false;

    const { shipping, zone } = window.getShippingPrice(cart.total_price)

    if (zone && zone.price_shipping_rates) {
      var freerate = zone.price_shipping_rates.find(function (r) {
        return r.price == 0
      });
      if (freerate) {
        freeShippingBar = true;
        freeShippingBarLimit = parseInt(freerate.min_order_subtotal) * 100
        freeShippingBarRemaining = freeShippingBarLimit - cart.total_price
        // console.log('zone',zone)
        if (freeShippingBarRemaining <= 0) {
          freeShippingBarProggress = 100
          freeShippingBarFull = true
        } else {
          freeShippingBarProggress = 100 - (freeShippingBarRemaining / freeShippingBarLimit * 100)
          freeShippingBarFull = false
          // console.log('freerate',freeShippingBarLimit, freeShippingBarRemaining, freeShippingBarProggress)
        }
      } else {
        freeShippingBar = false
      }
    }

    if ('true' == 'false') {
      freeShippingBar = false
    }

    return {
      freeShippingBar,
      freeShippingBarLimit,
      freeShippingBarRemaining: Shopify.formatMoney(freeShippingBarRemaining),
      freeShippingBarProggress,
      freeShippingBarFull
    }
  },
  updateGWPInfo: function(){
    var currentInfo = $(".cart-gwp-info").text();
    infoArr = currentInfo.split('/');
    tempData = discountSession.getItem("freeTemporary") ? JSON.parse(discountSession.getItem("freeTemporary")) : [];
    $(".cart-gwp-info").text([tempData.length, infoArr[1]].join("/"));
    if (parseInt(manual_gwp_opt.max_item) <= tempData.length){
      // $(".list-gwp-on-cart button.btn--primary").prop('disabled',true);
    } else {
      $(".list-gwp-on-cart button.btn-primary:not([data-stock-available='false'])").removeAttr('disabled');
    }
    $(".warning-checkout").addClass('hide');
  },
  addFreeItemTemporary: function(id,el){
    if (discountSession.getItem('freeTemporary')) {

      prevData = JSON.parse(discountSession.getItem('freeTemporary'));
      if (parseInt(manual_gwp_opt.max_item) == prevData.length && parseInt(manual_gwp_opt.max_item) == 1) {
        prevData = [];
        $(".exist-on-cart").each(function(i,e){
          btnItem = $(e).find('button');
          if (btnItem && btnItem.data('stock-available')) {
            varId = btnItem.data('variant-id');
            btnItem.attr("onclick", "smCart.addFreeItemTemporary("+varId+",this)");
            btnItem.attr('data-cy', 'cart-addfreegift-btn');
            btnItem.removeClass("btn-secondary").addClass('btn-primary');
            btnItem.text($(btnItem).data('text-add'));
          }
          $(e).removeClass('exist-on-cart');
        });
      }
      prevData.push(id);
      discountSession.setItem('freeTemporary', JSON.stringify(prevData));
    } else {
      discountSession.setItem('freeTemporary', JSON.stringify([id]));
    }
    $(el).parents('li').addClass('exist-on-cart');
    $(el).attr("onclick", "smCart.removeFreeItemTemporary("+id+",this)");
    $(el).removeClass("btn-primary").addClass('btn-secondary');
    $(el).text($(el).data('text-remove'));
    $("#dont-want-free-item").prop("checked",false);
    this.updateGWPInfo();
  },
  removeFreeItemTemporary: function(id,el) {
    $(el).parents('li').removeClass('exist-on-cart');
    $(el).attr("onclick", "smCart.addFreeItemTemporary("+id+",this)");
    $(el).attr('data-cy', 'cart-addfreegift-btn');
    $(el).removeClass("btn-secondary").addClass('btn-primary');
    $(el).text($(el).data('text-add'));
    if (discountSession.getItem('freeTemporary')) {
      prevData = JSON.parse(discountSession.getItem('freeTemporary'));
      position = prevData.indexOf(id);
      prevData.splice(position,1);
      discountSession.setItem("freeTemporary",JSON.stringify(prevData));
    }
    this.updateGWPInfo();
  },
  setManualGWP: function(cart = null){
     console.log('successGWp3');
    if (cart !== null) {
      this.runMixpanel(cart);
    }
     console.log('successGWp4');
    let manualGWPdata = {};
    let dontWantFreeItem = $('#dont-want-free-item').prop('checked');
    if (manual_gwp && $('.manual-gwp-box').length > 0) {
      let tempData = discountSession.getItem('freeTemporary') ? JSON.parse(discountSession.getItem('freeTemporary')) : [];
      if (tempData.length > 0) {
        $.each(tempData, function(index,var_id){
          if (cart) {
            var isInCart = cart.items.find(function(item, i) {
              return item.id == var_id && item.properties && item.properties._campaign_type === 'manual_gwp'
            })
            if (!isInCart) {
              manualGWPdata = {id: var_id, quantity: 1, properties: {_campaign_type: 'manual_gwp', _product_discount: 'true'}};
            }
          } else {
            manualGWPdata = {id: var_id, quantity: 1, properties: {_campaign_type: 'manual_gwp', _product_discount: 'true'}};
          }
        });
      }
    }

    if (!$.isEmptyObject(manualGWPdata) && !dontWantFreeItem) {
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: manualGWPdata,
        beforeSend: function(resp){
          // console.log('beforeSend');
        },
        success: function(resp){
           console.log('successGWp');
          $("#update-cart, #recharge-checkout").click();
        },
        complete: function(resp){
          // console.log('complete');
          
        },
        error: function(resp){
          console.log('error', resp);
        }
      });
    } else {
      console.log('successGWp2');
      $("#update-cart, #recharge-checkout").click();
    }
  },
  runMixpanel: function(cart) {
    const discountedPrice = parseInt($('.cart-checkout-button').find('.cart-total .money').attr('data-price'));
    const saving = cart.total_price - discountedPrice;
    let discountType = '';
    let discountName = '';
    let isApplied = discountSession.getItem('currentDiscount') && discountSession.getItem('currentDiscount') !== '';
    if (discountSession.getItem('discountData')) {
      discountName = discountSession.getItem('currentDiscount');
      const discountData = JSON.parse(discountSession.getItem('discountData'));
      if (discountData.data.is_bogo) {
        discountType = 'Buy X get Y'
      } else {
        discountType = discountData.data.price_rule.value_type || '';
      }
    }
    const itemsQtyArr = cart.items.map(x => x.quantity);
    let itemsQtyTotal = 0;
    for (let i = 0; i < itemsQtyArr.length; i++) {
      itemsQtyTotal += itemsQtyArr[i];
    }
    if (window.mixpanel) {
      window.mixpanel.track('Cart CTA', {
        'cart-items': itemsQtyTotal || 0,
        'cart-value': Shopify.formatMoney(discountedPrice, settings.moneyFormat) || 0,
        'cart-savings': Shopify.formatMoney(saving, settings.moneyFormat) || 0,
        'promocode-used': isApplied,
        'promocode-name': discountName,
        'promocode-type': discountType,
        'currency': settings.shop_currency
      });
    }
  },
  getFreeTemporaryData: function(){
    return discountSession.getItem('freeTemporary') ? JSON.parse(discountSession.getItem('freeTemporary')) : [];
  },
  getDefaultManualGWPVariantID: function(cart){
    let manual_gwp_auto_select = false;
    for (let i=0;i<=manual_gwp_items.length-1;i++) {
      if (i == manual_gwp_auto_index && manual_gwp_items[i].product.available && cart.original_total_price > manual_gwp_items[i].min_amount) {
        manual_gwp_auto_select = manual_gwp_items[i].product.variant_id;
        break;
      } else if (manual_gwp_items[i].product.available && cart.original_total_price > manual_gwp_items[i].min_amount){
        //set next items if not available from selection settings
        manual_gwp_auto_select = manual_gwp_items[i].product.variant_id;
        break;
      }
    }
    return manual_gwp_auto_select;
  },
  defaultManualGWP: function(cart){
    let manual_gwp_ids = [];

    if (manual_gwp_items.length && smCart.getDefaultManualGWPVariantID(cart) != false) {
      $.each(manual_gwp_items,function(k,v){
        manual_gwp_ids.push(v.product.variant_id);
        //check if gwp items has required min amount
        if (smCart.getFreeTemporaryData().length > 0 && smCart.getFreeTemporaryData().indexOf(v.product.variant_id) >=0 && cart.original_total_price < v.min_amount) {
          discountSession.setItem('freeTemporary', JSON.stringify([smCart.getDefaultManualGWPVariantID(cart)]));
        }
      });
    }

    return manual_gwp_ids;
  },
  clearManualGWP: function(cart){
    let manual_gwp_ids = smCart.defaultManualGWP(cart);
    if (manual_gwp_ids.length > 0 && cart.items.length > 0) {
      $.each(cart.items, function(k, items){
        if (manual_gwp_ids.indexOf(items.variant_id) >= 0 && items.properties && items.properties._campaign_type === 'manual_gwp') {
          let data = {
            id: items.key,
            quantity: 0
          }
          smCart._changeCart(data, function(){}, function(){}, function(){});
        }
      });
    }
  },
  unSelectManualGWP(el) {
    let tempData = smCart.getFreeTemporaryData();
    if ($(el).prop('checked')) {
      $('.list-gwp-on-cart').find('.btn').prop('disabled', true);
      $('.list-gwp-on-cart').find('.btn[data-variant-id="'+tempData+'"]').html('Add');
    } else {
      $('.list-gwp-on-cart').find('.btn').prop('disabled', false);
      $('.list-gwp-on-cart').find('.btn[data-variant-id="'+tempData+'"]').html('Remove');
    }
  },
  buildCart: function(cart) {
    var _this = this
    var gCart = this.getCart()
    gCart.done(function(cart) {
      var $cart_container = $('.cart-window-body')

      $cart_container.empty()
      window.getAllProducts((all_products) => {
        var cartItemsArr = cart.items.map(function(item, i){ return item.id })

        // Handlebars.js cart layout
        var items = [],
          upsells = [],
          item = {},
          upsell = {},
          data = {},
          source = $('#cartRowTemplate').html(),
          template = Handlebars.compile(source),
          cart_has_subscription_item = false,
          has_regular = true,
          saving = 0,
          compareDiffNormal = 0,
          compareDiffFree = 0,
          totalDiscount = 0,
          subsSaving = 0,
          total_price = cart.total_price,
          counter_min = 0,
          isUpsell_available = false,
          cartHandles = [],
          cartHandlesID = [];

        discountSetting = {
          cart_min: 0,
          name: null,
          discount: null,
          products: [],
          type: null,
          can_apply: false,
          discount_type: null,
          apply_for: null
        }

        // Discount applied
        var discountSaved = false
        var discountCode = null
        var discountedCount = 0
        let listBlockedProductsStatus = 'false';
        let whitelistCodes = 'mystery,hello,sorry10,vipbogo,gogetit5,getnow10,get15off,epkv684,cx7pg785,smpy10,get25,get35';
        if (listBlockedProductsStatus) {
          let listBlockedProducts = '';
          let blockedItems = cart.items.filter(function(i,v){return listBlockedProducts.includes(i.id)})
          if(discountSession.getItem('currentDiscount')) {
            // check start
            if(!whitelistCodes.includes(discountSession.getItem('currentDiscount').toLowerCase()) && blockedItems.length != 0) {
              // console.log('check white list =>', discountSession.getItem('currentDiscount'));
              discountSession.removeItem('currentDiscount')
              discountSession.removeItem('discountData')
            }
          }
        }
        if (discountSession.getItem('currentDiscount')) {
          discountCode = discountSession.getItem('currentDiscount')
          discountSaved = true
        }

        if (discountSession.getItem('discountData')) {
          // smCart.recalculateDiscountTier(cart.total_price);

          var discountData = JSON.parse(discountSession.getItem('discountData'))
          if ((discountData.data && discountData.data.variant_id) || (discountData.data && discountData.data.price_rule.prerequisite_subtotal_range == null)) {
            if (!discountData.data.is_bogo) {
              discountSetting.apply_for = discountData.data.apply_for
              discountSetting.type = discountData.data.price_rule.value_type
              discountSetting.discount = discountData.data.price_rule.value
              if (discountData.data.price_rule.entitled_variant_ids) {
                discountSetting.products = discountData.data.price_rule.entitled_variant_ids
              }
              if (discountData.data.variant_id) {
                discountSetting.type = 'bogo'
              }
            } else {
              discountSetting.type = 'bogo'
            }
          } else {
            discountSetting = {
              cart_min: discountData.data.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to,
              name: discountData.data.price_rule.title,
              discount: discountData.data.price_rule.value,
              products: discountData.data.price_rule.entitled_variant_ids,
              type: discountData.data.price_rule.value_type,
              apply_for: discountData.data.apply_for
            }
          }

					const dicountCap = DISCOUNT_CODES_WITH_CAP.find(function (d, i) {
						return discountCode && d.code.toLowerCase() == discountCode.toLowerCase() && window.themeSettings.discount_cap
					})

					if (dicountCap) {
						discountSetting.discount = dicountCap.percent;
						discountSetting.cap = dicountCap.discount_cap;
						discountSetting.products = 'all';
						discountApplied = false;
					}
          smCart.checkExitIntentCode('show', discountCode);

        } else if (typeof timer !== 'undefined' && window.themeSettings.exit_intent) {
          clearInterval(timer);
        }

        var bogoSavingPrice = 0;
        var pdp_upsells_container = $('.product-info-upsell .product-upsell-box')
        var pdp_upsells_ids = []
        if (pdp_upsells_container.length > 0) {

          pdp_upsells_container.each(function(i, item_) {
            var cur_id = $(item_).attr('data-variant')
            pdp_upsells_ids.push(parseInt(cur_id))
            $('.product-info-upsell .product-upsell-box[data-variant="'+cur_id+'"] .pdp-upsell-cta').html("<span class='desktop pdp-upsell-cta__label'>Add</span><span class='mobile pdp-upsell-cta__label'></span>").removeClass('upsell-added')
          })
        }

        let cartHasManualGWP = false;
        var origSubTotal = 0;
        $.each(cart.items, function(index, cartItem) {
          var prodImg;
          if (cartItem.image !== null) {
            prodImg = cartItem.image
              .replace(/(\.[^.]*)$/, '_medium$1')
              .replace('http:', '');
          } else {
            prodImg =
              '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
          }

          var free_item = false, is_subscription = false, upsell_discount = false, item_discount = false, isCompare = false, item_subscription = false, original_variant_id = '', package_ = null, bogo = false
          var cart_text = ''
          var new_subscription_price
          var frequency = ''
          var txt_info = ''
          var mont_secs = null
          var original_var_id = cartItem.id
          var compare_price = null
          var compare_price_diff = 0
          var clickable = true
          var new_subscription_price = 0
          var freebogo = false
          var showbogoQty = false
          var line_badge = ''
          var badgeEnable = false
          var discountApplied = false
          var discountPrecentageRow = null
          var recharge_discount = false


          if (cartItem.properties && cartItem.properties.subscription_id) {
            is_subscription = true
            original_var_id = cartItem.properties.original_variant_id
          }

          var itemInProduct = all_products.find(function(item, index) {
            return item.variants.find(function(item, index) {
              return item.id == original_var_id
            })
          })

          if (itemInProduct) {
            v = itemInProduct.variants.filter(function(x,y){return x.id == cartItem.id});
            if (v.length > 0) {
              if (v[0].compare_price) {
                isCompare = true
                compare_price = v[0].compare_price
                compare_price_diff = compare_price - v[0].price
                if (v[0].price > 0) {
                  compareDiffNormal += compare_price_diff * cartItem.quantity
                } else {
                  compareDiffFree += compare_price_diff * cartItem.quantity
                }
              }
            }
          }

          if (cartItem.properties && cartItem.properties.subscription_id) {

            if (itemInProduct) {
              itemInProduct.variants[0].metafields.forEach(function(item, i) {
                if (item[0] == 'compare_at_price') {
                  new_subscription_price = item[1];
                  compare_price = item[1];
                  isCompare = true;
                }
              });

              if (!isCompare) {
                let v = itemInProduct.variants[0];
                if (v.compare_price) {
                  compare_price = v.compare_price;
                  isCompare = true;
                } else {
                  compare_price = v.price;
                  isCompare = true;
                }
              }
            }
          }

          var bogoPair = mixProducts.find(function(x, v) {
            return x.regular.variants.find(function(y, z) {
              return y.id == original_var_id
            })
          })

          if (bogoPair && bogoPair.discount) {
            bogo = true
            if (smCampaign.bogo.length > 0 && smCampaign.bogo[0].sm_campaign_badge != '') {
              line_badge = smCampaign.bogo[0].sm_campaign_badge
              badgeEnable = true
            }
          }

          if (cartItem.properties && cartItem.properties.shipping_interval_frequency) {
            cart_has_subscription_item = true
            item_subscription = true
            frequency = cartItem.properties.shipping_interval_frequency
            var freq_month = frequency / 30
            var mont_secs = freq_month * 2592000
            if (freq_month == 1) {
              txt_info = "every month"
            } else {
              txt_info = 'every ' + freq_month + ' months'
            }
          }

          if (cartItem.properties && cartItem.properties.product_discount) {
            item_discount = true
          }

          if (cartItem.properties && cartItem.properties.original_variant_id) {
            original_variant_id = cartItem.properties.original_variant_id
          }

          if (cartItem.properties && cartItem.properties._campaign_text) {
            cart_text = cartItem.properties._campaign_text
          }

          if (cartItem.price == 0 && cartItem.properties && cartItem.properties._discount_code) {
            cart_text = 'FREE!';
          }

          if (cartItem.price == 0 || (cartItem.properties && cartItem.properties._campaign_type == 'bogo')) {
            free_item = true
            clickable = false
            freebogo = true
            if (cartItem.quantity > 1) {
              showbogoQty = true
            }
          }

          if (cartItem.properties && cartItem.properties._product_upsell) {
            upsell_discount = true
          }

          // CHECK DO NOT COUNT ITEM
          var campaignItem = smCampaign.autoAdd.find(function(item, index) {
            return item.sm_campaign_auto_add_free_item == cartItem.id
          })

          if (campaignItem && campaignItem.sm_campaign_counter != '') {
            counter_min = counter_min + parseInt(campaignItem.sm_campaign_counter)
          } else {
            counter_min = counter_min + cartItem.quantity
          }

          var timeObject = new Date();
          var next_bill = new Date(timeObject.getTime() + (mont_secs*1000))

          var dd = next_bill.getDate()
          var mm = next_bill.getMonth()
          var yyyy = next_bill.getFullYear()
          next_bill = dd+'-'+mm+'-'+yyyy


          var discountPrecentageLabel = {}
          if (discountSaved && discountSetting.type == 'percentage') {
            // REGULAR CODE
            if (discountSetting && (discountSetting.products.indexOf(cartItem.id) != -1 || discountSetting.products == 'all')) {
              discountApplied = true
              discountedCount = discountedCount + 1
              if (discountSetting.type == 'percentage') {
                var perc = Math.floor(parseInt(discountSetting.discount) * -1)
                var amount = (Math.floor((cartItem.price * perc) / 100)) * cartItem.quantity;
								var compareAmount = (Math.floor((compare_price * perc) / 100)) * cartItem.quantity;
              } else {
                var fixed = Math.floor(parseInt(discountSetting.discount) * -1) * 100
                var amount = fixed;
              }

              discountPrecentageLabel = {
                title: discountSetting.name,
                amount: Shopify.formatMoney(
                  amount,
                  settings.moneyFormat
                )
              }

              // calculate savings
              saving = saving + amount
              total_price = total_price - amount
              if (compare_price == null) {
                compare_price = cartItem.price
              }
            }
          }

          if (pdp_upsells_ids.indexOf(cartItem.variant_id) != -1) {
            $('.product-info-upsell .product-upsell-box[data-variant="'+cartItem.variant_id+'"] .pdp-upsell-cta').html("<span class='desktop pdp-upsell-cta__label'>Added</span><span class='mobile pdp-upsell-cta__label'></span>").addClass('upsell-added')
          }

					const price = (discountSetting && discountSetting.cap) ? (cartItem.price * cartItem.quantity) : cartItem.original_line_price;
					const priceFormatted = (discountSetting && discountSetting.cap) ? Shopify.formatMoney(cartItem.price * cartItem.quantity, settings.moneyFormat) : Shopify.formatMoney(
						cartItem.original_line_price,
						settings.moneyFormat
					);

					if (discountSetting && discountSetting.cap) {
						discountApplied = false;
					}


          item = {
            prodid: cartItem.product_id,
            varId: cartItem.id,
            sku: cartItem.sku,
            is_subscription: is_subscription,
            upsell_discount: upsell_discount,
            item_discount: item_discount,
            free_item: free_item,
            clickable: clickable,
            key: cartItem.key,
            line: index + 1,
            url: cartItem.url,
            img: prodImg,
            name: cartItem.title,
            quantity: cartItem.quantity,
            variant_id: cartItem.variant_id,
            variation: cartItem.variant_title,
            properties: cartItem.properties,
            originalPrice: cartItem.price,
            originalPrice_c: Shopify.formatMoney(
              cartItem.price,
              settings.moneyFormat
            ),
            price: price,
            price_c: priceFormatted,
            discountedPrice: Shopify.formatMoney(cartItem.price - cartItem.total_discount / cartItem.quantity, settings.moneyFormat),
            priceTimesQty: cartItem.original_line_price * cartItem.quantity,
            priceTimesQty_c: Shopify.formatMoney(
              cartItem.original_line_price * cartItem.quantity,
              settings.moneyFormat
            ),
            compareAtPrice: compare_price,
            compareAtPrice_c: Shopify.formatMoney(
              compare_price,
              settings.moneyFormat
            ),
            comparePriceTimesQty: compare_price * cartItem.quantity,
            comparePriceTimesQty_c: Shopify.formatMoney(
              compare_price * cartItem.quantity,
              settings.moneyFormat
            ),
            isCompare: isCompare,
            savingPriceMinCompare: cartItem.original_line_price - cartItem.compare_at_price,
            discountedPrice: Shopify.formatMoney(
              cartItem.final_line_price,
              settings.moneyFormat
            ),
            discounts: cartItem.line_level_discount_allocations,
            discountsApplied: cartItem.line_level_discount_allocations.length === 0 ? false : true,
            vendor: cartItem.vendor,
            package: package_,
            def_qty: 1,
            cart_text: cart_text,
            bogo: bogo,
            freebogo: freebogo,
            showbogoQty: showbogoQty,
            new_subscription_price: new_subscription_price,
            mont_secs: mont_secs,
            next_bill: next_bill,
            line_badge: line_badge,
            badgeEnable: badgeEnable,
            handle: cartItem.handle,
            discountApplied: discountApplied,
            discountPrecentageLabel: discountPrecentageLabel,
            bogoSaving: false,
            showBadge: window.themeSettings.cart_drawer_badge == cartItem.handle
          }

          //calculate bogo saving
          if (window.themeSettings.bogo_saving) {
            item.bogoSaving = true;
            if (item.comparePriceTimesQty > item.price) {
             bogoSavingPrice += (item.comparePriceTimesQty - item.price)
            }

          }

          // calculate tiered discount by qty saving
          if (window.themeSettings.tiered_discount_qty) {
            item.tieredQtySaving = true;
            origSubTotal += item.price;
          }


          if (discountApplied) {
            item.isCompare = true
            item.compareAtPrice = cartItem.original_line_price
            item.price = Math.round(cartItem.original_line_price - amount)
            item.compareAtPrice_c = Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat)
            item.price_c = Shopify.formatMoney(Math.round(cartItem.original_line_price - amount), settings.moneyFormat);
          }

          if (window.preorderVariants.indexOf(item.variant_id.toString()) != -1) {
            item.preorder_note = theme.strings.preorder_note;
          }

          if (cartItem.properties && cartItem.properties._bb_guides && cartItem.properties._bb_guides && cartItem.properties._product_upsell == undefined) {
            item.isCompare = true
            item.comparePriceTimesQty = cartItem.original_line_price
            item.comparePriceTimesQty_c = Shopify.formatMoney(cartItem.original_line_price,settings.moneyFormat)
            item.compareAtPrice = cartItem.original_line_price
            item.price = Math.round(cartItem.final_line_price)
            item.compareAtPrice_c = Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat)
            item.price_c = Shopify.formatMoney(Math.round(cartItem.final_line_price), settings.moneyFormat);
          }

          cartHandles.push(item.handle);
          cartHandlesID.push(item.variant_id);

          //CALCULATE SUBS SAVING
          if (item.is_subscription && !discountApplied) {
            var diff = item.compareAtPrice - item.originalPrice;
            var amt = diff * cartItem.quantity
            subsSaving = subsSaving + amt;
          }
          item.subsSaving = subsSaving;

          items.push(item);

          if (item.properties && item.properties._campaign_type == 'manual_gwp') {
            cartHasManualGWP = true;
          }
        });

        var newUpsells = [];
        var removeUpsell = []
        $.each(smUpsell.pairedUpsells, function(index, upsellItem) {
          var inCartArray = upsellItem.in_cart;
          if (upsellItem.in_cart == 'all') {
            newUpsells.push(upsellItem);
            if (upsellItem.remove_upsell) {
              $.each(upsellItem.remove_upsell, function(index, removeItem) {
                removeUpsell.push(removeItem)
              })
            }
          } else {
            var result = inCartArray.every(function(val) {
              return cartHandles.indexOf(val) >= 0;
            });
            if (result){
              newUpsells.push(upsellItem);
              if (upsellItem.remove_upsell) {
                $.each(upsellItem.remove_upsell, function(index, removeItem) {
                  removeUpsell.push(removeItem)
                })
              }
            }
          }

        });

        // BUILD UPSELLS
        $.each(newUpsells, function(index, upsellItem) {

          var product = window.upsellProducts.find(function(item, i) {
            if (item.handle == upsellItem.recommended && removeUpsell.indexOf(item.handle) == -1) {
              return item;
            }
          });

          h = upsellItem.in_cart[upsellItem.replace_item];
          idxs = cartHandles.indexOf(h);
          pairedID = cartHandlesID[idxs];



          if (product && product.isAvail) {
            firtVariant = product.variants[0];
            saveTxt = '';
            showDiscountUpsell = false;
            if (firtVariant.compare_price > 0) {
              var percentage = ((firtVariant.compare_price - firtVariant.price) / firtVariant.compare_price) * 100
              saveTxt = 'SAVE ' + percentage.toFixed() +'%';
              showDiscountUpsell = true;
            }

            var upsell_only = false

            if (upsellItem.upsell_only) {
              upsell_only = upsellItem.upsell_only
            }


            upsell = {
              variant: firtVariant,
              discount: saveTxt,
              showDiscountUpsell: showDiscountUpsell,
              isAdditional: true,
              additional: upsellItem.description.split('<br>'),
              u_compare_price: firtVariant.compare_price,
              price: firtVariant.price,
              u_compare_price_c: firtVariant.compare_price_c,
              price_c: firtVariant.price_c,
              isCompare: (firtVariant.compare_price) ? true : false,
              variant_id: firtVariant.id,
              img: product.image,
              title: product.title,
              mode: upsellItem.mode,
              handle: product.handle,
              purl: product.url,
              pairedItem: (upsellItem.mode == 'replace') ? pairedID : null,
              upsell_only: upsell_only
            }




            if (cartHandles.indexOf(upsellItem.recommended) >= 0) {
              //var idx = cartHandles.indexOf(upsellItem.recommended);
              //upsells.splice(idx, 1);
            } else {
              upsells.push(upsell)
            }

          }

        })

        var staticUpsells = [];
        $.each(smUpsell.staticUpsells, function(index, upsellItem) {
          var product = window.upsellProducts.find(function(item, i) {
            if (item.handle == upsellItem.upsell_product && cartHandles.indexOf(upsellItem.upsell_product) == -1) {
              return item;
            }
          });

          if (product && product.isAvail) {
            firtVariant = product.variants[0];
            saveTxt = '';
            showDiscountUpsell = false;
            if (firtVariant.compare_price > 0) {
              var percentage = ((firtVariant.compare_price - firtVariant.price) / firtVariant.compare_price) * 100
              saveTxt = 'SAVE ' + percentage.toFixed() +'%';
              showDiscountUpsell = true;
            }

            var staticUpsell = {
              variant: firtVariant,
              discount: saveTxt,
              showDiscountUpsell: showDiscountUpsell,
              description: upsellItem.cart_upsell_desc,
              u_compare_price: firtVariant.compare_price,
              price: firtVariant.price,
              u_compare_price_c: firtVariant.compare_price_c,
              price_c: firtVariant.price_c,
              isCompare: (firtVariant.compare_price) ? true : false,
              variant_id: firtVariant.id,
              img: product.image,
              title: product.title,
              handle: product.handle,
              purl: product.url
            }

            staticUpsells.push(staticUpsell)
          }
        })

        // Check if discount is applied
        var cartDiscountParam = ""
        if (discountSession.getItem('currentDiscount')) {
          cartDiscountParam = "?discount=" + discountSession.getItem('currentDiscount')
        } else {
          cartDiscountParam = '?discount=';
        }

        // CART INFO
        var cartEmpty = cart.items == 0;
        //remove duplicates of upsells data
        const filteredUpsells = upsells.reduce((acc, current) => {
          const x = acc.find(item => item.handle === current.handle);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);

        if (discountSession.getItem('currentDiscount')) {
          discountCode = discountSession.getItem('currentDiscount')
          discountSaved = true
        }

        if (cart_has_subscription_item && discountSaved) {
          // calculate savings
          if (discountSession.getItem('discountRecharge')) {
            var recharge_discount = JSON.parse(discountSession.getItem('discountRecharge'))
            if (recharge_discount.data && recharge_discount.data.discount) {
              if (recharge_discount && recharge_discount.data && recharge_discount.data.discount && recharge_discount.data.discount.discount_type == 'percentage') {
                var perc = recharge_discount.data.discount.value
                var amount = Math.floor((total_price * perc) / 100)
              } else {
                var fixed = recharge_discount.data.discount.value
                var amount = fixed;
              }
            } else {
              amount = 0;
            }
            saving = saving + amount
            total_price = total_price - amount
          } else {
            smCart.removePromoCode()
          }
        }

        if (!cart_has_subscription_item && (discountSetting.apply_for == 'entire_order' || (discountSetting.type == 'fixed_amount' && discountSetting.apply_for == 'specific_products'))) {
          if (discountSetting.type == 'percentage') {
            var perc = Math.floor(parseInt(discountSetting.discount) * -1)
            var amount = Math.floor((total_price * perc) / 100)
          } else {
            var fixed = Math.floor(parseInt(discountSetting.discount) * -1) * 100
            var amount = fixed;
          }
          saving = saving + amount
          total_price = total_price - amount
        }

        if (discountedCount == 0 && discountSetting.apply_for != 'entire_order' && discountSetting.type != 'bogo') {
          discountSession.removeItem('currentDiscount')
          discountSession.removeItem('discountData')
        }

				let useDiscountCap = false;
				let appliedDiscountCap = false;
				if (discountSetting && discountSetting.cap) {
					appliedDiscountCap = true;
					if (saving > discountSetting.cap) {
						saving = discountSetting.cap;
						useDiscountCap = true;
					}
				}

        if (window.themeSettings.tier_auto_applied) {

          const tierOff = smCart.checkDiscountTier(cart.original_total_price);
          let autoAppliedOff = 0;
          if (tierOff.valueType == 'amount') {
            autoAppliedOff = tierOff.offValue * 100;
          } else {
            autoAppliedOff = Math.floor((total_price * tierOff.offValue) / 100);
          }
          if (!discountSaved) {
            saving = saving + autoAppliedOff;
          }

        }

        var discount = cart.original_total_price - total_price;
        var { shipping } = window.getShippingPrice(total_price);
        var finalTotal = shipping != null ? total_price + shipping : total_price;
        var afterpayCartEnable = window.themeSettings.cart_afterpay;
        var afterpayFooter = window.themeSettings.cart_footer_afterpay;

        // APPEND TO CART

				const checkoutPrice = useDiscountCap ? totalPrice : finalTotal;
				const savingLabelCap = saving > cart.original_total_price && appliedDiscountCap ? cart.original_total_price : saving;
        // const finalSubtotal = cart.original_total_price + bogoSavingPrice;
        const finalSubtotal = cart.original_total_price + compareDiffNormal + compareDiffFree;
        const discountTotal = finalSubtotal - checkoutPrice - compareDiffNormal - (shipping || 0);
        const tieredQtySaving = origSubTotal - checkoutPrice;
        // if (finalSubtotal > checkoutPrice) {
        //   bogoSavingPrice = finalSubtotal - checkoutPrice - saving
        // }
        data = {
          items: items,
          upsells: filteredUpsells,
          staticUpsells: staticUpsells,
          upsellEnable: (upsells.length > 0 || staticUpsells.length > 0) ? smUpsell.enabled : false,
          cartEmpty: cartEmpty,
          cart_has_subscription_item: cart_has_subscription_item,
          has_regular: has_regular,
          subtotal_price_orig: finalSubtotal,
          subtotal_price: Shopify.formatMoney(finalSubtotal, settings.moneyFormat),
          total_price_orig: checkoutPrice,
          total_price: Shopify.formatMoney(checkoutPrice, settings.moneyFormat),
          // saving_orig: savingLabelCap,
          // saving: savingLabelCap > 0 ? Shopify.formatMoney(savingLabelCap, settings.moneyFormat) : false,
          saving_orig: compareDiffNormal,
          saving: compareDiffNormal > 0 ? Shopify.formatMoney(compareDiffNormal, settings.moneyFormat) : false,
          shipping_orig: shipping != null ? shipping : 0,
          shipping: shipping != null ? Shopify.formatMoney(shipping, settings.moneyFormat) : false,
          free_shipping: shipping === 0,
          counter_min: counter_min,
          promoCodeEnable: true,
          cartDiscountParam: cartDiscountParam,
          // bogoSaving: window.themeSettings.bogo_saving,
          // bogoSavingPrice: bogoSavingPrice,
          // bogoSavingPrice_c: bogoSavingPrice > 0 ? Shopify.formatMoney(bogoSavingPrice, settings.moneyFormat) : false,
          bogoSaving: true,
          bogoSavingPrice: discountTotal,
          bogoSavingPrice_c: discountTotal > 0 ? Shopify.formatMoney(discountTotal, settings.moneyFormat) : false,
          ...smCart.discountBar({ ...cart, total_price }),
          ...smCart.shippingBar({ ...cart, total_price }),
          cartAfterpay: afterpayCartEnable,
          showManualGWP: manual_gwp,
          discTieredQtySaving: tieredQtySaving > 0,
          discTieredQtySavingPrice: tieredQtySaving,
          discTieredQtySavingPrice_c: tieredQtySaving > 0 ? Shopify.formatMoney(tieredQtySaving, settings.moneyFormat) : false,
        }

        if (manual_gwp && manual_gwp_opt.min_spend < data.total_price_orig) {
          data.showManualGWP = true;
          data.manualGWPItems = [];
          data.manualMaxItem = parseInt(manual_gwp_opt.max_item);
          data.manualTitle = manual_gwp_opt.title;

          let reachedOut = false;

          smCart.defaultManualGWP(cart);

          if (smCart.getFreeTemporaryData().length <= 0 && smCart.getDefaultManualGWPVariantID(cart) != false) {
            discountSession.setItem('freeTemporary', JSON.stringify([smCart.getDefaultManualGWPVariantID(cart)]));
          }

          if (data.manualMaxItem <= smCart.getFreeTemporaryData().length) {
            reachedOut = true;
          }

          data.manualTotalSelected = smCart.getFreeTemporaryData().length;

          $.each(manual_gwp_items, function(i,v){
            if (data.subtotal_price_orig > v.min_amount && v.product.available) {
              data.manualGWPItems.push({
                added: smCart.getFreeTemporaryData().indexOf(v.product.variant_id) >= 0,
                available: v.product.available,
                stock_available: v.product.available,
                image: v.image != "" ? v.image : v.product.image,
                title: v.title != "" ? v.title : v.product.title,
                price: v.product.price,
                compare_at_price: v.product.compare_at_price,
                variant_id: v.product.variant_id
              });
            }
          });

          //clear manual gwp items from cart on built
          smCart.clearManualGWP(cart);
          data.manualGwpTotalItems = (data.manualGWPItems.length > 0) ? true : false;

        } else {
          discountSession.setItem("freeTemporary","[]");
        }

        $cart_container.append(template(data))

        counter_min = (cartHasManualGWP) ? (counter_min - 1) : counter_min;
        smCart.cart_counter(cart, counter_min);
        smCart.currencyConverting()

        smCart.buildInfo(cart)
        smCart.buildCheckout(data)
        smCart.urgency(cart)
        smCart.checkCodeForm()

        // YOTPO
        // if (typeof(yotpo) == 'object') {
        //   setTimeout(function(){
        //     var y = new Yotpo.API(yotpo)
        //     y.refreshWidgets();
        //   },500)
        // }


        // LOADING FALSE
        smCart.loading(false)
        setTimeout(function() {
          if (cart.item_count > 0) {
            document.dispatchEvent(new CustomEvent('drawerUpdated'));
          }

          // get stars for yotpo without refresh widget
          var subscriptions = [];
          $.get('/pages/checkout-line-item', function(response){
            $.each(JSON.parse(response), function(i,item){
              $(".cart-detail .yotpo.bottomLine[data-product-id='"+item.product_id+"']").html(item.yotpoBottomLine);
            });
          });

          if (afterpayCartEnable || afterpayFooter) {
            if (typeof(Afterpay) == 'object') {
              var store = window.location.hostname.split('.')[0]
              var cur = newAfterpay.currency.USD
              var locale = newAfterpay.locale.EN_US
              if (store == 'au') {
                cur = newAfterpay.currency.AUD
                locale = newAfterpay.locale.EN_AU
              } else if (store == 'ca') {
                cur = newAfterpay.currency.CAD
                locale = newAfterpay.locale.EN_CA
              }


              var afterpay_finalPrice = finalTotal / 100
              if (afterpay_finalPrice > 35) {
                newAfterpay.createPlacements({
                  targetSelector: '.afterpay-green-wrapper__cart',
                  attributes: {
                    locale: locale,
                    currency: cur,
                    amount: finalTotal / 100,
                    size: newAfterpay.size.SM,
                  }
                });
                var box = $(".cart-window-body afterpay-placement")[0].shadowRoot;

                if (box) {
                  var afterpayInstallment = $(box).find('.payment-amount').text()
                  var afterpaytext1 = $(box).find('.afterpay-main-text').text().replace('or', '').replace(' of', ' ').replace('by', '').replace(afterpayInstallment, '')
                  var afterpaylink = $(box).find('.afterpay-link')
                  var newText = afterpayInstallment + ' / ' + afterpaytext1;

                  $('.cart-ap-text').html(newText).append(afterpaylink)
                  $('.cart-ap-text').find('.afterpay-link').text('more info')
                  $('.cart-ap-text').find('.afterpay-link').removeAttr('style')
                  $(".afterpay-green-wrapper.afterpay-green-wrapper__cart").removeClass('hide');
                  $('.cart-window-body afterpay-placement').remove();

                  if ($('.afterpay-cart-footer').length > 0) {
										var aptext2 = $(box).find('.afterpay-text2').text();
										if (aptext2.includes('between')) {
											var newText = aptext2;
										} else {
                      const moneyRegex = /[+-]?\d+(\.\d+)?/g;
                      let APamount = afterpaytext1.match(moneyRegex).map(function(v) { return parseFloat(v); });
                      if (APamount.length > 0) {
                        let strAmount = 'of $'+ APamount[1];
                        var newText = afterpaytext1.replace('$'+APamount[1], strAmount);
                      } else {
                        var newText = 'or ' + afterpaytext1 + ' of ' + afterpayInstallment + ' with';
                      }
										}

                    $('.cart-window-body .ap-logo').find('.afterpay-link').remove();
                    $('.cart-window-body afterpay-placement').remove();
                    $('.cart-window-body .ap-logo').append(afterpaylink);
                    $('.cart-window-body .ap-logo').find('.afterpay-link').removeAttr('style').html('<svg xmlns="http://www.w3.org/2000/svg" width="109" height="17" viewBox="0 0 109 17"><g transform="translate(-143 -1934)"><g transform="translate(143 1934)"><g transform="translate(0 0)"><path d="M1278.751,312.364l-2.711-1.524-2.749-1.547a2.731,2.731,0,0,0-4.089,2.325v.346a.52.52,0,0,0,.274.462l1.277.716a.529.529,0,0,0,.791-.454v-.824a.54.54,0,0,1,.807-.462l2.507,1.416,2.5,1.409a.524.524,0,0,1,0,.916l-2.5,1.409-2.507,1.416a.54.54,0,0,1-.807-.462V317.1a2.728,2.728,0,0,0-4.089-2.325l-2.75,1.547-2.711,1.524a2.665,2.665,0,0,0,0,4.657l2.711,1.524,2.75,1.547a2.731,2.731,0,0,0,4.089-2.325V322.9a.52.52,0,0,0-.274-.462l-1.277-.716a.529.529,0,0,0-.792.454V323a.54.54,0,0,1-.807.462l-2.506-1.416-2.5-1.409a.523.523,0,0,1,0-.916l2.5-1.409,2.506-1.417a.54.54,0,0,1,.807.462v.408a2.728,2.728,0,0,0,4.089,2.325l2.749-1.547,2.711-1.524A2.665,2.665,0,0,0,1278.751,312.364Z" transform="translate(-1190.12 -308.933)"/><g transform="translate(60.508 3.939)"><path d="M1143.34,360.1,1137,372.979h-2.632l2.374-4.811L1133,360.1h2.7l2.4,5.4,2.616-5.4Z" transform="translate(-1133 -360.1)"/></g><g transform="translate(0 0.198)"><path d="M368,362.734a2.532,2.532,0,1,0-2.53,2.617,2.519,2.519,0,0,0,2.53-2.617m.023,4.573v-1.186a3.753,3.753,0,0,1-2.938,1.332,4.5,4.5,0,0,1-4.489-4.719A4.584,4.584,0,0,1,365.143,358a3.748,3.748,0,0,1,2.883,1.316v-1.155h2.287v9.145Z" transform="translate(-360.6 -354.42)"/><path d="M508.535,322.354c-.8,0-1.026-.293-1.026-1.062v-4.057h1.473v-1.994h-1.473v-2.232h-2.342v2.232h-3.024v-.908c0-.77.3-1.062,1.12-1.062h.517V311.5h-1.128c-1.935,0-2.852.624-2.852,2.525v1.224h-1.3v1.986h1.3v7.151h2.342v-7.151h3.024v4.48c0,1.863.729,2.671,2.624,2.671H509v-2.032Z" transform="translate(-487.697 -311.5)"/><path d="M650.313,361.818a2.219,2.219,0,0,0-2.311-1.9,2.285,2.285,0,0,0-2.342,1.9Zm-4.677,1.424a2.3,2.3,0,0,0,2.4,2.125,2.468,2.468,0,0,0,2.194-1.185h2.4a4.873,4.873,0,0,1-9.44-1.524,4.814,4.814,0,0,1,9.628,0,2.857,2.857,0,0,1-.055.585Z" transform="translate(-621.062 -354.328)"/><path d="M869.771,362.642a2.532,2.532,0,1,0-2.53,2.617,2.556,2.556,0,0,0,2.53-2.617m-7.372,8.306V358.069h2.287v1.186a3.724,3.724,0,0,1,2.938-1.355,4.536,4.536,0,0,1,4.489,4.719,4.584,4.584,0,0,1-4.543,4.734,3.628,3.628,0,0,1-2.812-1.224v4.811H862.4Z" transform="translate(-823.09 -354.328)"/><path d="M1004.6,362.734a2.532,2.532,0,1,0-2.53,2.617,2.519,2.519,0,0,0,2.53-2.617m.024,4.573v-1.186a3.753,3.753,0,0,1-2.938,1.332,4.5,4.5,0,0,1-4.489-4.719,4.584,4.584,0,0,1,4.543-4.734,3.748,3.748,0,0,1,2.883,1.316v-1.155h2.287v9.145Z" transform="translate(-947.331 -354.42)"/><path d="M782.7,358.962a2.462,2.462,0,0,1,3.016-.854v2.332a2.977,2.977,0,0,0-1.653-.416,1.615,1.615,0,0,0-1.293,1.771v5.412H780.4v-9.138h2.287v.893Z" transform="translate(-747.514 -354.328)"/></g></g></g><g transform="translate(0 -2)"><g data-cy="cart-afterpay-icon" class="a" transform="translate(238 1938)"><circle class="c" cx="7" cy="7" r="7"/><circle class="d" cx="7" cy="7" r="6.23"/></g><g class="b" transform="translate(244 1944)"><rect class="c" width="2" height="5" rx="1"/><rect class="d" x="0.5" y="0.5" width="1" height="4" rx="0.5"/></g><g class="b" transform="translate(244 1941)"><rect class="c" width="2" height="2" rx="1"/><rect class="d" x="0.5" y="0.5" width="1" height="1" rx="0.5"/></g></g></g></svg>');
                    $('.cart-window-body .cart-ap-text').text(newText);
                    if ($('.afterpay-badge').length > 0) {
                      $('.footer-ap-link').find('.afterpay-link').remove();
                      $('.footer-ap-text').html('or '+ afterpaytext1 + ' of '+ afterpayInstallment);
                      $('.footer-ap-link').append(afterpaylink);
                      $('.footer-ap-link').find('.afterpay-link').html('<svg xmlns="http://www.w3.org/2000/svg" width="109" height="17" viewBox="0 0 109 17"><defs><style></style></defs><g transform="translate(-143 -1934)"><g transform="translate(143 1934)"><g transform="translate(0 0)"><path d="M1278.751,312.364l-2.711-1.524-2.749-1.547a2.731,2.731,0,0,0-4.089,2.325v.346a.52.52,0,0,0,.274.462l1.277.716a.529.529,0,0,0,.791-.454v-.824a.54.54,0,0,1,.807-.462l2.507,1.416,2.5,1.409a.524.524,0,0,1,0,.916l-2.5,1.409-2.507,1.416a.54.54,0,0,1-.807-.462V317.1a2.728,2.728,0,0,0-4.089-2.325l-2.75,1.547-2.711,1.524a2.665,2.665,0,0,0,0,4.657l2.711,1.524,2.75,1.547a2.731,2.731,0,0,0,4.089-2.325V322.9a.52.52,0,0,0-.274-.462l-1.277-.716a.529.529,0,0,0-.792.454V323a.54.54,0,0,1-.807.462l-2.506-1.416-2.5-1.409a.523.523,0,0,1,0-.916l2.5-1.409,2.506-1.417a.54.54,0,0,1,.807.462v.408a2.728,2.728,0,0,0,4.089,2.325l2.749-1.547,2.711-1.524A2.665,2.665,0,0,0,1278.751,312.364Z" transform="translate(-1190.12 -308.933)"/><g transform="translate(60.508 3.939)"><path d="M1143.34,360.1,1137,372.979h-2.632l2.374-4.811L1133,360.1h2.7l2.4,5.4,2.616-5.4Z" transform="translate(-1133 -360.1)"/></g><g transform="translate(0 0.198)"><path d="M368,362.734a2.532,2.532,0,1,0-2.53,2.617,2.519,2.519,0,0,0,2.53-2.617m.023,4.573v-1.186a3.753,3.753,0,0,1-2.938,1.332,4.5,4.5,0,0,1-4.489-4.719A4.584,4.584,0,0,1,365.143,358a3.748,3.748,0,0,1,2.883,1.316v-1.155h2.287v9.145Z" transform="translate(-360.6 -354.42)"/><path d="M508.535,322.354c-.8,0-1.026-.293-1.026-1.062v-4.057h1.473v-1.994h-1.473v-2.232h-2.342v2.232h-3.024v-.908c0-.77.3-1.062,1.12-1.062h.517V311.5h-1.128c-1.935,0-2.852.624-2.852,2.525v1.224h-1.3v1.986h1.3v7.151h2.342v-7.151h3.024v4.48c0,1.863.729,2.671,2.624,2.671H509v-2.032Z" transform="translate(-487.697 -311.5)"/><path d="M650.313,361.818a2.219,2.219,0,0,0-2.311-1.9,2.285,2.285,0,0,0-2.342,1.9Zm-4.677,1.424a2.3,2.3,0,0,0,2.4,2.125,2.468,2.468,0,0,0,2.194-1.185h2.4a4.873,4.873,0,0,1-9.44-1.524,4.814,4.814,0,0,1,9.628,0,2.857,2.857,0,0,1-.055.585Z" transform="translate(-621.062 -354.328)"/><path d="M869.771,362.642a2.532,2.532,0,1,0-2.53,2.617,2.556,2.556,0,0,0,2.53-2.617m-7.372,8.306V358.069h2.287v1.186a3.724,3.724,0,0,1,2.938-1.355,4.536,4.536,0,0,1,4.489,4.719,4.584,4.584,0,0,1-4.543,4.734,3.628,3.628,0,0,1-2.812-1.224v4.811H862.4Z" transform="translate(-823.09 -354.328)"/><path d="M1004.6,362.734a2.532,2.532,0,1,0-2.53,2.617,2.519,2.519,0,0,0,2.53-2.617m.024,4.573v-1.186a3.753,3.753,0,0,1-2.938,1.332,4.5,4.5,0,0,1-4.489-4.719,4.584,4.584,0,0,1,4.543-4.734,3.748,3.748,0,0,1,2.883,1.316v-1.155h2.287v9.145Z" transform="translate(-947.331 -354.42)"/><path d="M782.7,358.962a2.462,2.462,0,0,1,3.016-.854v2.332a2.977,2.977,0,0,0-1.653-.416,1.615,1.615,0,0,0-1.293,1.771v5.412H780.4v-9.138h2.287v.893Z" transform="translate(-747.514 -354.328)"/></g></g></g><g transform="translate(0 -2)"><g data-cy="cart-afterpay-icon" class="a" transform="translate(238 1938)"><circle class="c" cx="7" cy="7" r="7"/><circle class="d" cx="7" cy="7" r="6.23"/></g><g class="b" transform="translate(244 1944)"><rect class="c" width="2" height="5" rx="1"/><rect class="d" x="0.5" y="0.5" width="1" height="4" rx="0.5"/></g><g class="b" transform="translate(244 1941)"><rect class="c" width="2" height="2" rx="1"/><rect class="d" x="0.5" y="0.5" width="1" height="1" rx="0.5"/></g></g></g></svg>');
                    }
                  }
                } else {
                  $('.cart-window-body afterpay-placement').remove()
                }
              }
            }
          }

          let centerPadding = '6%';

          if (window.innerWidth < 768) {
            centerPadding = '13%';
          }

          $('.cart-upsell-carousel--content').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            easing: "linear",
            arrow: false,
            prevArrow: null,
            nextArrow: null,
            dots: true,
            centerMode: true,
            centerPadding: centerPadding,
          });

        }, 500)
      });

      _this.setCartAttributesToken();
    });
  },
  setCartAttributesToken(){
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: { token: getCookie('cart') } }),
    });
  },
  buildInfo: function(cart) {
    var $cart_info = $('.cart-window .cart-info-footer'),
        souceInfo = $('#cartRowInfo').html(),
        template = Handlebars.compile(souceInfo),
        cartEmpty = false
    if (cart.item_count == 0) {
      cartEmpty = true
    }
    var data = {
      cartEmpty: cartEmpty,
      guarantee: true,
      real_customemrs: true,
      buildInfo: true,
    }

    $cart_info.empty()
    $cart_info.append(template(data))
  },
  buildCheckout: function(data) {
    var $cart_checkout = $('.cart-checkout-wrapper'),
        souceInfo = $('#cartCheckout').html(),
        template = Handlebars.compile(souceInfo);

    $cart_checkout.empty()
    $cart_checkout.append(template(data))
  },
  loading(state) {
    if (state) {
      $('.smCart-loading-overlay').addClass('active')
    } else {
      $('.smCart-loading-overlay').removeClass('active')
    }
  },
  cart_counter(cart, counter_min) {

    var counter = counter_min
    if (counter == 0) {
      counter = 0
    }
    $('.mycart-counter').html('<span class="cart-num">'+counter+'</span>');
    $('.cart-heading .total_count_ajax, .mobile-nav-bar .total_count_ajax').html(counter)
  },
  currencyConverting: function() {
    $(".money[data-price]").each(function(i,el){
      var pr = $(this).data("price");
      var cv = ((pr)/100).toFixed(2);
      var formattedP = theme.settings.moneyFormat.replace("\{\{amount\}\}",cv);
      $(el).text(formattedP);
    })
  },
  urgency: function(cart) {

  },
  beforeCheckout: function(){
    console.log('ddd')
    smCart.checkCampaign(true);
  },
  dataProducts: function() {
    window.getAllProducts((products) => {
      $.each(products, function(i,v){
        if (v.tags.indexOf('bogo') != -1) {
          discountProducts.push(v);
        } else {
          regularProducts.push(v);
        }
      });
      $.each(regularProducts, function(i, v){
        var obj = {regular: v};
        $.each(discountProducts, function(x,y) {
          if (y.handle.replace(v.handle, '').length < 4){
            obj.discount = y;
          };
        });
        mixProducts.push(obj);
      });
    });
  },
  discountInputField: function(obj) {
    if ($('.input-discount').val() == '') {
      return;
    }
    let listBlockedProductsStatus = 'false' == 'true';
    let listBlockedProducts = '';
    let whitelistCodes = 'mystery,hello,sorry10,vipbogo,gogetit5,getnow10,get15off,epkv684,cx7pg785,smpy10,get25,get35';
    let reject_msg = "You’re currently enjoying the best deal so save your codes for after the sale";
    let reject_code = "true";
    // console.log('list of blocked cart =>', listBlockedProducts);
    // console.log('whitelist codes =>', whitelistCodes);
    $('#promo-code-cta').text('Applying..');
    let discountProcessing = false;
    let allowProcess = true;
    let cartErrorMsg = 'This coupon code is not eligible for this order';
    var gCart = smCart.getCart();
      $('.p-discount-notif').remove();
    var pcode = $('.input-discount').val().toLowerCase();
    // start to check blocked products
    jQuery.getJSON('/cart.js', function(cart) {
      // now have access to Shopify cart object
      // console.log('cart content ===>', cart);
      // cart.items
      // console.log('cart list block status =>', listBlockedProductsStatus);
      if(listBlockedProductsStatus) {
        // console.log('status =>', listBlockedProductsStatus)
        if(whitelistCodes.includes(pcode)) {
          // console.log('can be discounted');
          allowProcess = true;
        } else {
          // console.log('can not be discounted');
          // cartErrorMsg = 'Oops, this code cannot be applied to your order';
          // smCart.showCodeError(cartErrorMsg);
          allowProcess = true;
          $('#promo-code-cta').text('Apply');
          cart.items.forEach(item => {
            if(listBlockedProducts.includes(item.variant_id)) {
              pcode = '';
              discountProcessing = true;
              allowProcess = false;
              cartErrorMsg = 'Oops, this code cannot be applied to your order';
              smCart.showCodeError(cartErrorMsg);
              return;
            }
          });
        }
      } else {
        allowProcess = true;
      }
      if (pcode != '' && allowProcess) {
        // console.log('processig discount')
        if (discountProcessing) {
          return;
        }


        smCart.checkCode(pcode, function(resp) {
          // console.log('response ==>', resp);
          var respCode = resp;

          if (respCode.discount_portal == 'recharge') {
            if (reject_code == 'true' && !whitelistCodes.includes(pcode)) {
              cartErrorMsg = reject_msg
              $('#promo-code-cta').text('Apply')
              smCart.showCodeError(cartErrorMsg)
            } else {
              var codeName = pcode
              discountSession.setItem('currentDiscount', codeName)
              discountSession.setItem('discountRecharge', JSON.stringify(respCode))

              gCart.done(function(cart) {
              smCart.promoFormToggle(false)
              smCart.checkCampaign()
              $('#promo-code-cta').text('Apply')
              })
            }
          } else {
            if (resp.data.can_apply) {
              // console.log('1')
              if (!resp.is_bogo) {
                // console.log('2')
                var codeName = resp.data.discount.code
                var products = resp.data.price_rule.entitled_variant_ids
                var applyToAll = resp.data.apply_for

                gCart.done(function(cart) {
                var cartItems = cart.items;

                if (applyToAll != 'specific_products') {
                  if (reject_code == 'true' && !whitelistCodes.includes(pcode)) {
                    cartErrorMsg = reject_msg
                    $('#promo-code-cta').text('Apply')
                    smCart.showCodeError(cartErrorMsg)
                  } else {
                    discountSession.setItem('currentDiscount', codeName);
                    discountSession.setItem('discountData', JSON.stringify(respCode));
                    smCart.promoFormToggle(false)
                    smCart.checkCampaign()
                  }

                  $('#promo-code-cta').text('Apply')
                } else {
                  var productSplitted = products;
                  buySelectors = []
                  cartItems.forEach(function(item, index) {
                    if (productSplitted.indexOf(item.id != -1)) {
                      buySelectors.push(item.id)
                    }
                  });

                  if (buySelectors.length > 0) {
                    if (reject_code == 'true' && !whitelistCodes.includes(pcode)) {
                      cartErrorMsg = reject_msg
                      $('#promo-code-cta').text('Apply')
                      smCart.showCodeError(cartErrorMsg)
                    } else {
                      discountSession.setItem('currentDiscount', codeName);
                      discountSession.setItem('discountData', JSON.stringify(respCode));
                      smCart.promoFormToggle(false)
                      smCart.checkCampaign()
                      $('#promo-code-cta').text('Apply')
                    }
                  } else {
                    // error no valid item
                    $('#promo-code-cta').text('Apply')
                    cartErrorMsg = resp.data.error
                    smCart.showCodeError(cartErrorMsg)
                  }
                }
                })
              }
            } else {
              // console.log('3')
              if (!resp.data.variant_id) {
                $('#promo-code-cta').text('Apply')
                cartErrorMsg = resp.data.error
                smCart.showCodeError(cartErrorMsg)
              } else {
                if (reject_code == 'true' && !whitelistCodes.includes(pcode)) {
                  cartErrorMsg = reject_msg
                  $('#promo-code-cta').text('Apply')
                  smCart.showCodeError(cartErrorMsg)
                } else {
                  var data = {
                    id: resp.data.variant_id,
                    quantity: 1,
                    properties: {
                      _discount_code: pcode
                    }
                  }
                  smCart._addCart(data, false, function() {

                  }, function(resp) {
                    // console.log('discount add.');
                    // force to clear product ids because max of length size for cookie, later we should use localStorage instead of cookie
                    respCode.data.price_rule.prerequisite_product_ids = [];
                    discountSession.setItem('currentDiscount', pcode.toUpperCase());
                    discountSession.setItem('discountData', JSON.stringify(respCode));
                    smCart.promoFormToggle(false)
                    smCart.checkCampaign()
                    $('#promo-code-cta').text('Apply')
                  }, function() {

                  }, function() {
                    cartErrorMsg = resp.data.error
                    smCart.showCodeError(cartErrorMsg)
                    console.log('discount add error')
                    $('#promo-code-cta').text('Apply')
                  })
                }
              }
            }
          }


        }, function(resp) {
          $('#promo-code-cta').text('Apply')
          // console.log(resp)
          smCart.showCodeError(cartErrorMsg)
        })
      }
    });
  },
  checkCode: function(code, success, error) {
    var token = discountSession.getItem('cart')
    var store = location.hostname.split('.')[0]
    if (store == 'us') {
      store = 'www'
    }
    if (store == 'skinny-mint') {
      store = 'dev'
    }
    var brand = 'skinnymint_shopify_'+store;
    const signature = encryptParam(`{code:'${code}',time:${new Date().getTime()}}`);

    $.ajax({
      url: `${window.apiEndpoint}/shopify/discount_codes/${code}?brand=${brand}&cart=${token}&signature=${signature}`,
      cache: false,
      beforeSend: function(resp) {
        // console.log('before')
      },
      success: function(resp) {
        // console.log(resp);
        success(resp)
      },
      complete: function complete() {
        // console.log('complete')
      },
      error: function(resp) {
        error(resp)
      }
    });
  },
  isCartValid: function(items) {
    isHero = items.filter(function(item, index) {
      return item.product_type == 'HERO' || item.product_type == 'BUNDLE'
    })

    return isHero.length > 0
  },
  checkCodeForm: function(code) {
    if (discountSession.getItem('currentDiscount')) {
      smCart.promoFormToggle(false);
      if (!$('.promo-apply-toggle').hasClass('active')) {
        $('#input_accordion > li > div').click()
      }
    } else {
      smCart.promoFormToggle(true);
    }
  },
  promoFormToggle: function(open) {
    if(open) {
      $('.promo-discount .code_').hide()
      $('.promo-discount .form_').show()
    } else {
      $('.promo-discount .code_ .applied_code').text('Promo code applied: '+discountSession.getItem('currentDiscount'))
      $('.promo-discount .code_').show()
      $('.promo-discount .form_').hide()
    }
  },
  recalculateDiscountTier: function(totalPrice){
    // console.log('reca')
    var pcode = discountSession.getItem('currentDiscount');
    if (pcode.toLowerCase() == 'vipbf') {
      if (discountSession.getItem('discountData')){
        objectDiscount = JSON.parse(discountSession.getItem('discountData'));
        offValue = smCart.checkDiscountTier(totalPrice, pcode);
        if (percentageOff > 0){
          objectDiscount.data.price_rule.value = "-"+offValue.offValue+".0";
        } else {
          objectDiscount.data.price_rule.value = "0.0";
          smCart.removePromoCode();
        }
        discountSession.setItem('discountData', JSON.stringify(objectDiscount));
      }
    }
  },
  checkDiscountTier: function(total_price, codeName = '') {
    var bfDiscTier = $.parseJSON(window.themeSettings.tier_discount);
    var store = window.location.hostname.split('.')[0]
    if (store == 'www') {
      store = 'us';
    }
    var offValue = 0;
    var valueType = 'percentage';
    if ((codeName.toLowerCase() == 'vipbf' && bfDiscTier.data.length > 0) || window.themeSettings.tier_auto_applied)  {
      for (var i=0;i<=bfDiscTier.data.length-1;i++) {
        if (bfDiscTier.data[i].store == store) {
          valueType = bfDiscTier.data[i].value_type;
          var tier = bfDiscTier.data[i].tier;
          for (var j=0;j<=tier.length-1;j++) {
            var treshold = tier[j].treshold * 100;
            if (total_price >= treshold) {
              offValue = tier[j].val;
              break;
            }
          }
        }
      }

    }
    return { offValue, valueType };
  },
  removePromoCode: function() {
    let prevDisc = discountSession.getItem('currentDiscount');
    discountSession.removeItem('currentDiscount')
    discountSession.removeItem('discountData')
    discountSession.removeItem('discountRecharge')
    smCart.promoFormToggle(true)
    smCart.checkCampaign()
    smCart.checkExitIntentCode('hide', prevDisc);

  },
  checkExitIntentCode: function(mode, discountCode){
    let exitIntentCode;
    if (window.themeSettings.exit_intent && window.themeSettings.notice_bar) {
      exitIntentCode = $('#exit_intent_pcode').val();
      if (discountCode.toLowerCase() == exitIntentCode.toLowerCase()) {

        if (mode == 'hide') {
          clearInterval(timer);
          $('.countdown-bar').addClass('hide-default');
          $('.cart-countdown').addClass('hide-default');
          $('div.mega-menu-type-2').css('top', 48);
          $('#header--main-content.fixed').css('top', 0);

        } else {
          $('.countdown-bar').removeClass('hide-default');
          $('.cart-countdown').removeClass('hide-default');
          $('div.mega-menu-type-2').css('top', 95);
          window.startCount(getCookie('_counter_expired_at'), new Date().getTime(),parseInt(window.themeSettings.exit_intent_timer));

        }
      } else {
        if (typeof timer !== 'undefined') {
          clearInterval(timer);
        }
      }
    }
  },
  showCodeError: function(msg) {
    $('.discount-p').remove();
    // console.log(msg)
    if (msg.includes('This coupon code is eligible for orders over')) {
      msg = msg.replace('This coupon code is eligible for orders over', 'This code is valid for orders over')
    }
    $(`<p style="font-size: 12px; color:red;" class="discount-p" data-cy="cart-discount-error">${msg}</p>`).insertAfter($('.form_'));
  },
  inputDiscountEnterKey: function inputDiscountEnterKey(a) {
    a.keyCode == 13 && $('.btn-apply').click();
  }
}

$(document).ready(function(){
  smCart.init();

})

var smInstagram  = (function(){
  let isInit = false;
  function smInstagram(container) {
    const $container = this.$container = $(container)
    const sectionId = $container.attr('data-section-id')
    this.namespace = `.instagram-${sectionId}`
    this.$target = $(`#Instafeed-${sectionId}`)
  }

  smInstagram.prototype = $.extend({}, smInstagram.prototype, {
    init() {
      isInit = true;
      this.media();
    },
    checkVisibility() {
      if (isInit) {
        $(window).off(`scroll${this.namespace}`);
        return;
      }
      if (theme.isElementVisible(this.$container)) {
        this.init();
      }
    },
    templating(arrMedia) {
      arrMedia.forEach(function (item, index) {
        const instaindex = index + 2;
        const instaclassname = `.wc_instagram_img_${instaindex}`;
        let instaHTML = '';
        instaHTML += `<a href="${item.link}" target="_blank">`;
        instaHTML += `<img data-src="${item.image}" class="lazyload" />`;
        instaHTML += '</a>';
        $(instaclassname).append(instaHTML);
      });
    },
    media() {
      if (this.getCookie('ig_files_')) {
        this.templating(JSON.parse(this.getCookie('ig_files_')));
      } else {
        // var data =
        // console.log('cookie not')
        const instafeed = this;
        $.ajax({
          url: "https://sminstagram.s3.amazonaws.com/instagram/skinnymint.json",
          type: 'GET',
          dataType: 'json',
          cors: true ,
          contentType:'application/json',
          secure: true,
          headers: {
            'Access-Control-Allow-Origin': '*',
          },
          success: function (data){
            const dataMedia = [];
            for (let i = 0; i < data.length; i++) {
              const d = data[i];
              const obj = { link: d.permalink, image: (i == 0 || i == 8) ? d.thumbnail_640_url : d.thumbnail_url };
              dataMedia.push(obj);
            }
            instafeed.setCookie('ig_files_', JSON.stringify(dataMedia));
            instafeed.templating(dataMedia);
          }
        })
      }
    },
    getCookie(name) {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = `; expires=${date.toUTCString()}`;
      }
      document.cookie = `${name}=${value || ''}${expires}; path=/`;
    }
  })
  return smInstagram
})();

$(document).ready(function(){
  smig = new smInstagram('.sm-instagram-section')
  smig.init()
})

document.addEventListener('StartLast2Loading', function (event) {
	try {
		roar.init();
		setCookie('referrer-href', window.location.href);
	} finally {
		const y = new theme.Sections();

		y.register('product-template', theme.Product),
		y.register('home-product-template', theme.Product),
		y.register('topblock-section', theme.TopBlockSection),
		y.register('custom-widget', theme.CustomWidgetSection),
		y.register('delivery-bar', theme.DeliveryBarSection),
		y.register('slideshow', theme.SlideShowSection),
		y.register('slideshow-with-html', theme.SlideShowSection),
		y.register('slideshow-with-megamenu', theme.SlideShowSection),
		y.register('sidebar', theme.SidebarSection),
		y.register('product-tab', theme.ProductTabSection),
		y.register('advanced-grid', theme.AdvancedGridSection),
		y.register('footer-copyright', theme.FooterCopyRightSection),
		y.register('mobile-nav-section', theme.mobileNavSection),
		y.register('product-variant-mobile', theme.ProductVariantMobile),
		y.register('brands', theme.Brands),
		y.register('collections-list', theme.CollectionsList),
		y.register('search-template', theme.Filters),
		y.register('product-customers-section', theme.productCustomers),
		y.register('collection-custom', theme.CollectionCustom);
		document.dispatchEvent(new CustomEvent('StartLast3Loading'));
	}
});


loadjs.ready('ThemeScript', function () {
	jQuery(window).resize(function () {
		roar.getWidthBrowser() < 768 && $('#popup-mailchimp.hidden-xs').find('.mfp-close').trigger('click');
	});

	const y = new theme.Sections();
	y.register('mega-menu', theme.MegaMenuSection);

	document.dispatchEvent(new CustomEvent('StartLast2Loading'));
	forceFullWidth();
	$(window).resize(function () {
		forceFullWidth();
	});

	$('.photoswipe.zoom').off('click').on('click', function (e) {
		e.preventDefault();
	});
	checkBBTone();
	$('[data-currency-list] li').click(function () {
		handleBoldCurrency();
	});
	handleBoldCurrency();
	convertCurrencySubscription();

	handleMoneyFormat();
});

function handleMoneyFormat() {
	if (window.use_mcp) {
		$('.money[data-price]').each(function (i, el) {
			pr = $(this).data('price');
			cv = ((pr) / 100).toFixed(2);
			formattedP = theme.settings.moneyFormat.replace('\{\{amount\}\}', cv);
			$(el).text(formattedP);
		});
	}
}

function convertCurrencySubscription() {
	if (window.use_mcp) {
		$('[data-subscription-price]').each(function (i, el) {
			if (theme.shop_currency != Shopify.currency.active || true) {
				pr = $(this).data('subscription-price');
				rate = Shopify.currency.rate;
				cv = ((pr * rate) / 100).toFixed(2);
				lstDecimal = cv.split('.');
				lstDecimal = lstDecimal[lstDecimal.length - 1];
				// turned off feature to make subscription price keep use decimal .90
				// if (pr > 0) {
				// 	if (parseInt(lstDecimal) > 90) {
				// 		cv = `${parseInt((parseInt(cv) + 1).toFixed(2))}.90`; // need to dynamic rule for 90 might another store has diff val
				// 	} else {
				// 		cv = `${parseInt((parseInt(cv)).toFixed(2))}.90`; // need to dynamic rule for 90 might another store has diff val
				// 	}
				// }
				m = '';
				if (!$(this).hasClass('no-mo') && $(this).data('subscription-price') && $(this).parent().find('.subscription-info').length <= 0) {
					m = '/mo';
				}
				formattedP = theme.settings.moneyFormat.replace('\{\{amount\}\}', cv);
				$(el).text(formattedP + m);
			}
		});
	}
}

function forceFullWidth() {
	const S = $('.custom-content-product, .triple-pack-counts');
	if (S.length > 0) {
		S.width($('body').width()), S.css('left', '0px');
		const T = S.offset();
		S.css('position', 'relative');
		S.css('left', `-${T.left}px`), S.find('.container').css('padding-left', T.left), S.find('.container').css('padding-right', T.left);
	}
}

function checkBBTone() {
	const sel = $('.free-tone-bb');
	if (sel.length > 0 && !sel.hasClass('checked')) {
		const cloned = sel.clone();
		cloned.removeClass('free-tone-bb');
		cloned.addClass('free-tone-bb-cloned');
		cloned.css({
			display: 'flex !important'
		});
		const html = cloned.wrap('<div />').parent().html();
		if ($('.slim-trim-cart-handle-subs').length > 0 && $('.free-tone-bb-cloned').length <= 0) {
			$('.slim-trim-cart-handle-subs').after(html);
		} else {
			$('.slim-trim-cart-handle').after(html);
		}
		sel.addClass('checked');
		sel.remove();
	}
}


function handleBoldCurrency() {
	if (window.use_mcp) {
		return;
	}
	if (Shopify.shop != 'skinny-mint-sg.myshopify.com') {
		return;
	}
	if (BOLDCURRENCY.currentCurrency == 'USD') {
		return;
	}

	subTotal = 0;
	subTotalOriginal = 0;
	totalSaving = 0;
	subTotalSavingOriginal = 0;
}

var smSearchNode = $('input[name=q]')
var smSearch = {
  init: function() {
    this.inputEventListener()
  },
  inputEventListener: function() {
    var input = smSearchNode
    smSearch.desktopScrollSandle()
    input.on("keyup", smSearch.debounce(function(evt) {
      smSearch.search(evt.target.value)
    }, 500));

    $('.search-icon-btn').on('click', function(){
      $('.mobile-search-wrapper').toggleClass('hide-container');
      if ($('#header--main-content').hasClass('fixed')) {
        $(".full-width-search-container").addClass('fixed');
      }
    });

    $('.form-search form').on('click', function(evt) {
      evt.preventDefault()
      smSearch.search(evt.currentTarget[0].value)
    })
    smSearch.keywordListener(input)
  },
  keywordListener: function(input) {
    $('.search-info span').on('click', function(evt) {
      input.val(evt.target.textContent)
      smSearch.search(evt.target.textContent)
    })
  },
  desktopScrollSandle() {
    $(window).scroll(function(){
      var scrollPos = $(document).scrollTop();
      var w = window.innerWidth;
      if (scrollPos > 122) {
        $(".full-width-search-container").addClass('fixed');
      } else {
        $(".full-width-search-container").removeClass('fixed');
      }
    })
  },
  search: function(keyword) {
    smSearch.loading(true)
    var $search_container = $('.header-search-container')
    var info = 'Top searches: <span>Teatox</span>, <span>Weight Loss</span>, <span>Gummies</span>'
    $search_container.empty()
    if (keyword == '') {
      $('.search-info').html(info)
      smSearch.keywordListener(smSearchNode)
      smSearch.loading(false)
      return
    }
    jQuery.getJSON("/search/suggest.json", {
      "q": keyword,
      "resources": {
        "type": "product",
        "options": {
          "unavailable_products": "last",
          "fields": "title,product_type,variants.title,tag"
        }
      }
    }).done(function(response) {
      var productSuggestions = response.resources.results.products;
      if (productSuggestions.length > 0) {
        var firstProductSuggestion = productSuggestions[0];
        smSearch.buildResult(productSuggestions)
      } else {
        $('.search-info').html(info)
        smSearch.keywordListener(smSearchNode)
        smSearch.loading(false)
      }
    });
  },
  buildResult: function(result) {
    window.getAllProducts((all_products) => {
      var $search_container = $('.header-search-container')
      $search_container.empty()

      var items = [],
        item = {},
        data = {},
        source = $('#searchRowTemplate').html(),
        template = Handlebars.compile(source),
        info = ''

      result = result.filter(function(i, index) {
        return i.type == 'HERO' || i.type == 'BUNDLE'
      })

      $.each(result, function(index, item) {
        var searchInfo = ''
        var inProduct = all_products.find(function(x, y) {
          return x.handle === item.handle
        })

        if (inProduct) {
          searchInfo = inProduct.searchInfo
        }
        item = {
          product_id: item.id,
          img: item.image,
          title: item.title,
          handle: item.handle,
          price: item.price,
          url: item.url,
          compare_at_price_max: item.compare_at_price_max,
          searchInfo: searchInfo
        }

        items.push(item)
      })

      if (result.length > 0) {
        info = result.length + ' Results'
      }

      data = {
        items: items
      }
      smSearch.loading(false)
      $('.search-info').html(info)
      $search_container.append(template(data))
    });
  },
  debounce: function(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  },
  loading(state) {
    if (state) {
      $('.lds-ring').addClass('active')
    } else {
      $('.lds-ring').removeClass('active')
    }
  }
}

$(document).ready(function(){
  smSearch.init();

})

var Filter = (function() {
  function Filter() {
    this.domain = window.location.hostname
    this.sort = 'best-selling'
    this.collection = 'all-items'
    this.collections = []
    this.heading = $('.collection-unfiltered .collection-filtered__heading h2').text()
    this.description = $('.collection-unfiltered .collection-filtered__heading p').text()
  }

  Filter.prototype.init = function() {
    $('input[name="filterCollectionDesktop"], input[name="filterCollection"]').on('click', function() {
      $('.collection-filter__submit').removeClass('disabled')
      $('.collection-filter__clear').removeClass('disabled')
    })

    var fixedDiv = document.getElementById('stickyCollectionFilter'),
    scrollableDiv = document.getElementById('collectionFilterScrollable');
    if (fixedDiv) {

      fixedDiv.addEventListener('mousewheel', function (e) {
        var temp = scrollableDiv.scrollTop
        scrollableDiv.scrollTop += e.deltaY;
        if (scrollableDiv.scrollTop > 0 && scrollableDiv.scrollTop > temp)  {
          e.preventDefault()
        }
      });
    }

    if ($('#notice-bar-content').length > 0) {
      $('.sidebar-column').addClass('notice-bar-active')
    }
  }

  Filter.prototype.filterApply = function(){
    var checkedArr = []
    this.collection = $('input[name="filterCollection"]:checked').val()
    $('input[name="filterCollection"]:checked').each(function() {
       checkedArr.push($(this).val())
    })

    this.collections = checkedArr
    if (this.collections.length > 1) {
      this.collection = 'all-items'
    }
    this.heading = $('input[name="filterCollectionDesktop"]:checked').next().attr('data-heading')
    this.description = $('input[name="filterCollectionDesktop"]:checked').next().attr('data-description')
    this.loadCollection(this.collection, this.sort)
    this.mobileFilterSelectorToggle()
  }

  Filter.prototype.desktopFilterApply = function(){
    var checkedArr = []
    this.collection = $('input[name="filterCollectionDesktop"]:checked').val()
    $('input[name="filterCollectionDesktop"]:checked').each(function() {
       checkedArr.push($(this).val())
    })

    this.collections = checkedArr
    if (this.collections.length > 1) {
      this.collection = 'all-items'
    }

    this.heading = $('input[name="filterCollectionDesktop"]:checked').next().attr('data-heading')
    this.description = $('input[name="filterCollectionDesktop"]:checked').next().attr('data-description')
    this.loadCollection(this.collection, this.sort, this.collections)
  }

  Filter.prototype.displayStars = function () {
    $(document).find('.product-card__rating').each((i, el) => {
      const appKey = $(el).data('yotpo-appkey');
      const productId = $(el).data('product-id');
      if ($(el).find('.product-card__yotpo-stars').length > 0) {
        $('.product-card__yotpo-stars').remove();
      }
      $.get(`https://api-cdn.yotpo.com/products/${appKey}/${productId}/bottomline`).done(function (data) {
          const avg = Math.round(data.response.bottomline.average_score * 10) / 10;
          const totalReview = data.response.bottomline.total_reviews;
          $(el).find('.product-card__review-text').html(`(${totalReview})`);
          $(el).prepend(`<div class="product-card__yotpo-stars">${ReviewStar(avg)}</div>`);
          $(el).removeClass('d-none').addClass('d-flex');
      });
    });
  }

  Filter.prototype.loadCollection = function(collection = 'all-items', sort = 'best-selling', collections = []) {
    this.loadingState(true)
    var _this = this
    var shopDomain = this.domain
    console.log('sort', sort)
    var url = 'https://' + shopDomain + '/collections/' + collection + '?sort_by=' + sort
    console.log(url)
    $.ajax({
      url: url,
      success: function(resp) {
        _this.renderContent(resp, collection, sort, collections)
        _this.displayStars();
      }
    })
  }

  Filter.prototype.sortBy = function(sort){
    this.sort = sort
    this.heading = $('input[name="filterCollectionDesktop"]:checked').next().attr('data-heading') || $('.collection-unfiltered .collection-filtered__heading h2').text()
    this.description = $('input[name="filterCollectionDesktop"]:checked').next().attr('data-description') || $('.collection-unfiltered .collection-filtered__heading p').text()
    $('.collection-filter-selector li').removeClass('active')
    $('.collection-filter-selector li[data-sort="'+this.sort+'"]').addClass('active')
    $('.desktop-collection-sort li').removeClass('active')
    $('.desktop-collection-sort li[data-sort="'+this.sort+'"]').addClass('active')
    this.loadCollection(this.collection, this.sort)
    this.sortSelectorToggle()
    this.mobileSortSelectorToggle()
  }

  Filter.prototype.renderContent = function(resp, collection, sort, collections) {
    var html = $(resp);
    var items = $(html).find('.flex-prod-item .prod-item')

    var heading = this.heading
    var description = this.description
    var content_all = ''

    $.each(items, function(index, content){
      var rating = $(content).attr("rating")
      var product_id = $(content).attr("data-badge")
      var type = $(content).attr("data-product-type")
      var product_collections = $(content).attr("data-product-collections").split(',')
      if (type == 'HERO' || type == 'BUNDLE') {
        if (collection == 'all-items' && collections.length) {
          var cont = true
          $.each(collections, function(i, item) {
            if (product_collections.indexOf(item) != -1 && cont) {
              content_all += '<div class="prod-item" data-badge="'+product_id+'">' + $(content).html() + '</div>'
              cont = false
            }
          })
        } else {
          content_all += '<div class="prod-item" data-badge="'+product_id+'">' + $(content).html() + '</div>'
        }
      }
    })

    // $('.collection-filtered__heading h2').text(heading)
    // $('.collection-filtered__heading p').text(description)
    $('.collection-unfiltered').hide()
    $('.collection-filtered .flex-prod-item').html(content_all)
    $('.collection-filtered').show()
    $('.desktop-collection-sort').removeClass('active')

    $('.mobile-collection-filter__filter-selector span').text('Filter by (' + this.collections.length + ')')
    this.reloadReviews()
    this.loadingState(false)
    setTimeout(function() {
      roar.setBadge()

    });
  }

  Filter.prototype.sortSelectorToggle = function() {
    $('.desktop-collection-sort').toggleClass('active')
  }

  Filter.prototype.mobileSortSelectorToggle = function() {
    $('#mobile-collection-filter-selection').hide()
    $('#mobile-collection-sort-selection').toggle()
  }

  Filter.prototype.mobileFilterSelectorToggle = function() {
    $('#mobile-collection-sort-selection').hide()
    $('#mobile-collection-filter-selection').toggle()
  }

  Filter.prototype.clearAll = function() {
    $('.collection-unfiltered').show()
    $('.collection-filtered').hide()
    // var originalHeading = $('.collection-filtered__heading-mobile').attr('data-original-heading')
    // var originalDesc = $('.collection-filtered__heading-mobile').attr('data-original-desc')
    // $('.collection-filtered__heading-mobile').find('h2').text(originalHeading)
    // $('.collection-filtered__heading-mobile').find('p').text(originalDesc)
    $('input[name="filterCollection"]').prop('checked',false)
    $('input[name="filterCollectionDesktop"]').prop('checked',false)
    $('.collection-filter__submit').addClass('disabled')
    $('.collection-filter__clear').addClass('disabled')
  }

  Filter.prototype.loadingState = function(active) {
    if (active) {
      $('.collection-filter').addClass('loading')
    } else {
      $('.collection-filter').removeClass('loading')
    }
  }

  Filter.prototype.reloadReviews = function(){
    _this = this;
    if (typeof(Yotpo) == 'function') {
      var api = new Yotpo.API(yotpo);
      try {
        api.refreshWidgets();
      } catch (error) {
        console.log('refresh yotpo error', error);
      }
    } else {
      setTimeout(function(){
        if (typeof _this.reloadReviews == 'function') _this.reloadReviews();
      }, 1000);
    }
  }

  return Filter;
})();

$(document).ready(function(){
  smFilter = new Filter()
  smFilter.init()
})
